import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import moment from "dayjs";
import 'dayjs/locale/zh-cn'
import { Message } from "@hi/ui";
import { MessageBox } from "@hi/ui";
import { Loading } from "@hi/ui";
import programDynamicCapMock from "@/mock/program/programDynamicCap";
import programCapMock from "@/mock/program/programCap";
import pageParamcapMock from "@/mock/program/pageParamcap";
import templateListMock from "@/mock/program/templateList";
import oUtils from "@/utils/utils";
import constant from "@/utils/constant";
import i18n from "@/locale";
import Storage from "@/utils/storage";
import * as programApi from "@/services/program/index";
import oMaterialService from "@/services/program/materialService";
import { BASE } from "@/config/index";
import eventBus from '@/utils/eventBus';

class ProgramService {
  constructor() {
    this.oProgramDynamicCap = {
      //节目动态能力集(页面数量能力集、窗口宽高能力集+默认值+数量)
      normal: {},
      decode: {},
      touch: {},
      fold: {},
    };
    this.oProgramCap = {
      //节目能力参数
      aResolution: [], //分辨率
      // 节目类型（单面屏or双面屏）不能按照协议programType来分，需要按照节目数量单独有字段判断，因为实现完全不同。
      aProgramScreenTypes: [],
      aIntlligentResolution: [],
      oResolutionCap: {}, //支持的最大最小分辨率
      aShareProperty: [], //属性
      aApproveState: [], //审核状态
      oProgramValid: {}, //字符长度能力
      aCascadeSize: {}, //多屏规格
      aCascadeResolution: [], //多屏分辨率
      oCascadeResolutionCap: [], //多屏支持的最大最小分辨率
      aCollect: [],
    };
    this.oPageCap = {
      //页面能力集
      aPalyDurationMode: [], //播放时间类型
      oPageParamValid: {}, //校验信息
      oPageDefParam: {}, //页面默认参数
    };
    this.oTemplate = {}; //模板列表
    this.materialNameMap = {}; // 图片名称存储
    this.predefineColors = constant.PREDEFINE_COLORS; // 预定义颜色
    this.programContextInit = ""; // 节目上下文初始数据，用来判断是否发生变更
  }

  //获取节目动态能力集
  getProgramDynamicCap () {
    let oDefWinCap = {
      video: {}, //视频
      picture: {}, //图片
      audio: {}, //音频
      web: {}, //网页
      weather: {}, //天气
      clock: {}, //时钟
      localInput: {}, //视频输入
      realStream: {}, //视频直播
      call: {}, //叫号
      document: {}, //文档
      pdf: {}, //pdf
      ppt: {}, //ppt
      doc: {}, //doc
      excel: {}, //excel
      dynamicPic: {}, //弹图
      countdown: {}, //倒计时
      capturePic: {}, //抓图
      hyperlinkBtn: {}, //触屏-超链接按钮
      app: {}, //apk安装包
      zip: {}, // zip安装包
      character: {}, // 文字消息
      event: {}, //客流测温
      signIn: {}, //考勤
      conference: {}, // 会议签到
      dataSource: {}, //三方数据
      chart: {},
      RSS: {},
      signalSource: {},
    };

    // 窗口默认值
    _.each(oDefWinCap, (value, index) => {
      Object.assign(value, {
        iMinWidth: 120, //最小宽度
        iMinHeight: 120, //最小高度
        iDefWidth: 800, //默认宽度
        iDefHeight: 200, //默认高度
        iMaxWinNum: 1, //最多窗口数
      });
    });

    //循环初始化节目能力集
    _.each(this.oProgramDynamicCap, (value1, index1) => {
      _.extend(value1, {
        iMaxWndNum: 64,
        iMaxPageNum: 16,
        iMaxPlayItemsNum: 64,
        oPageCap: {
          horizontal: {},
          vertical: {},
          "3840*2160": {}, //暂不支持
          "2160*3840": {}, //暂不支持
        },
      });
      //循环插入窗口能力默认值
      _.each(value1.oPageCap, (value2) => {
        _.extend(value2, _.cloneDeep(oDefWinCap));
      });
    });
    // return oWebSdk.WSDK_GetDeviceConfig("programDynamicCap", null, {
    // success: (resJson) => {
    const resJson = programDynamicCapMock;
    let ProgramCapList = resJson.ProgramDynamicCap.ProgramCapList;
    _.each(ProgramCapList, (progaram) => {
      let oProgramCapInfo = progaram.ProgramCap;
      let oProgramType = this.oProgramDynamicCap[oProgramCapInfo.programType];

      oProgramType.iMaxWndNum = +oProgramCapInfo.maxWinNum;
      oProgramType.iMaxPageNum = +oProgramCapInfo.maxPageNum;
      oProgramType.iMaxPlayItemsNum = +oProgramCapInfo.maxMaterialNum;

      //WinCap暂时只支持1920*1080和1080*1920
      _.each(oProgramCapInfo.WinCapList, (page) => {
        let oWinCap = page.WinCap;
        let iWindowBaseX = +oWinCap.BaseRes.resWidth;
        let iWindowBaseY = +oWinCap.BaseRes.resHeight;
        let szResolution = iWindowBaseX + "*" + iWindowBaseY; //分辨率
        let oPageSizeCap = {};
        if (szResolution === "1920*1080") {
          oPageSizeCap = oProgramType.oPageCap["horizontal"];
        } else if (szResolution === "1080*1920") {
          oPageSizeCap = oProgramType.oPageCap["vertical"];
        } else {
          oPageSizeCap = oProgramType.oPageCap[szResolution]; //页面分辨率对应的各个窗口能力
        }
        _.each(oWinCap.WinSizeList, (window) => {
          let oWinSize = window.WinSize;
          let szType = oWinSize.WinMaterialInfo.materialType;
          let szMaterialType =
            "static" === szType
              ? oWinSize.WinMaterialInfo.staticMaterialType
              : oWinSize.WinMaterialInfo[szType + "Type"];
          let oWindowCap = oPageSizeCap[szMaterialType];
          if (oWindowCap) {
            oWindowCap.iMinWidth = oWinSize.width["@min"]; //最小宽度
            oWindowCap.iMinHeight = oWinSize.height["@min"]; //最小高度
            oWindowCap.iDefWidth = oWinSize.DefaultSize.defaultWidth; //默认宽度
            oWindowCap.iDefHeight = oWinSize.DefaultSize.defaultHeight; //默认高度
            oWindowCap.iMaxWinNum = oWinSize.maxWinNum; //最多窗口数
          }
        });
      });
    });
    // },
    // });
  }

  //获取节目参数能力集
  getProgramCap () {
    let oProgramCap = this.oProgramCap;

    // return oWebSdk.WSDK_GetDeviceConfig("showCap", null, {
    //   success: resJson => {
    const resJson = programCapMock;
    const Program = resJson.Program;
    const Resolution = Program.Resolution;
    const CascadeResolution = Program.CascadeResolution;
    const CascadeSize = Program.CascadeSize;
    //分辨率
    let aResolution = Resolution.resolutionName["@opt"].split(",");
    let aProgramType = Program.programType["@opt"].split(",");
    let aCascadeResolution = CascadeResolution
      ? CascadeResolution.resolutionName["@opt"].split(",")
      : [];
    oProgramCap.aResolution.length = 0;
    oProgramCap.aIntlligentResolution.length = 0;
    oProgramCap.aCascadeResolution.length = 0;
    for (let resolution of aResolution) {
      if ("1920*1080" === resolution) {
        //横屏
        oProgramCap.aResolution.push({
          value: resolution,
          name: i18n.t("landscape"),
        });
        oProgramCap.aIntlligentResolution.push({
          value: resolution,
          name: i18n.t("landscape"),
        });
      }
      if ("1080*1920" === resolution) {
        //竖屏
        oProgramCap.aResolution.push({
          value: resolution,
          name: i18n.t("portrait"),
        });
        oProgramCap.aIntlligentResolution.push({
          value: resolution,
          name: i18n.t("portrait"),
        });
      }
      if ("selfDefine" === resolution) {
        //自定义
        oProgramCap.aResolution.push({
          value: resolution,
          name: i18n.t("custom"),
        });
      }
      oProgramCap.aProgramScreenTypes.length = 0;
      // 单面屏默认是一定有的
      oProgramCap.aProgramScreenTypes.push({
        value: "single",
        name: i18n.t("signle_program"),
      });
      // 类型中包括doubleSide说明支持双面屏，屏幕类型增加双面屏类型
      if (aProgramType.includes("doubleSide")) {
        oProgramCap.aProgramScreenTypes.push({
          value: "double",
          name: i18n.t("double_program"),
        });
      }
      // TODO 调试完后删除，因为现在能力协议没改
      // oProgramCap.aProgramScreenTypes.push({
      //   value: "double",
      //   name: i18n.t("double_program")
      // });
    }
    for (let resolution of aCascadeResolution) {
      if ("1920*1080" === resolution) {
        //横屏
        oProgramCap.aCascadeResolution.push({
          value: resolution,
          name: i18n.t("landscape"),
        });
      }
      if ("1080*1920" === resolution) {
        //竖屏
        oProgramCap.aCascadeResolution.push({
          value: resolution,
          name: i18n.t("portrait"),
        });
      }
      if ("selfDefine" === resolution) {
        //自定义
        oProgramCap.aCascadeResolution.push({
          value: resolution,
          name: i18n.t("custom"),
        });
      }
    }
    //最大最小分辨率
    oProgramCap.oResolutionCap = {
      iMaxResolutinX: Resolution.imageWidth["@max"],
      iMinResolutinX: Resolution.imageWidth["@min"],
      iMaxResolutinY: Resolution.imageHeight["@max"],
      iMinResolutinY: Resolution.imageHeight["@min"],
      iMin4KResolution: Resolution["4KResolution"]
        ? Resolution["4KResolution"]["@min"]
        : 2160,
      iMax4KResolution: Resolution["4KResolution"]
        ? Resolution["4KResolution"]["@max"]
        : 3840,
    };
    //最大最小分辨率
    if (CascadeResolution) {
      oProgramCap.oCascadeResolutionCap = {
        iMaxResolutinX: CascadeResolution.imageWidth["@max"],
        iMinResolutinX: CascadeResolution.imageWidth["@min"],
        iMaxResolutinY: CascadeResolution.imageHeight["@max"],
        iMinResolutinY: CascadeResolution.imageHeight["@min"],
        iMin4KResolution: CascadeResolution["4KResolution"]
          ? CascadeResolution["4KResolution"]["@min"]
          : 2160,
        iMax4KResolution: CascadeResolution["4KResolution"]
          ? CascadeResolution["4KResolution"]["@max"]
          : 3840,
      };
    }

    //多屏规格
    oProgramCap.aCascadeSize = {
      rowMin: CascadeSize.row["@min"],
      rowMax: CascadeSize.row["@max"],
      columnMin: CascadeSize.column["@min"],
      columnMax: CascadeSize.column["@max"],
      isSupportMultiRowAndColumn: CascadeSize.isSupportMultiRowAndColumn,
    };
    //属性
    let aShareProperty = Program.shareProperty["@opt"].split(",");
    oProgramCap.aShareProperty = oUtils.getArray(aShareProperty);
    //审核状态
    oProgramCap.aApproveState = oUtils.getArray(
      Program.approveState["@opt"].split(",")
    );
    oProgramCap.oProgramValid = {
      oProgramName: {
        iMaxLength: Program.programName["@max"],
        iMinLength: 1,
      },
      oProgramRemarks: {
        iMaxLength: Program.programRemarks["@max"],
      },
    };

    const Collecti18nMap = new Map([
      ["all", "searchByAll"],
      ["not collected", "not_collected"],
    ]);
    const collectArr = Array.from(
      new Set(["all", ...Program.collectProperty["@opt"].split(",")])
    );
    // 收藏属性
    oProgramCap.aCollect = collectArr.map((collect, index) => {
      return {
        id: index + 1,
        value: collect,
        view: i18n.t(`${Collecti18nMap.get(collect) || collect}`),
      };
    });
    //   }
    // });
  }

  //获取页面能力
  getPageCap (deviceId = "") {
    let oPageCap = this.oPageCap;
    // return oWebSdk.WSDK_GetDeviceConfig("pageParamcap", {id: deviceId}, {
    //   success: resJson => {
    const resJson = pageParamcapMock;
    const PageBasicInfo = resJson.Page.PageBasicInfo;
    const WindowsList = resJson.Page.WindowsList;
    const LayoutList = resJson.Page.TemplateLayoutWindowList;
    oPageCap.oPageParamValid = {
      oPageName: {
        //页面名称校验
        iMinLength: 1,
        iMaxLength: PageBasicInfo.pageName["@max"],
      },
      oPagePlayDuration: {
        //播放时间校验
        iMinLength: PageBasicInfo.playDuration["@min"],
        iMaxLength: PageBasicInfo.playDuration["@max"],
      },
      oPagePlayCount: {
        iMinLength: PageBasicInfo.playCount["@min"],
        iMaxLength: PageBasicInfo.playCount["@max"],
      },
    };
    oPageCap.oPageDefParam = {
      iDefPagePlayDuration: +PageBasicInfo.playDuration["@default"], //不知道为什么json协议这个默认值传了字符串类型
    };
    //播放时间类型
    let aPalyDurationMode = PageBasicInfo.playDurationMode["@opt"].split(",");
    oPageCap.aPalyDurationMode = oUtils.getArray(aPalyDurationMode);
    //页面切换效果
    let aSwitchEffect = (PageBasicInfo?.switchEffect &&
      PageBasicInfo.switchEffect["@opt"]
        ?.split(",")
        ?.map((item) => item.replace(" ", ""))) || ["none", "gradient"];
    oPageCap.aSwitchEffect = oUtils.getArray(aSwitchEffect, "program_effect_");
    //播放特效
    let aAnimationBlockType = (PageBasicInfo?.animationBlockType &&
      PageBasicInfo.animationBlockType["@opt"]
        ?.split(",")
        ?.map((item) => item.replace(" ", ""))) || [
        "ball",
        "leaf",
        "snow",
        "pater",
        "null",
      ];
    oPageCap.aAnimationBlockType = oUtils.getArray(
      aAnimationBlockType,
      "program_anime_"
    );
    /* TODO 原xml数组带属性时，转json格式不规范，属性会塞进数组里，所以从第二项开始取 */
    if (WindowsList.length > 1) {
      let windows = WindowsList[1].Windows;
      if (windows.PlayItemList.length > 1) {
        let playItemList = windows.PlayItemList;
        // 窗口素材大小
        oPageCap.iWindowMaterialSize = playItemList[0]["@size"];

        let playItem = playItemList[1].PlayItem;
        //素材切换效果
        oPageCap.aPlayItemSwitchEffect = oUtils.getArray(
          playItem.switchEffect["@opt"].split(",")
        );
        //文档切换效果
        oPageCap.aDocumentScrollDeriction = oUtils.getArray(
          playItem.CharactersEffect.scrollDirection["@opt"].split(","),
          "program_"
        );
        //窗口滚动速度
        let iMinScrollSpeed = playItem.CharactersEffect.scrollSpeed["@min"];
        let iMaxScrollSpeed = playItem.CharactersEffect.scrollSpeed["@max"];
        oPageCap.aDocumentScrollSpeed = [];
        for (let i = iMinScrollSpeed; i <= iMaxScrollSpeed; i++) {
          oPageCap.aDocumentScrollSpeed.push(i);
        }
        //  是否启用文字删除线
        oPageCap.strikethroughEnabled =
          playItem.CharactersEffect?.strikethroughEnabled || false;
        //  是否支持文字描边
        oPageCap.fontBorderEnabled =
          playItem.CharactersEffect?.fontBorderEnabled || false;
        //  是否支持文字渐变
        oPageCap.fontGradientEnabled =
          playItem.CharactersEffect?.fontGradientEnabled || false;
        //  是否支持文字阴影
        oPageCap.fontShadowEnabled =
          playItem.CharactersEffect?.fontShadowEnabled || false;
        //视频直播最大通道数
        oPageCap.iMaxInputChannel = playItem.inputChannel["@max"];

        // 微动效果的默认参数
        oPageCap.animationEffect = {
          repetTime: playItem.animationEffect?.repetTime ?? -1,
          durationTime: playItem.animationEffect?.durationTime ?? 1500,
          delayTime: playItem.animationEffect?.delayTime ?? 1000,
        };
        oPageCap.animationEffectSupportType = [-1, 2, 3, 9]; // 目前支持配置的微动效
      }
      //倒计时单位
      let aCountdownTimeUnit = windows.Countdown.timeUnit["@opt"].split(",");
      oPageCap.aCountdownTimeUnit = oUtils.getArray(aCountdownTimeUnit);
      //时钟样式
      let aClockStyleType =
        windows.ClockParam.ClockIcon.type["@opt"].split(",");
      oPageCap.aClockStyleType = oUtils.getArray(aClockStyleType);
      windows.Call = windows.Call || {};
      //叫号样式列表
      let aCallStyleType =
        windows.Call.tableType && windows.Call.tableType["@opt"].split(",");
      oPageCap.aCallStyleType = oUtils.getArray(aCallStyleType);
      //表格方向
      let aTableDirection =
        windows.Call.tableDirection &&
        windows.Call.tableDirection["@opt"].split(",");
      oPageCap.aTableDirection = oUtils.getArray(aTableDirection);
      //三方数据表格 取叫号的能力集
      oPageCap.aDatasource = {
        aSourceTableDirection: oUtils.getArray(aTableDirection),
        atableRow: { ...windows.Call.tableRow, "@def": 2 },
        atableColumn: { ...windows.Call.tableColumn, "@def": 3 },
        aSourcePlayMode:
          (windows.Call.playType &&
            windows.Call.playType["@opt"].split(",").map((item) => {
              return { name: i18n.t("program_" + item), value: item };
            })) ||
          [],
        afontSize:
          windows.Call.ItemStyleList &&
          windows.Call.ItemStyleList[1].ItemStyle.fontSize,
        afontColor: oUtils.transformRgb(
          windows.Call.ItemStyleList &&
          windows.Call.ItemStyleList[1].ItemStyle.FontColor["RGB"]
        ),
        aBackColor: oUtils.transformRgb(
          16777215 || windows.Call.ItemStyleList[1].ItemStyle.BackColor["RGB"]
        ),
        emptyRate:
          windows.Call.ItemStyleList &&
          windows.Call.ItemStyleList[1].ItemStyle.width,
        alignType: { "@def": "left" },
        verticaAlignType: { "@def": "top" },
        aSourceTableDirectionDef: "horizontal",
      };
      //对齐
      let aAlignType = windows.Call.alignType["@opt"].split(",");
      oPageCap.aAlignType = [];
      for (let alignType of aAlignType) {
        let alignName =
          alignType === "middle" ? alignType : alignType + "Align";
        oPageCap.aAlignType.push({
          value: alignType,
          name: i18n.t(alignName),
        });
      }
      //  size取文字窗口宽高的最小值
      oPageCap.aCharacterBorder = {
        aBorderColor: "#000000",
        aBorderSize: { "@def": 0, "@min": 0, "@max": 60 },
        aBorderStyle: {
          "@def": "solid",
          "@val": ["solid", "dashed", "pointsDotted"],
        },
      };
    }

    //布局模板能力集
    if (LayoutList?.length > 1) {
      oPageCap.LayoutCap = { ...LayoutList[1].TemplateLayoutWindow.Position };
    }

    //表格刷新方向
    oPageCap.aRefreshDirectionX = [
      {
        value: "upTodown",
        name: i18n.t("upTodown"),
      },
      {
        value: "downToup",
        name: i18n.t("downToup"),
      },
    ];
    oPageCap.aRefreshDirectionY = [
      {
        value: "leftToright",
        name: i18n.t("leftToright"),
      },
      {
        value: "rightToleft",
        name: i18n.t("rightToleft"),
      },
    ];

    oPageCap.aWeatherTimeUnit = [
      {
        value: "celsius",
        name: i18n.t("program_celsius"),
      },
      {
        value: "fahrenheit",
        name: i18n.t("program_fahrenheit"),
      },
    ];

    oPageCap.aWeatherdateShowType = new Array(10)
      .fill("")
      .map((item, index) => {
        return {
          value: index + 1,
          name: i18n.t(`program_dateShowType_${index + 1}`),
        };
      });
    oPageCap.aWeatherUpdateInterval = [
      15,
      30,
      60,
      3 * 60,
      6 * 60,
      12 * 60,
      24 * 60,
    ].map((item) => {
      return {
        value: item,
        name:
          item >= 60
            ? i18n.t(`program_hours`).replace("%d", Math.round(item / 60))
            : i18n.t(`program_minutes`).replace("%d", item),
      };
    });

    // console.log(this.oPageCap, "this.oPageCap");
    //   }
    // });
  }

  //获取模板
  async getTemplates (options, vm) {
    let oTemplate = (this.oTemplate = {
      normal: {
        vertical: {
          normal: [],
          retail: [],
          financial: [],
          building: [],
          market: [],
          restaurant: [],
          traffic: [],
          medical: [],
          culture: [],
        },
        horizontal: {
          normal: [],
          retail: [],
          financial: [],
          building: [],
          market: [],
          restaurant: [],
          traffic: [],
          medical: [],
          culture: [],
        },
      },
      peopleConting: {
        //客流测温
        vertical: {
          peopleConting: [],
          peopleContingTemperature: [],
          temperature: [],
        },
        horizontal: {
          peopleConting: [],
          peopleContingTemperature: [],
          temperature: [],
        },
      },
      signIn: {
        //考勤
        vertical: {
          signIn: [],
          signInTemperature: [],
        },
        horizontal: {
          signIn: [],
          signInTemperature: [],
        },
      },
      conference: {
        // 会议签到
        vertical: {
          conference: [],
        },
        horizontal: {
          conference: [],
        },
      },
      clock: [],
      weather: [],
      countdown: [],
      RSS: [],
      call: [],
      emergencyProgram: {
        // 紧急避险
        vertical: {
          emergencyProgram: [
            {
              id: 0,
              name: i18n.t("nonePage"),
              playDurationMode: "auto",
              options: {},
            },
          ],
        },
        horizontal: {
          emergencyProgram: [
            {
              id: 0,
              name: i18n.t("nonePage"),
              playDurationMode: "auto",
              options: {},
            },
          ],
        },
      },
      totalNum: 0,
    });
    let arrayClockType = ["ClockIcon", "YmdParam", "HmsParam", "WeekParam"];
    let arrayWeatherType = [
      "City",
      "UpdateTime",
      "WeatherIcon",
      "Date",
      "Temperature",
      "WeatherContent",
      "Wind",
      "AirQuality",
      "Humidity",
    ];
    let arrayRssType = ["icon", "title", "date", "content"];
    let language = Storage.get(Storage.NAME.LANGUAGE)
      ? Storage.get(Storage.NAME.LANGUAGE)
      : "en";
    // let oParams = {
    //   TemplateSearchDescription: {
    //     searchID: uuidv4(),
    //     screenType: "all",
    //     templateType: "all",
    //     maxResults: 200,
    //     searchResultsPosition: 0,
    //     collectProperty: "all", //模板默认查询所有模板
    //     selfDefineResoluionSeachFlag: false,
    //     language: language,
    //     Resolution: {},
    //   },
    // };
    // if (options) {
    //   oParams.TemplateSearchDescription.maxResults = options.maxResults || 200;
    //   oParams.TemplateSearchDescription.searchResultsPosition =
    //     options.searchResultsPosition || 0;
    // }
    // if (options) {
    //   oParams.TemplateSearchDescription.selfDefineResoluionSeachFlag =
    //     options.resolution === "custom";
    //   // options.resolution === "selfDefine";
    //   oParams.TemplateSearchDescription.Resolution.imageHeight =
    //     options.programHeight;
    //   oParams.TemplateSearchDescription.Resolution.imageWidth =
    //     options.programWidth;
    // }
    // if (options && options.screenType) {
    //   //屏幕类型查找 vertical,horizontal,all
    //   oParams.TemplateSearchDescription.screenType = options.screenType;
    // }
    // if (options && options.templateType) {
    //   //模板类型查找 page,callWin,weatherWin,clockWin,countdownWin,all
    //   oParams.TemplateSearchDescription.templateType = options.templateType;
    //   // 节目模板支持翻页搜索
    //   if (
    //     options.templateType === "page" &&
    //     options.maxResults !== undefined &&
    //     options.searchResultsPosition !== undefined
    //   ) {
    //     oParams.TemplateSearchDescription.maxResults = options.maxResults;
    //     oParams.TemplateSearchDescription.searchResultsPosition =
    //       options.searchResultsPosition;
    //   }
    // }
    // if (options && options.ApplicationTypeList) {
    //   //应用类型查找 normal-普通 signIn-考勤 peopleConting--客流等
    //   oParams.TemplateSearchDescription.ApplicationTypeList =
    //     options.ApplicationTypeList;
    // }
    // if (options && options.collectProperty) {
    //   //应用类型查找 normal-普通 signIn-考勤 peopleConting--客流等
    //   oParams.TemplateSearchDescription.collectProperty =
    //     options.collectProperty;
    // }
    // if (options?.keyword) {
    //   // 模板名称检索
    //   oParams.TemplateSearchDescription.keyword = options.keyword;
    // }
    // let resJson = await oWebSdk.WSDK_GetDeviceConfig("templateSearch", null, {
    //   data: oParams,
    //   showLoading: options ? options.showLoading : false,
    // });

    // let resJson = templateListMock;

    let resJson = await programApi.listProgramTemplate(options);

    // 如果是考勤则获取自定义属性
    // try {
    //   if (
    //     ["signIn", "signInTemperature"].includes(
    //       options?.ApplicationTypeList?.[0]?.applicationType
    //     )
    //   ) {
    //     this.aCustomField = await this.getCustomFields();
    //   }
    // } catch (error) {
    //   console.error(error);
    // }
    let templateItems = resJson?.data || [];
    // let templateItems = resJson?.Data?.TemplateList;
    // oTemplate.totalNum = resJson?.Data.totalMatches;
    for (let template of templateItems) {
      let templateInfo = {
        ...template,
        ...JSON.parse(template.templateContent),
      };
      // let templateInfo = template.Template;
      let szType = templateInfo.templateType;
      let applicationType = templateInfo.applicationType;
      let screenType = templateInfo.resolutionType;
      // let screenType = templateInfo.screenType;
      let clockNames = this.getSubWindowName("clock");
      let weatherNames = this.getSubWindowName("weather");
      let rssNames = this.getSubWindowName("RSS");
      let oTemp = {};

      oTemp.id = templateInfo.templateId;
      // oTemp.id = templateInfo.id;
      // oTemp.name = templateInfo.templateName; //模板名称(语言解析)
      oTemp.name = i18n.t(templateInfo.templateName); //模板名称(语言解析)
      // oTemp.collectProperty = templateInfo.collectProperty; //收藏与否
      // if (templateInfo.useLanguage) { // 是否采用多语言
      //   oTemp.name = i18n.t('program_' + oTemp.name);
      // } else {
      //   if (oTemp.name.indexOf("_") !== -1) {
      //     let nameArray = oTemp.name.split("_");
      //     const nameMap = {
      //       "Layout": "program_layout",
      //       "rss": "program_rss"
      //     };
      //     oTemp.name = i18n.t(nameMap[nameArray[0]] || nameArray[0]) + nameArray[1];
      //   } else {
      //     oTemp.name = i18n.t(oTemp.name);
      //   }
      // }
      oTemp.screenType = screenType;
      oTemp.applicationType = applicationType;
      oTemp.thumbnail = templateInfo.templateThumbnail;
      oTemp.materialThumbnailUrl = this.getTemplateUrl(oTemp.thumbnail);
      if (szType !== "page") {
        oTemp.x = templateInfo.Position.positionX;
        oTemp.y = templateInfo.Position.positionY;
        oTemp.width = templateInfo.Position.width;
        oTemp.height = templateInfo.Position.height;
      }
      switch (szType) {
        case "page":
          var TemplatePageBasicInfo =
            templateInfo.PageTemplate.TemplatePageBasicInfo;
          oTemp.windowList = await this.getWindows(
            templateInfo.PageTemplate.TemplateWindowsList,
            screenType,
            templateInfo,
            // template,
            vm,
            templateInfo.templateId
            // templateInfo.id
          );
          //服务端说布局模板的背景颜色不应该根据赋值，默认白色
          if (applicationType === "layout") {
            TemplatePageBasicInfo.BackgroundColor.RGB = 16777215;
            TemplatePageBasicInfo.playDurationMode = "auto"; //同样的问题
          }
          oTemp.backgroundColor = oUtils.transformRgb(
            TemplatePageBasicInfo.BackgroundColor.RGB || 0
          );
          oTemp.playDurationMode = TemplatePageBasicInfo.playDurationMode; //播放时间模式
          oTemp.backgroundPic = TemplatePageBasicInfo.backgroundPic; //背景图片
          oTemp.backgroundPicName = "page_mask";
          if (oTemp.playDurationMode === "selfDefine") {
            oTemp.playDuration = TemplatePageBasicInfo.playDuration; //播放时间
          } else if (oTemp.playDurationMode === "auto") {
            oTemp.playCount = TemplatePageBasicInfo.playCount; //播放次数
          } else if (oTemp.playDurationMode === "loop") {
            oTemp.playDurationMode = "programLoop";
          }
          if (
            applicationType === "peopleConting" ||
            applicationType === "peopleContingTemperature" ||
            applicationType === "temperature"
          ) {
            oTemplate.peopleConting[screenType][applicationType].push(oTemp);
          } else if (
            applicationType === "signIn" ||
            applicationType === "signInTemperature"
          ) {
            oTemp.signInCfg = {
              voiceBroadcastEnable:
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast.enabled, //语音播报
              broadcastSpeed:
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast.broadcastSpeed, //播报语速
              inLibVoice:
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast.inLibVoice, //在库人员语音播报内容
              outLibVoice:
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast.outLibVoice, //未知人员语音播报内容
              welcomeWordEnable:
                TemplatePageBasicInfo.SignInCfg.WelcomeWord.enabled, //是否启用欢迎词
              inLibWord: TemplatePageBasicInfo.SignInCfg.WelcomeWord.inLibWord, //在库人员欢迎词内容
              outLibWord:
                TemplatePageBasicInfo.SignInCfg.WelcomeWord.outLibWord, //未知人员欢迎词内容
              // templateThreshold: TemplatePageBasicInfo.SignInCfg.TemperatureDetection.threshold, //正常温度值
              bSupportTemplateThreshold:
                !!TemplatePageBasicInfo.SignInCfg.TemperatureDetection, //是否支持温度
            };
            if (applicationType === "signInTemperature") {
              // 体温异常在库人员和未知人员语音提示
              oTemp.signInCfg.inLibAbnormalTemperatureVoice =
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast
                  .inLibAbnormalTemperatureVoice
                  ? TemplatePageBasicInfo.SignInCfg.VoiceBroadcast
                    .inLibAbnormalTemperatureVoice
                  : `*${i18n.t("abnormal_temperature_format")}`;
              oTemp.signInCfg.outLibAbnormalTemperatureVoice =
                TemplatePageBasicInfo.SignInCfg.VoiceBroadcast
                  .outLibAbnormalTemperatureVoice
                  ? TemplatePageBasicInfo.SignInCfg.VoiceBroadcast
                    .inLibAbnormalTemperatureVoice
                  : `${i18n.t("abnormal_temperature_format")}`;
            }
            oTemp.signInCfg.templateThreshold = oTemp.signInCfg
              .bSupportTemplateThreshold
              ? TemplatePageBasicInfo.SignInCfg.TemperatureDetection.threshold
              : "";
            oTemplate.signIn[screenType][applicationType].push(oTemp);
          } else if (applicationType === "conference") {
            // TODO，非空能力集，不让报错
            oTemp.signInCfg = {};
            oTemplate.conference[screenType][applicationType].push(oTemp);
          } else if (applicationType === "layout") {
            oTemp.layoutWindowList =
              templateInfo?.PageTemplate?.TemplateLayoutWindowList || [];
            //布局模板和通用模板中一起展示
            oTemplate.normal[screenType]["normal"].push(oTemp);
          } else if (applicationType === "emergencyProgram") {
            // 紧急避险节目
            //布局模板和通用模板中一起展示
            oTemplate.emergencyProgram[screenType][applicationType].push(oTemp);
          } else {
            oTemplate.normal[screenType][applicationType].push(oTemp);
          }
          break;
        case "clockWin":
          oTemp.subWindows = [];
          oTemp.subWindows.backgroundPic =
            templateInfo.ClockParam.backPicId || "";
          for (let k = 0; k < 4; k++) {
            let oClockSubParam = templateInfo.ClockParam[arrayClockType[k]];
            let subWindow = {
              enable: oClockSubParam.enabled,
              x: oClockSubParam.Position.positionX,
              y: oClockSubParam.Position.positionY,
              width: oClockSubParam.Position.width,
              height: oClockSubParam.Position.height,
              content: clockNames[k].content,
              name: clockNames[k].name,
            };
            if (k === 0) {
              subWindow.clockType = oClockSubParam.type;
            } else {
              let fontSize = oClockSubParam.fontSize;
              subWindow.fontSize = this.transformFontSize(
                fontSize,
                oTemp.height,
                oTemp.screenType
              );
              subWindow.fontColor = oUtils.transformRgb(
                oClockSubParam.FontColor.RGB || 0
              );
            }
            oTemp.subWindows.push(subWindow);
          }
          oTemplate.clock.push(oTemp);
          break;
        case "weatherWin":
          // 2.1 新增openweather服务商
          //   .map(item => {
          //     return {
          //         "Position": {
          //        "positionX": item[0] + "",
          //        "positionY": parseInt(item[1] * 1920 / 1080) + "",
          //        "height": parseInt(item[2] * 1920 / 1080) + "",
          //        "width": item[3] + ""
          //     },
          //     "fontSize": parseInt(1080 * 100 * 640 / (item[4] * 1920)),
          //     "FontColor": {
          //       "RGB": parseInt(item[5], 16)
          //     }
          //     }
          // })
          if (templateInfo.WeatherParam.weatherShowType) {
            oTemp.weatherShowType = templateInfo.WeatherParam.weatherShowType;
            oTemp.backgroundColor = oUtils.transformRgb(
              templateInfo.WeatherParam.WeatherDetail.BackColor.RGB
            );
            oTemp.backTransparent = Math.ceil(
              100 -
              (templateInfo.WeatherParam.WeatherDetail.backTransparent /
                255) *
              100
            ); // 背景透明度
            oTemp.tempUnit = templateInfo.WeatherParam.WeatherDetail.tempUnit;
            oTemp.dateShowType =
              templateInfo.WeatherParam.WeatherDetail.dateShowType;
            oTemp.updateInterval =
              templateInfo.WeatherParam.WeatherDetail.updateInterval;
            oTemp.subWindows = [];
            oTemp.subWindows.backgroundPic =
              templateInfo.WeatherParam.backPicId || "";

            if (
              templateInfo.WeatherParam?.WeatherDetail?.weatherDateList?.[0]
                ?.weatherparamList?.length
            ) {
              for (
                let i = 0;
                i <
                templateInfo.WeatherParam.WeatherDetail.weatherDateList.length;
                i++
              ) {
                const date =
                  templateInfo.WeatherParam.WeatherDetail.weatherDateList[i];
                for (let j = 0; j < date.weatherparamList.length; j++) {
                  const oWeatherSubParam = date.weatherparamList[j];
                  const language =
                    // Storage.get(Storage.NAME.LANGUAGE) === "zh_CN"
                    Storage.get(Storage.NAME.LANGUAGE) === "zh"
                      ? "zh-cn"
                      : "en";
                  const contentMap = {
                    datetoday0: moment(new Date()).format("YYYY-MM-DD"),
                    currentTemperature: "xx℃",
                    lowestTemperature: "xx℃",
                    highestTemperature: "xx℃",
                    wind: i18n.t("program_wind").replace("%s", "xx"),
                    humidity: i18n.t("program_humidity").replace("%s", "xx"),
                    datefiveDays0: moment(new Date()).format("YYYY-MM-DD"),
                    datefiveDays1: moment(new Date())
                      .add(1, "day")
                      .locale(language)
                      .format("dddd"),
                    datefiveDays2: moment(new Date())
                      .add(2, "day")
                      .locale(language)
                      .format("dddd"),
                    datefiveDays3: moment(new Date())
                      .add(3, "day")
                      .locale(language)
                      .format("dddd"),
                    datefiveDays4: moment(new Date())
                      .add(4, "day")
                      .locale(language)
                      .format("dddd"),
                    updateInterval: i18n
                      .t("program_hours")
                      .replace("%d", oTemp.updateInterval),
                    source: "x".repeat(25),
                  };
                  oTemp.subWindows.push({
                    enable:
                      (typeof oWeatherSubParam.enable !== "undefined" &&
                        oWeatherSubParam.enable) ||
                      (oWeatherSubParam.paramType !== "city" &&
                        oWeatherSubParam.paramType !== "cityIcon"),
                    moduleType: i,
                    x: oWeatherSubParam.Position.positionX,
                    y: oWeatherSubParam.Position.positionY,
                    width: oWeatherSubParam.Position.width,
                    height: oWeatherSubParam.Position.height,
                    content:
                      contentMap[
                      oWeatherSubParam.paramType +
                      (oWeatherSubParam.paramType === "date"
                        ? oTemp.weatherShowType + i
                        : "")
                      ] || "xxxxxx",
                    type: oWeatherSubParam.paramType,
                    fontSize: this.transformFontSize(
                      oWeatherSubParam.fontSize,
                      oTemp.height,
                      oTemp.screenType
                    ),
                    fontColor: oUtils.transformRgb(
                      oWeatherSubParam.FontColor.RGB || 0
                    ),
                    weatherIcon: oWeatherSubParam.paramType === "weatherIcon",
                  });
                }
              }
            }

            oTemplate.weather.push(oTemp);
          } else {
            oTemp.subWindows = [];
            oTemp.subWindows.backgroundPic =
              templateInfo.WeatherParam.backPicId;
            for (let k = 0; k < 9; k++) {
              let oWeatherSubParam =
                templateInfo.WeatherParam[arrayWeatherType[k]];
              let subWindow = {
                enable: oWeatherSubParam.enabled,
                x: oWeatherSubParam.Position.positionX,
                y: oWeatherSubParam.Position.positionY,
                width: oWeatherSubParam.Position.width,
                height: oWeatherSubParam.Position.height,
                content: weatherNames[k].content,
                name: weatherNames[k].name,
              };
              if (k === 0) {
                subWindow.cityId = oWeatherSubParam.cityId || -1;
                subWindow.cityName = oWeatherSubParam.cityName;
                subWindow.cityIdPath = oWeatherSubParam.cityIdPath;
              } else if (k === 1) {
                subWindow.interval = oWeatherSubParam.updateInterval;
                // subWindow.content = i18n.t("updateTime").replace("%s", subWindow.interval);
                // subWindow.name = i18n.t("updateTime").replace("%s", subWindow.interval);
                subWindow.content = i18n
                  .t("update_interval")
                  .replace("%s", subWindow.interval);
                // subWindow.name = i18n.t("update_interval").replace("%s", subWindow.interval);
              } else if (k === 2) {
                subWindow.weatherIcon = true; //是否显示天气图标
              }
              if (k !== 2) {
                let fontSize = oWeatherSubParam.fontSize;
                subWindow.fontSize = this.transformFontSize(
                  fontSize,
                  oTemp.height,
                  oTemp.screenType
                );
                subWindow.fontColor = oUtils.transformRgb(
                  oWeatherSubParam.FontColor.RGB || 0
                );
              }
              oTemp.subWindows.push(subWindow);
            }
            oTemplate.weather.push(oTemp);
          }

          break;
        case "countdownWin":
          oTemp.subWindows = [];
          // backgroundPic应该是模板属性吧，为什么放在subWindows上？更改之前一贯实现
          // oTemp.subWindows.backgroundPic = templateInfo.Countdown.backPicId;
          oTemp.backgroundPic = templateInfo.Countdown.backPicId;
          oTemp.template = templateInfo.Countdown.template; //属于哪种模板
          oTemp.timeUnit = templateInfo.Countdown.timeUnit;
          oTemp.timeUnitEnabled = templateInfo.Countdown.timeUnitEnabled;
          oTemp.maxTimeUnit = templateInfo.Countdown.maxTimeUnit;
          if (templateInfo.Countdown.endTime) {
            // 模板一般是不带结束时间的，如果带了就转成时间格式
            oTemp.endTime = new Date(
              oUtils.transformUTCDate(templateInfo.Countdown.endTime, "format")
            );
          } else {
            // 没带默认时间就是当前时间加1个最大单位时间
            oTemp.maxTimeUnit = oTemp.maxTimeUnit ? oTemp.maxTimeUnit : "day"; //没有默认最大时间就取day
            oTemp.endTime = oUtils.handleTime2(
              new Date(),
              1,
              oTemp.maxTimeUnit
            );
          }
          oTemp.TimeFontCfg = {
            x: templateInfo.Countdown.TimeFontCfg.Position.positionX,
            y: templateInfo.Countdown.TimeFontCfg.Position.positionY,
            width: templateInfo.Countdown.TimeFontCfg.Position.width,
            height: templateInfo.Countdown.TimeFontCfg.Position.height,
            fontSize: templateInfo.Countdown.TimeFontCfg.fontSize,
            fontColor: oUtils.transformRgb(
              templateInfo.Countdown.TimeFontCfg.FontColor.RGB || 0
            ),
          };
          if (templateInfo.Countdown.ModuleInfoList) {
            //ModuleInfoList排序
            templateInfo.Countdown.ModuleInfoList = this.countDownSort(
              templateInfo.Countdown.ModuleInfoList,
              oTemp.template
            );
            oTemp.subWindows = templateInfo.Countdown.ModuleInfoList.map(
              (item, i) => {
                let ModuleInfo = item.ModuleInfo;
                let fontSize = this.transformFontSize(
                  ModuleInfo.fontSize,
                  oTemp.height,
                  oTemp.screenType
                );
                let content = "0";
                // 将模板中DATE改成DAY
                if (ModuleInfo.moduleType === "text") {
                  if (ModuleInfo.text === "DATE") {
                    content = "DAY";
                  } else {
                    content = ModuleInfo.text || "0";
                  }
                }
                return {
                  start: i,
                  moduleType: ModuleInfo.moduleType,
                  enable: ModuleInfo.enabled,
                  x: ModuleInfo.Position.positionX,
                  y: ModuleInfo.Position.positionY,
                  width: ModuleInfo.Position.width,
                  height: ModuleInfo.Position.height,
                  fontSize,
                  fontColor: oUtils.transformRgb(ModuleInfo.FontColor.RGB || 0),
                  content: content,
                };
              }
            );
            oUtils.setCountDown(
              oTemp.subWindows,
              oTemp.endTime,
              oTemp.maxTimeUnit
            );
            oTemp.subwindowGroups = oSubGroupMap[oTemp.template];
          }
          oTemplate.countdown.push(oTemp);
          break;
        case "rssWin": {
          const IconParams = templateInfo.RssParam[arrayRssType[0]];
          oTemp.subWindows = [
            {
              enable: IconParams.enabled,
              x: IconParams.Position.positionX,
              y: IconParams.Position.positionY,
              width: IconParams.Position.width,
              height: IconParams.Position.height,
              defX: IconParams.Position.positionX,
              defY: IconParams.Position.positionY,
              defWidth: IconParams.Position.width,
              defHeihgt: IconParams.Position.height,
              name: rssNames[0].name,
              type: IconParams.type,
            },
          ];
          // 除ICON外 其他当做统一属性配置
          const padding = Math.max((oTemp.width * 12) / 320, 25);
          const contentParams = {
            enable: true,
            x: padding,
            y: padding,
            width: oTemp.width - padding * 2,
            height: oTemp.height - padding * 2,
            defX: padding,
            defY: padding,
            defWidth: oTemp.width - padding * 2,
            defHeihgt: oTemp.height - padding * 2,
            defH: oTemp.width - padding * 2,
            name: "rssContent",
            subWindows: [],
          };

          // 调大边距
          const ratio =
            oTemp.screenType === "horizontal"
              ? (1 / 1080) * 1920
              : (1 * 1080) / 1920;
          contentParams.defY = contentParams.y = padding * ratio;
          contentParams.defHeihgt = contentParams.height =
            oTemp.height - padding * ratio * 2;

          for (let k = 1; k < 4; k++) {
            let oRssSubParam = templateInfo.RssParam[arrayRssType[k]];
            const fontSize = this.transformFontSize(
              oRssSubParam.fontSize,
              oTemp.height,
              oTemp.screenType
            );
            let subWindow = {
              enable: oRssSubParam.enabled,
              type: oRssSubParam.type,
              alignType:
                oRssSubParam.alignType === "center"
                  ? "middle"
                  : oRssSubParam.alignType,
              fontSize,
              fontColor: oUtils.transformRgb(oRssSubParam.FontColor.RGB || 0),
              name: rssNames[k].name,
              content: rssNames[k].content,
              defFont: fontSize,
            };

            if (k === 3) {
              subWindow.interval = oRssSubParam.interval;
            }
            oTemp.fontSize = fontSize;
            contentParams.subWindows.push(subWindow);
          }

          oTemp.subWindows.push(contentParams);
          oTemplate.RSS.push(oTemp);
          break;
        }

        default:
          break;
      }
      // console.log("oTemplate.countdown  ", oTemplate.countdown);
    }
  }

  //获取子窗口名称和内容
  getSubWindowName (type, subType = 1) {
    let aNames = [];
    if (type === "clock") {
      aNames = [
        {
          name: i18n.t("clock"),
          content: "",
        },
        {
          name: i18n.t("ymd"),
          content: oUtils.getCurTime("ymd2"),
        },
        {
          name: i18n.t("hms"),
          content: oUtils.getCurTime("hms2"),
        },
        {
          name: i18n.t("week"),
          content: i18n.t(oUtils.getWeekInfo()),
        },
      ];
    } else if (type === "weather") {
      aNames = [
        {
          name: i18n.t("city"),
          content: i18n.t("city"),
        },
        {
          name: i18n.t("updateTimeTip"),
          content: i18n.t("update_interval"),
        },
        {
          name: i18n.t("weatherIcon"),
          content: i18n.t("weatherIcon"),
        },
        {
          name: i18n.t("date"),
          content: oUtils.getCurTime("ymd2"),
        },
        {
          name: i18n.t("temperature"),
          content: "18℃",
        },
        {
          name: i18n.t("weather"),
          content: i18n.t("fineDay"),
        },
        {
          name: i18n.t("windPower"),
          content: i18n.t("windPowerExp"),
        },
        // {
        //   name: i18n.t("airQuality"),
        //   content: i18n.t("ample"),
        // },
        {
          name: i18n.t("humidity"),
          content: i18n.t("humidityExp"),
        },
      ];
    } else if (type === "event") {
      aNames = [
        {
          name: i18n.t("title"),
          content: "",
        },
        {
          name: i18n.t("peopleCountingPrompt"),
          content: "",
        },
        {
          name: i18n.t("peopleIcon"),
          content: "",
        },
        {
          name: i18n.t("InsidePeopleTitle"),
          content: "",
        },
        {
          name: i18n.t("InsidePeopleNumber"),
          content: "112",
        },
        {
          name: i18n.t("AvailablePeopleTitle"),
          content: "",
        },
        {
          name: i18n.t("AvailablePeopleNumber"),
          content: "888",
        },
        {
          name: i18n.t("maskPrompt"),
          content: "",
        },
        {
          name: i18n.t("maskIcon"),
          content: "",
        },
        {
          name: i18n.t("temperaturePromp"),
          content: "",
        },
        {
          name: i18n.t("temperatureIcon"),
          content: "",
        },
        {
          name: i18n.t("maskPrompt"),
          content: "",
        },
        {
          name: i18n.t("maskIcon"),
          content: "",
        },
        {
          name: i18n.t("normal_temperature_promp"),
          content: "",
        },
        {
          name: i18n.t("temperatureIcon"),
          content: "",
        },
      ];
    } else if (type === "signin") {
      aNames = [
        {
          name: i18n.t("nameEnabled"),
        },
        {
          name: i18n.t("genderEnabled"),
        },
        {
          name: i18n.t("signInTimeEnabled"),
        },
        {
          name: i18n.t("peopleTemperature"),
        },
      ];
    } else if (type === "signout") {
      aNames = [
        {
          name: i18n.t("unknownPerson"),
        },
        {
          name: i18n.t("genderEnabled"),
        },
        {
          name: i18n.t("signInTimeEnabled"),
        },
        {
          name: i18n.t("peopleTemperature"),
        },
      ];
    } else if (type === "conference") {
      aNames = [
        {
          name: i18n.t("nameEnabled"),
        },
      ];
    } else if (type === "RSS") {
      aNames = [
        {
          name: i18n.t("program_icon"),
        },
        {
          name: i18n.t("title"),
          content: new Array(Math.round(subType * 22))
            .fill(i18n.t("title") + " ")
            .reduce((sum, cur) => sum + cur),
        },
        {
          name: i18n.t("date"),
          content: moment().format("MMM DD, YYYY"),
        },
        {
          name: i18n.t("program_content"),
          content: new Array(Math.round(subType * 45))
            .fill(i18n.t("program_content") + " ")
            .reduce((sum, cur) => sum + cur),
        },
      ];
    }
    return aNames;
  }

  //转换子窗口字体大小
  transformFontSize (fontSize, height, type) {
    let pageFontSize = 30;
    if (type === "horizontal") {
      pageFontSize = Math.floor((height * 1080 * 100) / fontSize / 1920);
    } else if (type === "vertical") {
      pageFontSize = Math.floor((height * 1920 * 100) / fontSize / 1920);
    }
    return pageFontSize;
  }

  //获取模板缩略图
  getTemplateUrl (templateThumbnail, extend = "") {
    // let token = JSEncrypt.createUrlToken();
    // return (
    //   templateId !== -1 &&
    //   (`${
    //     window.location.pathname
    //   }ISAPI/Bumblebee/FocSign/V0/TemplateMgr/Template/Thumbnail/Download?ID=${templateId}&timestamp=${new Date().getTime()}&MT=GET&Token=${token}` ||
    //     "") + extend
    // );
    // return "//imgapi.xl0408.top";
    return `${BASE}/content/materialManager/getMaterialDownloadUrl?bucketName=led-picture-bucket${oUtils.isIntl() ? "-intl" : ""}&key=${encodeURIComponent(templateThumbnail)}`;
  }

  //窗口坐标转换
  transformWindow (program, oWindowCap, programWidth, programHeight) {
    let pageList = program.pageList;
    let windowList = [];
    let coordinateValue; //基准坐标
    let relProgramHeight;
    let relProgramWidth;

    if (program.applicationType === "cascadeProgram") {
      coordinateValue = 192000;
      relProgramHeight = programHeight * program.CascadeSize.row;
      relProgramWidth = programWidth * program.CascadeSize.column;
    } else {
      coordinateValue = 1920;
      relProgramHeight = programHeight;
      relProgramWidth = programWidth;
    }

    for (let page of pageList) {
      windowList = page.windowList;
      if (windowList) {
        for (let win of windowList) {
          if (win) {
            let type = win.windowMode;
            if (type !== "app" && type !== "zip") {
              if (program.coordinateType !== "resolutionCoordinate") {
                win.x = Number.parseFloat(
                  (win.x / coordinateValue) * relProgramWidth,
                  2
                );
                win.y = Number.parseFloat(
                  (win.y / coordinateValue) * relProgramHeight,
                  2
                );
                win.defWidth = win.width = Number.parseFloat(
                  (win.width / coordinateValue) * relProgramWidth,
                  2
                );
                win.defHeight = win.height = Number.parseFloat(
                  (win.height / coordinateValue) * relProgramHeight,
                  2
                );
              } else {
                win.x = Number.parseFloat(win.x, 2);
                win.y = Number.parseFloat(win.y, 2);
                win.defWidth = win.width = Number.parseFloat(win.width, 2);
                win.defHeight = win.height = Number.parseFloat(win.height, 2);
              }
              win.minWidth = Number.parseFloat(
                (oWindowCap[type]["iMinWidth"] / 1920) * programWidth
              );
              win.minHeight = Number.parseFloat(
                (oWindowCap[type]["iMinHeight"] / 1920) * programHeight
              );

              win.maxWidth = relProgramWidth;
              if (win.aspectFactor) {
                win.maxHeight = Math.max(
                  win.height,
                  win.maxWidth / win.aspectFactor
                );
              } else {
                win.maxHeight = relProgramHeight;
              }
            } else {
              win.minWidth = relProgramWidth;
              win.minHeight = relProgramHeight;
              win.maxWidth = relProgramWidth;
              win.maxHeight = relProgramHeight;
            }
            if (win.subWindows) {
              for (let suWindow of win.subWindows) {
                if (program.coordinateType !== "resolutionCoordinate") {
                  suWindow.x = Number.parseFloat(
                    (suWindow.x / 1920) * programWidth,
                    2
                  );
                  suWindow.y = Number.parseFloat(
                    (suWindow.y / 1920) * programHeight,
                    2
                  );
                  suWindow.width = Number.parseFloat(
                    (suWindow.width / 1920) * programWidth,
                    2
                  );
                  suWindow.height = Number.parseFloat(
                    (suWindow.height / 1920) * programHeight,
                    2
                  );
                  suWindow.defX = Number.parseFloat(
                    (suWindow.defX / 1920) * programWidth,
                    2
                  );
                  suWindow.defY = Number.parseFloat(
                    (suWindow.defY / 1920) * programHeight,
                    2
                  );
                  suWindow.defWidth = Number.parseFloat(
                    (suWindow.defWidth / 1920) * programWidth,
                    2
                  );
                  suWindow.defHeight = Number.parseFloat(
                    (suWindow.defHeight / 1920) * programHeight,
                    2
                  );
                } else {
                  suWindow.x = Number.parseFloat(suWindow.x, 2);
                  suWindow.y = Number.parseFloat(suWindow.y, 2);
                  suWindow.width = Number.parseFloat(suWindow.width, 2);
                  suWindow.height = Number.parseFloat(suWindow.height, 2);
                  suWindow.defX = Number.parseFloat(suWindow.defX, 2);
                  suWindow.defY = Number.parseFloat(suWindow.defY, 2);
                  suWindow.defWidth = Number.parseFloat(suWindow.defWidth, 2);
                  suWindow.defHeight = Number.parseFloat(suWindow.defHeight, 2);
                }
              }
            }
          }
        }
      }
    }
  }

  //布局模板窗口大小转换
  transformLayoutWindow (layoutList, programWidth, programHeight) {
    //以前先转换在求线信息会有与小数点问题导致判断不准确，现在先计算再转换
    let res = this.areaToLine(layoutList, programWidth, programHeight);
    const coordinateValue = 1920; //基准坐标
    for (let position of res) {
      position.x = Number.parseFloat(
        (position.x / coordinateValue) * programWidth,
        2
      );
      position.y = Number.parseFloat(
        (position.y / coordinateValue) * programHeight,
        2
      );
      position.width =
        position.width === 1
          ? 1
          : Number.parseFloat(
            (position.width / coordinateValue) * programWidth,
            2
          );
      position.height =
        position.height === 1
          ? 1
          : Number.parseFloat(
            (position.height / coordinateValue) * programHeight,
            2
          );
      position.defX = position.x;
      position.defY = position.y;
      position.defW = position.width;
      position.defH = position.height;
    }
    return res;
  }

  //将区域信息转换为线信息
  areaToLine (list, maxW, maxH) {
    let lineList = [];
    //将区域信息转换线信息
    for (let i = 0; i < list.length; i++) {
      let win = list[i];
      const { x, y, height: h, width: w } = win;
      // 依次判断上右下左四条线是否可以转换为线信息
      [y, x + w, y + h, x].forEach((item, index) => {
        const flag = !(index % 2);
        const coordinateValue = 1920;
        if (item !== 0 && item !== coordinateValue) {
          lineList.push({
            x: flag ? x : item,
            y: flag ? item : y,
            height: flag ? 1 : h,
            width: flag ? w : 1,
            defX: flag ? x : item, //用于后面联动比较
            defY: flag ? item : y,
            defH: flag ? 1 : h, //用于后面联动比较
            defW: flag ? w : 1,
            notMove: flag ? "lr" : "tb",
          });
        }
      });
    }
    //删除短的、重复的线信息
    const len = lineList.length;
    for (let i = 0; i < len - 1; i++) {
      for (let j = i + 1; j < len; j++) {
        const { x, y, height: h, width: w } = lineList[i];
        const { x: x1, y: y1, height: h1, width: w1 } = lineList[j];
        //都为竖线、从同一x出发，j在i内部, 以下同理
        if (w === 1 && w1 === 1 && x === x1 && y <= y1 && y + h >= y1 + h1) {
          lineList[j].del = true;
        } else if (
          w === 1 &&
          w1 === 1 &&
          x === x1 &&
          y >= y1 &&
          y + h <= y1 + h1
        ) {
          lineList[i].del = true;
        } else if (
          h === 1 &&
          h1 === 1 &&
          y === y1 &&
          x <= x1 &&
          x + w >= x1 + w1
        ) {
          lineList[j].del = true;
        } else if (
          h === 1 &&
          h1 === 1 &&
          y === y1 &&
          x >= x1 &&
          x + w <= x1 + w1
        ) {
          lineList[i].del = true;
        }
      }
    }
    lineList = lineList.filter((line) => {
      return !line.del;
    });
    // console.error(lineList);
    let res = [];
    //拼接所有同一x、同一y的线
    const xSet = new Set(lineList.map((item) => item.x));
    const ySet = new Set(lineList.map((item) => item.y));
    for (let x of xSet) {
      let total = 0;
      let i = -1;
      let minY = -1;
      lineList.forEach((line, index) => {
        if (line.x === x && line.width === 1) {
          i = index;
          total += line.height;
          minY = minY === -1 ? line.y : Math.min(minY, line.y);
        }
      });
      if (i !== -1) {
        res.push({
          ...lineList[i],
          y: minY,
          defY: minY,
          defH: total,
          height: total,
          isAll: total === maxH,
        });
      }
    }
    for (let y of ySet) {
      let total = 0;
      let i = -1;
      let minX = -1;
      lineList.forEach((line, index) => {
        if (line.y === y && line.height === 1) {
          i = index;
          total += line.width;
          minX = minX === -1 ? line.x : Math.min(minX, line.x);
        }
      });
      if (i !== -1) {
        res.push({
          ...lineList[i],
          x: minX,
          defX: minX,
          defW: total,
          width: total,
          isAll: total === maxW,
        });
      }
    }

    return res;
  }

  // 组装素材类型相关json
  getMaterialType (windowType, dataType, window) {
    //generalData通用数据，弹图添加素材;
    //web分为静态网页webpage，动态网址weburl，获取素材的时候区分静态动态，保存的时候web窗口素材节点统一为静态，服务器根据素材类型区分静态动态
    let aStaticMaterialType = [
      "picture",
      "flash",
      "audio",
      "video",
      "document",
      "pdf",
      "ppt",
      "doc",
      "excel",
      "web",
      "webPage",
      "app",
      "zip",
      "signIn",
      "conference",
      "signalSource",
    ];
    let aDynamicType = [
      "socket",
      "call",
      "dynamicPic",
      "realStream",
      "capturePic",
      "generalData",
      "webUrl",
      "picUrl",
      "character",
    ];
    let aAllType = ["windowBgPic", "pageBgPic"]; //背景图片支持静态图片和动态图片url
    let materialType = "other";
    let WinMaterialInfo = {};
    if (aStaticMaterialType.includes(windowType)) {
      materialType = "static";
      WinMaterialInfo.staticMaterialType = windowType;
    } else if (aDynamicType.includes(windowType)) {
      materialType = "dynamic";
      WinMaterialInfo.dynamicType = windowType;
    } else if (aAllType.includes(windowType)) {
      materialType = "all";
      WinMaterialInfo.staticMaterialType = "web";
      WinMaterialInfo.dynamicType = "web";
    } else if (windowType === "dataSource" && dataType === "table") {
      materialType = "dynamic";
      WinMaterialInfo.dynamicType = "call";
    } else if (windowType === "dataSource" && dataType === "pic") {
      materialType = "static";
      WinMaterialInfo.staticMaterialType = "picture";
    } else if (windowType === "dataSource" && dataType === "character") {
      materialType = "dynamic";
      WinMaterialInfo.dynamicType = "character";
    } else if (windowType === "dataSource" && dataType === "chart") {
      materialType = "dynamic";
      WinMaterialInfo.dynamicType = "chart";
    } else {
      materialType = "other";
      const lowArr = ["RSS"];
      WinMaterialInfo.otherType = lowArr.includes(windowType)
        ? windowType.toLowerCase()
        : windowType;
    }
    WinMaterialInfo.materialType = materialType;
    this.judgeIsHybrid("", window) &&
      (WinMaterialInfo.materialType = "multiType"); // 混合窗口
    return {
      WinMaterialInfo: { WinMaterialInfo },
      materialType: materialType,
    };
  }
  /**
   * 判断是否是混合窗口
   * @params
   * window: window对象
   * oProgramInfo: 节目对象
   **/
  judgeIsHybrid (oProgramInfo, window) {
    //非数字标牌不支持混合窗口
    if (oProgramInfo && oProgramInfo.applicationType !== "normal") {
      // --超长屏先可以支持混合窗口
      return false;
    }
    // 除了pro、lite，其他不支持混合窗口
    // if (!["FocSignPro", "FocSignLite"].includes(Storage.get(Storage.NAME.PRODUCTINFO)?.Product)) {
    //   return false;
    // }
    const isSupportHybridTypes = constant.IS_SUPPORT_HYBRID_TYPES;
    // const isSupportHybridTypes = ["picture", "video", "pdf", "realStream"];
    const nowTypes = [
      ...new Set(
        window?.materialList?.map((material) => material.materialType)
      ),
    ];

    return _.intersection(isSupportHybridTypes, nowTypes)?.length > 1;
  }

  //保存节目，双面屏组装参数单独调用，两个节目的szErrorTip都不存在时，在下发保存请求。
  saveProgram (oProgramInfo, pageList, doubleParams, showThumbnail = true) {
    let szErrorTip = "";
    let pageErrorObj = {};
    let programErrorObj = {};
    let oJsonParams = null;
    let materialList = [];
    let content = [];
    let iProgramId = oProgramInfo.programId;
    let reg = /[/\\:*?？"<>|]/g;
    let bIsPageNameError = false;

    // doubleParams存在时直接使用它的data作为请求参数，校验在外面做。
    if (doubleParams) {
      oJsonParams = doubleParams.data;
      iProgramId = doubleParams.id; //这里重新赋值一下，防止传入的是双面屏的doubleSideNo
      oJsonParams.Program.audioEnabled = doubleParams.audioEnabled;
    } else {
      let oResult = this.createSaveParams(oProgramInfo, pageList);
      szErrorTip = oResult.szErrorTip;
      pageErrorObj = oResult.pageErrorObj;
      oJsonParams = oResult.oJsonParams;
      programErrorObj = oResult.programErrorObj;
      materialList = oResult.materialList;
      content = oResult.content;
    }
    console.log(oJsonParams, "===oJsonParams");
    console.log(materialList, "===materialList");
    oJsonParams.materialList = [... new Set(materialList)].join();
    oJsonParams.content = JSON.stringify(content);
    oJsonParams.programContext = JSON.stringify(oJsonParams.Program);
    delete oJsonParams.Program;
    //修改还是新增逻辑
    let cmd = "addProgram";
    let params = null;
    let type = iProgramId !== 0 ? "modify" : "add";
    if (type === "modify") {
      cmd = "operateSingleShow";
      params = {
        id: iProgramId,
      };
    }
    //IE11显示loading特别慢，增加自定义样式。因为双面屏节目等待框要加在外面，所幸统一都增加到外面
    // let oWait = oResponse.getWaitInstance(i18n.t("saveing"), 'special-loading-box');
    return new Promise(async (resolve, reject) => {
      //处理错误信息
      if (pageErrorObj && Object.keys(pageErrorObj)?.length) {
        const key = Object.keys(pageErrorObj)[0];

        MessageBox.alert(
          key.replace("%s", pageErrorObj[key].join(", ")),
          i18n.t("saveFail"),
          { type: "error", version: "2" }
        );
        // oResponse.showMessageBox(
        //   i18n.t("saveFail"),
        //   "error",
        //   key.replace("%s", pageErrorObj[key].join(", "))
        // );
        // oWait.close();
        reject();
        return;
      }
      //处理错误信息
      if (programErrorObj && Object.keys(programErrorObj)?.length) {
        const key = Object.keys(programErrorObj)[0];
        MessageBox.alert(
          key.replace("%s", programErrorObj[key].join(", ")),
          i18n.t("program_save_program_fail"),
          { type: "error", version: "2" }
        );
        // oResponse.showMessageBox(
        //   i18n.t("program_save_program_fail"),
        //   "error",
        //   key.replace("%s", programErrorObj[key].join(", "))
        // );
        // oWait.close();
        reject();
        return;
      }
      //处理错误信息
      if (szErrorTip) {
        Message.error(szErrorTip);
        // oResponse.showTips(szErrorTip);
        // oWait.close();
        reject();
        return;
      }
      //检测页面名称是否合法
      pageList.forEach((item) => {
        if (item.pageName.match(reg)) {
          Message.error(i18n.t("pageNameError"));
          // oResponse.showTips("pageNameError", "", true);
          bIsPageNameError = true;
        }
      });
      if (bIsPageNameError) {
        reject();
        return;
      }

      const blobFile = await oUtils.generateShowThumbnail([
        ".page-list-element",
        ".page-content",
      ]);
      // oJsonParams.programThumbnail = blobFile;

      // 创建 FormData 对象来处理表单数据
      const formData = new FormData();
      formData.append("programThumbnailPicture", blobFile);
      for (let key in oJsonParams) {
        formData.append(key, oJsonParams[key]);
      }

      programApi[oJsonParams.programId ? "updateProgram" : "saveProgram"](
        formData
      )
        .then((res) => {
          if (res.code == "200") {
            // 新建节目需要补充programId
            if (!oJsonParams.programId) {
              let programContextObj = JSON.parse(oJsonParams.programContext)
              programContextObj.id = res.data || 0
              this.programContextInit = JSON.stringify(programContextObj)
            } else {
              this.programContextInit = oJsonParams.programContext
            }
            resolve(res.data || 0);
          } else {
            reject(res);
          }
        })
        .catch((e) => {
          MessageBox.alert(
            // szErrorString,
            i18n.t("program_save_program_fail"),
            { type: "error", version: "2" }
          );
          reject(e);
        });

      // console.log('oJsonParams = >', oJsonParams);
      // oWebSdk.WSDK_SetDeviceConfig(cmd, params, {
      //   data: oJsonParams,
      //   success: (resJson, result) => {
      //     // oResponse.showResponse(result, "", false);
      //     if (type === "add") {
      //       iProgramId = resJson?.ProgramInfo?.id; // 创建成功的节目的id(新增)
      //     }
      //     // 双面屏非正在编辑的那个屏幕，截屏已在切换内外屏时完成
      //     if (doubleParams && doubleParams.imageData) {
      //       this.uploadShowThumbnail(doubleParams.imageData, iProgramId).then(
      //         () => {
      //           resolve(iProgramId);
      //         }
      //       );
      //     } else {
      //       // 双面屏第二块屏幕正常应该有imageData，若没有则是编辑进入后未切换到第二块屏幕直接保存，这个时候不截图（无法截图），用原先的截图。
      //       if (doubleParams && doubleParams.index === 2) {
      //         return resolve(iProgramId);
      //       }
      //       // 默认上传缩略图，会议签到两个节目只需要保存一个节目的缩略图
      //       if (showThumbnail === true) {
      //         oUtils
      //           .generateShowThumbnail([".page-list-element", ".page-content"])
      //           .then(
      //             async (imageData) => {
      //               await this.uploadShowThumbnail(imageData, iProgramId);
      //               this.handleProgramResolve({
      //                 oProgramInfo,
      //                 oJsonParams,
      //                 iProgramId,
      //                 resolve,
      //               });
      //               // oWait.close();
      //             },
      //             () => {
      //               // reject();
      //               // 缩略图保存失败继续执行，保证闭环
      //               this.handleProgramResolve({
      //                 oProgramInfo,
      //                 oJsonParams,
      //                 iProgramId,
      //                 resolve,
      //               });
      //               // oWait.close();
      //             }
      //           );
      //       } else {
      //         this.handleProgramResolve({
      //           oProgramInfo,
      //           oJsonParams,
      //           iProgramId,
      //           resolve,
      //         });
      //       }
      //     }
      //   },
      //   errorResponse: (resData) => {
      //     if (resData.CascadingErrorInfo === "internalMaterialNotUpload") {
      //       //内置素材未上传云存储
      //       // oWait.close();
      //       reject("internalMaterialNotUpload");
      //     } else {
      //       let iErrorModule = 0;
      //       let iErrorCode = 0;
      //       let szErrorString = "";
      //       // let szCascadingErrorInfo = '';
      //       let xmlString = oUtils.xmlToStr(resData);
      //       if (xmlString && xmlString.indexOf("<?xml") > -1) {
      //         iErrorModule = oUtils.nodeValue(resData, "ErrorModule", "i");
      //         iErrorCode = oUtils.nodeValue(resData, "ErrorCode", "i");
      //         // szCascadingErrorInfo = oUtils.nodeValue(response, 'CascadingErrorInfo');
      //       } else if ("object" === typeof resData) {
      //         iErrorModule = resData["ErrorModule"];
      //         iErrorCode = resData["ErrorCode"];
      //         // szCascadingErrorInfo = response['CascadingErrorInfo'];
      //       }
      //       szErrorString = i18n.t(
      //         iErrorCode
      //           ? `error_${iErrorModule}_${iErrorCode}`
      //           : "program_error_device_error"
      //       ); //未返回，提示服务器错误
      //       MessageBox.alert(
      //         szErrorString,
      //         i18n.t("program_save_program_fail"),
      //         { type: "error", version: "2" }
      //       );
      //       // oResponse.showMessageBox(szErrorString);
      //       // oWait.close();
      //       reject();
      //     }
      //     return false;
      //   },
      //   error: () => {
      //     reject();
      //   },
      // });
    });
  }

  /*
    创造保存节目时候的参数，双面屏时需要确保2个节目web层面的限制都已通过，才能下发请求，所以这里分出来。
    programScreenType 是主屏还是副屏，存在这个参数判断是双面屏节目
  */
  createSaveParams (oProgramInfo, pageList, programScreenType) {
    let szErrorTip = "";
    let programErrorObj = {};
    let pageErrorObj = {}; // 窗口类型错误列表 使用szErrorTip后一个会覆盖前一个，用这个获取完整的错误列表
    let iVoiceOpenNum = 0;
    let oWindowInfo = ""; //窗口信息对象(json、error等)
    let programWidth = oProgramInfo.programWidth;
    let programHeight = oProgramInfo.programHeight;
    let bResolutionCoordinate; //终端bug，出现大于1920的时候，要按实际坐标计算；否则就是基准1920*1920的坐标计算
    let coordinateValue; //基准坐标
    let relProgramHeight;
    let relProgramWidth;
    if (oProgramInfo.applicationType === "cascadeProgram") {
      bResolutionCoordinate = oProgramInfo.resolution === "custom";
      // bResolutionCoordinate = oProgramInfo.resolution === "selfDefine";
      coordinateValue = 192000;
      relProgramHeight = programHeight * oProgramInfo.row;
      relProgramWidth = programWidth * oProgramInfo.column;
    } else {
      bResolutionCoordinate = oProgramInfo.applicationType === "fold" || programWidth > 1920 || programHeight > 1920;
      coordinateValue = 1920;
      relProgramHeight = programHeight;
      relProgramWidth = programWidth;
    }

    console.log(coordinateValue, "===coordinate");

    let resolutionName = oProgramInfo.resolution;
    // TODO 是否需要审核
    if (false) {
      // if (oCommonService.oFocSignPermission.FOCSIGN.AUDIT_MANAGE.AUDIT) {
      oProgramInfo.approveState = "approved";
    } else {
      oProgramInfo.approveState = "notApprove";
    }
    let oJsonParams = {
      Program: {
        id: oProgramInfo.programId,
        programName: oProgramInfo.programName.trim(),
        programRemarks: oProgramInfo.programRemarks,
        approveState: oProgramInfo.approveState,
        shareProperty: oProgramInfo.shareProperty,
        programType: oProgramInfo.programType,
        applicationType:
          oProgramInfo.applicationType === "peopleCounting"
            ? "peopleConting"
            : oProgramInfo.applicationType,
        groupId: oProgramInfo.groupId,
        groupIdPath: oProgramInfo.groupIdPath,
        // orgNo: oProgramInfo.orgId,
        Resolution: {
          resolutionName: resolutionName,
          imageWidth: programWidth,
          imageHeight: programHeight,
        },
        coordinateType: bResolutionCoordinate
          ? "resolutionCoordinate"
          : "uniformCoordinate",
        audioEnabled: true, // 是否开启音频，单面屏节目默认开启，双面屏节目按照实际开启情况传值
        PageList: [],
        CascadeSize: {
          row: oProgramInfo.row,
          column: oProgramInfo.column,
        },
        mode: oProgramInfo.mode || "",
        AddAttribute: oProgramInfo.AddAttribute || {},
      },
    };
    if (oProgramInfo.programId) {
      oJsonParams.programId = oProgramInfo.programId;
    } else {
      oJsonParams.groupId = oJsonParams.Program.groupId;
      oJsonParams.groupIdPath = oJsonParams.Program.groupIdPath;
    }

    oJsonParams.programName = oJsonParams.Program.programName;
    oJsonParams.programType = oJsonParams.Program.programType;
    // const resolutionTransform = {
    //   "1920*1080": "horizontal",
    //   "1080*1920": "vertical",
    //   selfDefine: "custom",
    // };
    // oJsonParams.resolutionType =
    //   resolutionTransform[oJsonParams.Program.Resolution.resolutionName];
    oJsonParams.resolutionType = oJsonParams.Program.Resolution.resolutionName;
    oJsonParams.resolutionWidth = oJsonParams.Program.Resolution.imageWidth;
    oJsonParams.resolutionHeight = oJsonParams.Program.Resolution.imageHeight;

    // 节目中所有素材id集合（包括背景）
    let materialList = [];
    // 节目中所有文本内容
    let content = [];
    if (programScreenType) {
      oJsonParams.Program.programType = oJsonParams.Program.applicationType =
        "doubleSide";
      oJsonParams.Program.screenType = programScreenType;
      if (oJsonParams.Program.screenType === "second") {
        // 副屏节目修改节目名称，否则两个节目名称相同服务器报错。这个限制能否加判断去除后续待定。
        oJsonParams.Program.programName =
          "SUB_" + oJsonParams.Program.programName;
        if (oUtils.lengthw(oJsonParams.Program.programName) > 64) {
          let le = oJsonParams.Program.programName.length;
          oJsonParams.Program.programName =
            oJsonParams.Program.programName.slice(0, le - 4);
        }
      }
    }
    for (let page of pageList) {
      let iPageWndDurationTotal = 0;
      let iVoiceOpenNumSingle = 0;
      if (page.pageName === "" || page.pageName.trim() === "") {
        //判断页面是否为空，由于页面不一定停留在当前页，所以要在保存前判断
        szErrorTip = oUtils.getValue("pageNameEmptyError", [page.pageId]);
      }
      let oPageParam = {
        Page: {
          id: page.pageId,
          PageBasicInfo: {
            templateId: page.templateId,
            pageName: page.pageName,
            backgroundPic: page.backgroundPic,
            backgroundPicType: page.backgroundType,
            BackgroundColor: {
              RGB: oUtils.transformRgb(page.backgroundColor, 16),
            },
            playDurationMode:
              page.playDurationMode === "programLoop"
                ? "loop"
                : page.playDurationMode,
            switchEffect: page.switchEffect,
            animationBlockType: page.animationBlockType,
            CascadeInfo: {
              ModuleInfoList: page.ModuleInfoList,
            },
          },
          WindowsList: [],
          TemplateLayoutWindowList: [],
          templateType: page.layoutWindowList?.length ? "Layout" : "",
        },
      };
      if (page.backgroundPic) {
        materialList.push(page.backgroundPic);
      }
      if (page.playDurationMode === "selfDefine") {
        oPageParam.Page.PageBasicInfo.playDuration = page.playDuration;
      } else if (page.playDurationMode === "auto") {
        oPageParam.Page.PageBasicInfo.playCount = page.playCount;
      }

      const signInSubWindows = []; // 考勤icon、time、字幕 本地再subwindow这层，下发时要转换成窗口层
      //如果是考勤窗口
      if (oProgramInfo.applicationType === "signIn") {
        oPageParam.Page.PageBasicInfo.SignInCfg = {
          VoiceBroadcast: {
            enabled: page.signInCfg.voiceBroadcastEnable,
            broadcastSpeed: page.signInCfg.broadcastSpeed,
            inLibVoice: page.signInCfg.inLibVoice,
            outLibVoice: page.signInCfg.outLibVoice,
          },
          WelcomeWord: {
            enabled: page.signInCfg.welcomeWordEnable,
            inLibWord: page.signInCfg.inLibWord,
            outLibWord: page.signInCfg.outLibWord,
          },
        };
        // 体温异常在库人员语音提示
        if (page.signInCfg.inLibAbnormalTemperatureVoice) {
          oPageParam.Page.PageBasicInfo.SignInCfg.VoiceBroadcast.inLibAbnormalTemperatureVoice =
            page.signInCfg.inLibAbnormalTemperatureVoice;
        }
        // 体温异常未知人员语音提示
        if (page.signInCfg.outLibAbnormalTemperatureVoice) {
          oPageParam.Page.PageBasicInfo.SignInCfg.VoiceBroadcast.outLibAbnormalTemperatureVoice =
            page.signInCfg.outLibAbnormalTemperatureVoice;
        }
        if (page.signInCfg.templateThreshold) {
          oPageParam.Page.PageBasicInfo.SignInCfg.TemperatureDetection = {
            enabled: true,
            threshold: page.signInCfg.templateThreshold,
          };
        }

        // 考勤 subwindow => window
        try {
          let windowId1 = Math.max(
            ...page.windowList.map((window) => window.windowId)
          );
          let {
            oWindowInfo: { SignIn },
          } = this.getWindowInfo(
            page.windowList[0],
            oProgramInfo,
            bResolutionCoordinate,
            materialList
          );
          // logo
          if (SignIn?.signIn_logo?.enabled) {
            const {
              materialNo,
              Position: { height, positionX, positionY, width },
            } = SignIn.signIn_logo;
            signInSubWindows.push({
              windowId: ++windowId1,
              windowMode: "picture",
              height: (height / coordinateValue) * relProgramHeight,
              width: (width / coordinateValue) * relProgramWidth,
              x: (positionX / coordinateValue) * relProgramWidth,
              y: (positionY / coordinateValue) * relProgramHeight,
              z: 1,
              windowApplication: "attendanceLogo",
              materialList: [
                {
                  index: 0,
                  materialId: materialNo,
                  scaleType: false,
                  playTimeType: "selfDefine",
                  switchEffect: "none",
                  materialTime: 10,
                },
              ],
            });
          }
          // 时钟
          if (SignIn?.signIn_time?.enabled) {
            const {
              Position: { height, positionX, positionY, width },
            } = SignIn.signIn_time;
            signInSubWindows.push({
              windowId: ++windowId1,
              windowMode: "clock",
              // backgroundPic: 122,
              height: (height / coordinateValue) * relProgramHeight,
              width: (width / coordinateValue) * relProgramWidth,
              x: (positionX / coordinateValue) * relProgramWidth,
              y: (positionY / coordinateValue) * relProgramHeight,
              z: 1,
              windowApplication: "attendanceClock",
              subWindows:
                programHeight > programWidth ? clock_params_h : clock_params,
            });
          }
          // 字幕
          if (SignIn?.signIn_zimu?.enabled) {
            const {
              text,
              rolling_direction,
              Position: { height, positionX, positionY, width },
            } = SignIn.signIn_zimu;
            signInSubWindows.push({
              windowId: ++windowId1,
              windowMode: "character",
              height: (height / coordinateValue) * relProgramHeight,
              width: (width / coordinateValue) * relProgramWidth,
              x: (positionX / coordinateValue) * relProgramWidth,
              y: (positionY / coordinateValue) * relProgramHeight,
              z: 1,
              characterContent: text,
              fontSize: 30,
              fontColor: "#FBFBFB",
              backgroundColor: "#FFFFFF",
              characterStyle: "normal",
              strikethroughEnabled: "none",
              backTransparent: 0,
              alignType: "left",
              verticaAlignType: "top",
              rollingDirection: rolling_direction,
              characterLineType: "singleLine",
              windowApplication: "attendanceSubtitles",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
      const windowPositionArray = [];
      // 窗口数据组装处理
      for (let window of [...page.windowList, ...signInSubWindows]) {
        oWindowInfo = this.getWindowInfo(
          window,
          oProgramInfo,
          bResolutionCoordinate,
          materialList,
          content
        );
        oWindowInfo.szErrorTip !== "" &&
          (szErrorTip = i18n.t(oWindowInfo.szErrorTip));
        // 2.1就特殊处理天气窗口，后续优化
        if (i18n.t(oWindowInfo.szErrorTip) === i18n.t("weatherWndNoCity")) {
          const errorTip = i18n.t("program_weather_save_tip");
          if (!pageErrorObj[errorTip]) {
            pageErrorObj[errorTip] = [];
          }
          if (!pageErrorObj[errorTip].includes(page.pageName)) {
            pageErrorObj[errorTip].push(page.pageName);
          }
        }
        // 三方数据源处理
        if (
          i18n.t(oWindowInfo.szErrorTip) === i18n.t("program_source_id_tip")
        ) {
          const errorTip = i18n.t("program_source_id_tip");
          if (!pageErrorObj[errorTip]) {
            pageErrorObj[errorTip] = [];
          }
          if (!pageErrorObj[errorTip].includes(page.pageName)) {
            pageErrorObj[errorTip].push(page.pageName);
          }
        }
        if (
          i18n.t(oWindowInfo.szErrorTip) === i18n.t("program_source_name_tip")
        ) {
          const errorTip = i18n.t("program_source_name_tip");
          if (!pageErrorObj[errorTip]) {
            pageErrorObj[errorTip] = [];
          }
          if (!pageErrorObj[errorTip].includes(page.pageName)) {
            pageErrorObj[errorTip].push(page.pageName);
          }
        }
        // RSS处理
        if (i18n.t(oWindowInfo.szErrorTip) === i18n.t("program_rss_none_tip")) {
          const errorTip = i18n.t("program_rss_none_tip");
          if (!pageErrorObj[errorTip]) {
            pageErrorObj[errorTip] = [];
          }
          if (!pageErrorObj[errorTip].includes(page.pageName)) {
            pageErrorObj[errorTip].push(page.pageName);
          }
        }
        // 按钮窗口
        if (i18n.t(oWindowInfo.szErrorTip) === i18n.t("hyperlinkBtnNoBg")) {
          const errorTip = i18n.t("program_hyperlink_btn_no_bg");
          if (!pageErrorObj[errorTip]) {
            pageErrorObj[errorTip] = [];
          }
          if (!pageErrorObj[errorTip].includes(page.pageName)) {
            pageErrorObj[errorTip].push(page.pageName);
          }
        }
        let oWindowParam = {
          Windows: {
            id: window.windowId,
            layerNo: window.z,
            Position: {},
          },
        };

        // 未四舍五入的原始值，计算结束坐标，避免坐标重复
        let winHeightOld = (window.height * coordinateValue) / relProgramHeight;
        let winWidthOld = (window.width * coordinateValue) / relProgramWidth;
        let positionXOld = (window.x * coordinateValue) / relProgramWidth;
        let positionOld = (window.y * coordinateValue) / relProgramHeight;

        let positionX = Math.round(positionXOld);
        let positionY = Math.round(positionOld);
        let endPositionX = Math.round(winWidthOld + positionXOld);
        let endPositionY = Math.round(winHeightOld + positionOld);
        let winWidth = Math.round(endPositionX - positionX);
        let winHeight = Math.round(endPositionY - positionY);

        //处理positios和width,height之和可能超过 基准坐标 的问题
        if (winHeight + positionY > coordinateValue) {
          winHeight = winHeight + (coordinateValue - winHeight - positionY);
        }

        if (winWidth + positionX > coordinateValue) {
          winWidth = winWidth + (coordinateValue - winWidth - positionX);
        }

        if (bResolutionCoordinate) {
          winHeight = Math.round(window.height);
          winWidth = Math.round(window.width);
          positionX = Math.round(window.x);
          positionY = Math.round(window.y);
        }
        if (window.windowMode === "app" || window.windowMode === "zip") {
          //app手动计算，协议无效的
          positionX = 0;
          positionY = 0;
        }
        oWindowParam.Windows.Position.positionX = positionX;
        oWindowParam.Windows.Position.positionY = positionY;
        oWindowParam.Windows.Position.height = winHeight;
        oWindowParam.Windows.Position.width = winWidth;
        windowPositionArray.push({
          x: Math.round(window.x),
          y: Math.round(window.y),
          height: Math.round(window.height),
          width: Math.round(window.width),
        }); //获取当前页所有窗口的位置信息
        Object.assign(
          oWindowParam.Windows,
          this.getMaterialType(window.windowMode, window.dataType, window)
            .WinMaterialInfo,
          oWindowInfo.oWindowInfo
        );
        iPageWndDurationTotal += oWindowInfo.iPageWndDurationTotal;
        console.log(iPageWndDurationTotal, "===iPageWndDurationTotal");
        iVoiceOpenNum += oWindowInfo.iVoiceOpenNum;
        iVoiceOpenNumSingle += oWindowInfo.iVoiceOpenNum;
        oPageParam.Page.WindowsList.push(oWindowParam);
      }

      //focsign1.4限制屏幕墙 一个区域只能有一个窗口
      if (
        oProgramInfo.applicationType === "cascadeProgram" &&
        !oProgramInfo.isSupportCasCadeResizeAndDrag
      ) {
        const { programWidth, programHeight, row, column } = oProgramInfo;
        let ModuleInfoList = page.ModuleInfoList ?? [];
        let position = []; // 获取标准的宽高范围
        ModuleInfoList.forEach((item) => {
          position.push(item.ModuleInfo.CellPosition);
        });
        if (position.length) {
          position.forEach((item) => {
            item.x = item.cellPositionX * programWidth;
            item.y = item.cellPositionY * programHeight;
            item.height = item.cellRow * programHeight;
            item.width = item.cellColumn * programWidth;
            item.num = 0;
          });
        } else {
          position.push({
            num: 0,
            x: 0,
            y: 0,
            height: programHeight * row,
            width: programWidth * column,
          });
        }

        for (let i = windowPositionArray.length - 1; i >= 0; i--) {
          const item = windowPositionArray[i];
          //判断窗口位置是否是标准宽高，且只有一个窗口 pos.num用来记录个数
          const index = position.findIndex(
            (pos) =>
              pos.height === item.height &&
              pos.width === item.width &&
              pos.x === item.x &&
              pos.y === item.y &&
              pos.num === 0
          );
          if (index === -1) {
            szErrorTip = i18n
              .t("program_cascade_position_tip")
              .replace("%s", page.pageName);
            break;
          }
          position[index].num++;
        }
      }

      //布局模板信息
      if (page.layoutWindowList?.length) {
        const { programHeight, programWidth } = oProgramInfo;
        let areaInfo = this.getAreaInfo(
          { programHeight, programWidth },
          page.layoutWindowList
        );
        // console.error(areaInfo);
        oPageParam.Page.TemplateLayoutWindowList = areaInfo.map((item) => {
          return {
            TemplateLayoutWindow: {
              id: item.id + 1,
              Position: {
                positionX: item.x,
                positionY: item.y,
                height: item.height,
                width: item.width,
              },
            },
          };
        });
      }

      //获取当前页有无音频
      if (oProgramInfo.audioData?.length) {
        oProgramInfo.audioData.some((item) => {
          if (
            item.materialNo &&
            item.pageId === page.pageId &&
            (!programScreenType || item.screenType === programScreenType)
          ) {
            iPageWndDurationTotal += 5;
            let oWindowParam = {
              Windows: {
                id: -1,
                layerNo: 1,
                Position: {
                  positionX: 0,
                  positionY: 0,
                  height: 80,
                  width: 45,
                },
                WinMaterialInfo: {
                  staticMaterialType: "audio",
                  materialType: "static",
                },
                PlayItemList: [
                  {
                    PlayItem: {
                      id: 1,
                      materialNo: item.materialNo,
                      PlayDuration: {
                        durationType: "materialTime",
                      },
                    },
                  },
                ],
              },
            };
            oPageParam.Page.WindowsList.push(oWindowParam);
            materialList.push(item.materialNo)
            return true;
          }
          return false;
        });
      }

      // 是否包含无限时长，无限时长没有具体时间，但是循环时可以提交
      let bHasUnlimited = false;
      page.windowList?.forEach((window) => {
        let aMaterialList = window.materialList; // 窗口素材列表
        aMaterialList &&
          aMaterialList.forEach((material) => {
            if (material.playTimeType === "unlimited") {
              bHasUnlimited = true;
            }
          });
      });
      /*用目前需要对时钟、天气、倒计时、弹图、叫号、按钮、APP 、文字的页面播放类型进行限制，以上窗口单独存在且不包含其他窗口时，
      页面选择循环和自动报错，报错为“XX页面播放类型不能设置为XX”(所有窗口，不仅仅是上述窗口)*/
      let applicationTypes = ["normal", "cascadeProgram", "emergencyProgram", "fold"];
      // let applicationTypes = ["normal", "cascadeProgram", "emergencyProgram"];
      // 针对设置了自定义的播放时长，但是窗口数量为0的情况
      // 没有窗口不就应该提示么，还需要关心是否是自定义么
      if (
        applicationTypes.includes(oProgramInfo.applicationType) &&
        // page.playDurationMode === "selfDefine" &&
        // iPageWndDurationTotal === 0 &&
        !bHasUnlimited &&
        !page?.windowList?.length
      ) {
        const errorTip = i18n.t("program_page_play_mode_error_3");
        if (!programErrorObj[errorTip]) {
          programErrorObj[errorTip] = [];
        }
        if (!programErrorObj[errorTip].includes(page.pageName)) {
          programErrorObj[errorTip].push(page.pageName);
        }
      }
      // 增加有窗口才提示设置页面时间
      if (
        applicationTypes.includes(oProgramInfo.applicationType) &&
        (page.playDurationMode === "programLoop" ||
          page.playDurationMode === "auto") &&
        iPageWndDurationTotal === 0 &&
        !bHasUnlimited &&
        page?.windowList?.length
      ) {
        const errorTip = i18n.t("program_page_play_mode_error_2");
        if (!programErrorObj[errorTip]) {
          programErrorObj[errorTip] = [];
        }
        if (!programErrorObj[errorTip].includes(page.pageName)) {
          programErrorObj[errorTip].push(page.pageName);
        }
      }

      //双面屏多音频校验
      if (programScreenType && iVoiceOpenNum > 1) {
        szErrorTip = oUtils.getValue("voiceNumMoreError", [
          page.pageName,
          i18n.t(page.playDurationMode),
        ]);
      }
      //单面屏多音频验证
      if (!programScreenType && iVoiceOpenNumSingle > 1) {
        szErrorTip = oUtils.getValue("voiceNumMoreError", [
          page.pageName,
          i18n.t(page.playDurationMode),
        ]);
      }

      oJsonParams.Program.PageList.push(oPageParam);
    }
    return {
      szErrorTip,
      oJsonParams,
      pageErrorObj,
      programErrorObj, // 内容制作错误提示样式排查优化
      materialList, // 记录所有素材id
      content, // 记录所有文本内容信息
    };
  }

  //组装窗口信息
  getWindowInfo (
    window,
    oProgramInfo,
    bResolutionCoordinate,
    materialList = [],
    content = []
  ) {
    let oWindowInfo = {};
    let szErrorTip = ""; //错误提示
    let iPageWndDurationTotal = 0;
    let iVoiceOpenNum = 0; //只支持开启一个音频
    let windowMode = window.windowMode;
    let dataType = window.dataType;
    let programWidth = oProgramInfo.programWidth;
    let programHeight = oProgramInfo.programHeight;
    let aSupportMaterial = [
      "picture",
      // "document",
      // "pdf",
      ...constant.DOCUMENT_TYPES,
      "video",
      "audio",
      "web",
      "realStream",
    ]; //是否支持素材
    let aNotSupportNullWindow = [
      "picture",
      "video",
      "audio",
      // "document",
      // "pdf",
      ...constant.DOCUMENT_TYPES,
      "app",
      "zip",
      "dynamicPic",
      "capturePic",
      "realStream",
      "web",
      "call",
    ]; //不支持空窗口保存

    if (aSupportMaterial.includes(windowMode)) {
      oWindowInfo.PlayItemList = [];
      if (windowMode === "realStream" && window.backgroundIPC) {
        //考勤、客流视频直播窗口需要单独处理
        oWindowInfo.PlayItemList.push({
          PlayItem: {
            id: 1,
            playType: window.playType,
          },
        });
      } else {
        //如果是空窗口
        if (
          aNotSupportNullWindow.includes(windowMode) &&
          window.materialList.length === 0
        ) {
          szErrorTip = i18n
            .t("nullWindowTips")
            .replace(
              "%s",
              i18n.t(constant.DOCUMENT_TYPES.includes(windowMode) ? "pdfToDocument" : windowMode)
              // i18n.t(windowMode === "pdf" ? "pdfToDocument" : windowMode)
            );
        }
        const isHybrid = this.judgeIsHybrid(oProgramInfo, window); //当前是否是混合窗口
        for (let material of window.materialList) {
          // 强制将升级上来视频自定义时长改为素材时长
          let materialType = material.materialType || windowMode;
          if (
            materialType === "video" &&
            material.playTimeType === "selfDefine"
          ) {
            material.playTimeType = "materialTime";
          }
          let oPlayItem = {
            PlayItem: {
              id: material.index,
              materialNo: material.materialId,
              PlayDuration: {
                durationType: material.playTimeType,
              },
              scaleType: material.scaleType ? "fitCenter" : "fitXY",
            },
          };
          if ("selfDefine" === material.playTimeType) {
            oPlayItem.PlayItem.PlayDuration.duration = material.materialTime;
            iPageWndDurationTotal += parseInt(material.materialTime, 10);
          }
          switch (material.materialType || windowMode) {
            case "picture":
              oPlayItem.PlayItem.switchEffect = material.switchEffect; //图片类型：切换效果
              oPlayItem.PlayItem.AnimationEffectList =
                window.AnimationEffectList || [];
              break;
            // case "document":
            //   oPlayItem.PlayItem.CharactersEffect = {
            //     fontSize: material.fontSize, // 字体大小
            //     FontColor: {
            //       RGB: oUtils.transformRgb(material.fontColor, 16), //字体颜色
            //     },
            //     BackColor: {
            //       RGB: oUtils.transformRgb(material.backgroundColor, 16), // 背景颜色
            //     },
            //     backTransparent: Math.ceil(
            //       ((100 - material.backTransparent) / 100) * 255
            //     ), // 背景透明度
            //     scrollDirection: material.scrollDirection, //滚动方向
            //     scrollSpeed: material.scrollSpeed, //滚动速度
            //   };
            //   break;
            case "web":
              oPlayItem.PlayItem.scrollSpeed = material.scrollSpeed; //滚动速度
              // 网页属性 desktop#PC端，mobile#移动端
              if (material.webType) {
                oPlayItem.PlayItem.WebProperty = {
                  webType: material.webType,
                };
              }
              break;
            case "pdf":
            case "ppt":
            case "doc":
            case "excel":
            case "document":
              oPlayItem.PlayItem.pageTime = material.pageTime; //页面时间
              break;
            case "realStream":
              oPlayItem.PlayItem.inputChannel = material.inputChannel; //绑定的IPC通道号
              break;
            case "video":
            case "audio":
              iPageWndDurationTotal += 5; //视频、音频如果有素材，则均为有播放时间,此处默认加5
              break;
            default:
              break;
          }

          isHybrid &&
            (oPlayItem.PlayItem.itemMaterialType = material.materialType);

          oWindowInfo.PlayItemList.push(oPlayItem);
          materialList.push(material.materialId);
        }
      }
      if (windowMode === "picture") {
        oWindowInfo.rotateDegree = window.rotate || 0;
        oWindowInfo.filletedCornerDegree = window.borderRadius || 0;
      }
      //关掉音频(窗口级)
      if (oUtils.judgeExistTypes(window, ["video", "realStream"])) {
        if (!window.enabledAudio && !window.backgroundIPC) {
          //客流测温窗口特殊处理
          iVoiceOpenNum = 1;
        }
        oWindowInfo.enabledAudio = !window.enabledAudio;
      }
    } else if (windowMode === "character") {
      // 圆角 、 旋转度
      oWindowInfo.rotateDegree = window.rotate || 0;
      oWindowInfo.filletedCornerDegree = window.borderRadius || 0;

      oWindowInfo.CharactersAttribute = {
        characterContent: window.characterContent, // 文字内容
        fontSize: window.fontSize, // 字体大小
        FontColor: {
          RGB: oUtils.transformRgb(window.fontColor, 16), //字体颜色
        },
        BackColor: {
          RGB: oUtils.transformRgb(window.backgroundColor, 16), // 背景颜色
        },
        fontType: window.characterStyle, // 字体类型
        backTransparent: Math.ceil(window.backTransparent * 255), // 背景透明度
        alignType: window.alignType, // 水平对齐方式
        verticaAlignType: window.verticaAlignType, // 垂直对齐方式
        AnimationEffectList: window.AnimationEffectList,
        strikethroughEnabled: window.strikethroughEnabled,
        fontBorder: window.fontBorder,
        fontGradient: window.fontGradient,
        fontShadow: window.fontShadow,
      };
      parseInt(window.fontFamily, 10) !== -1 &&
        Object.assign(oWindowInfo.CharactersAttribute, {
          materialID: parseInt(window.fontFamily, 10),
        });

      // 文字窗口边框
      const fbParams = {
        characterBorderList: [],
      };
      if (
        window.fontBorderStyle &&
        JSON.stringify(window.fontBorderStyle) !== "{}"
      ) {
        const { size, style, color } = window.fontBorderStyle;
        const styleMap = {
          solid: 1,
          dashed: 2,
          pointsDotted: 3,
        };
        const TypeList = ["left", "right", "top", "bottom"];
        TypeList.forEach((type) => {
          fbParams.characterBorderList.push({
            characterBorder: {
              borderType: type,
              borderDegree: size,
              borderColor: {
                RGB: oUtils.transformRgb(color, 16),
              },
              borderStyle: styleMap[style],
            },
          });
        });
      }
      // 文本阴影
      const shadowParams = {
        fontShadow: {},
      };
      if (window.fontShadow && JSON.stringify(window.fontShadow) !== "{}") {
        const {
          enabled,
          shadowRadiusX,
          shadowRadiusY,
          shadowTransparent,
          shadowColor,
        } = window.fontShadow;
        shadowParams.fontShadow = {
          enabled,
          shadowRadiusX: shadowRadiusX * 2,
          shadowRadiusY: shadowRadiusY * 2,
          shadowTransparent: Math.ceil(shadowTransparent * 255),
          shadowColor: oUtils.transformRgb(shadowColor, 16),
        };
      }
      // 文本渐变
      const fontGradientParams = {
        fontGradient: {},
      };
      if (window.fontGradient && JSON.stringify(window.fontGradient) !== "{}") {
        const {
          enabled,
          startTransparent,
          startColor,
          endTransparent,
          endColor,
          gradientDirection,
        } = window.fontGradient;
        fontGradientParams.fontGradient = {
          enabled,
          gradientDirection,
          startTransparent: Math.ceil(startTransparent * 255),
          startColor: oUtils.transformRgb(startColor, 16),
          endTransparent: Math.ceil(endTransparent * 255),
          endColor: oUtils.transformRgb(endColor, 16),
        };
      }
      // 文本描边
      const borderParams = {
        fontBorder: {},
      };
      if (window.fontBorder && JSON.stringify(window.fontBorder) !== "{}") {
        const { enabled, borderDegree, borderColor, borderTransparent } =
          window.fontBorder;
        borderParams.fontBorder = {
          enabled,
          borderDegree,
          borderTransparent: Math.ceil(borderTransparent * 255),
          borderColor: oUtils.transformRgb(borderColor, 16),
        };
      }
      // 滚动设置 有滚动方向并且不能配置了微动效
      const rdParams =
        window.rollingDirection && !window.AnimationEffectList?.length
          ? {
            scrollDirection: window.rollingDirection,
            scrollSpeed: window.scrollSpeed,
            characterLineType:
              window.rollingDirection === "up" ? "multiLines" : "singleLine",
            characterSingleLineAnimation: "marquee",
          }
          : {
            characterLineType: "multiLines",
          };

      Object.assign(
        oWindowInfo.CharactersAttribute,
        rdParams,
        fbParams,
        shadowParams,
        borderParams,
        fontGradientParams
      );

      // 限制文字窗口长度
      // TODO 看看是怎么个规则
      // const characterMaxLen = 512;
      // if (oUtils.lengthw(window.characterContent) > characterMaxLen) {
      //   szErrorTip = i18n
      //     .t("program_var_charater_length_tips")
      //     .replace("%s", characterMaxLen);
      // }
      if (window.verifyContentValid === false) {
        szErrorTip = i18n
          .t("program_charater_verify_tips")
          .replace("%s", window.characterContent);
      }
      content.push(window.characterContent);
    } else if (windowMode === "dynamicPic") {
      //弹图
      oWindowInfo.DataSource = {
        materialNo: window.materialList[0]
          ? window.materialList[0].materialId
          : "",
      };
      oWindowInfo.DynamicPic = {
        backPicId: window.backgroundPic,
      };
    } else if (windowMode === "capturePic") {
      //抓图
      oWindowInfo.CapturePic = {
        backPicId: window.backgroundPic,
        ipcMaterialNo: window.materialList[0]
          ? window.materialList[0].materialId
          : "",
        cancelType: window.cancelType,
      };
      if (window.cancelType === "auto") {
        oWindowInfo.CapturePic.duration = window.duration;
        iPageWndDurationTotal += parseInt(window.duration, 10);
      }
    } else if (windowMode === "hyperlinkBtn") {
      window.backgroundPic === 0 && (szErrorTip = "hyperlinkBtnNoBg"); //按钮窗口没有背景图片 则是不合法的，不允许保存
      oWindowInfo.HyperlinkBtn = {
        backPicId: window.backgroundPic,
      };
    } else if (windowMode === "app" || windowMode === "zip") {
      //zip类型虽然是单独的窗口类型，但是协议借用app的协议
      oWindowInfo.AppWindow = {
        WindowInfoList: [],
      };
      for (let material of window.materialList) {
        //目前app只支持一个素材
        oWindowInfo.AppWindow.WindowInfoList.push({
          WindowInfo: {
            id: material.index,
            materialNo: material.materialId,
          },
        });
      }
    } else if (windowMode === "countdown") {
      if (window.endTime === "") {
        szErrorTip = i18n.t("endTimeNullTips");
      }
      let subWindow = window.subWindows[0];
      /* TimeFontCfg终端兼容之前的实现，需要传倒计时整个窗口的大小信息，坐标是0,0 */
      let winHeight = Math.round((window.height * 1920) / programHeight);
      let winWidth = Math.round((window.width * 1920) / programWidth);
      if (bResolutionCoordinate) {
        winHeight = Math.round(window.height);
        winWidth = Math.round(window.width);
      }
      oWindowInfo.Countdown = {
        endTime: oUtils.transformUTCDate(window.endTime), //终止时间
        template: window.template,
        timeUnit: window.timeUnit,
        timeUnitEnabled: window.timeUnitEnabled,
        maxTimeUnit: window.maxTimeUnit,
        backPicId: window.backgroundPic,
        TimeFontCfg: {
          fontSize: this.calculateFontSize(subWindow.fontSize),
          FontColor: {
            RGB: oUtils.transformRgb(subWindow.fontColor, 16),
          },
          Position: {
            positionX: 0,
            positionY: 0,
            height: winHeight,
            width: winWidth,
          },
        },
      };
      oWindowInfo.Countdown.ModuleInfoList = window.subWindows.map((item) => {
        console.log(item, "item");
        let ModuleInfo = {
          moduleType: item.moduleType,
          enabled: item.enable,
          Position: {
            positionX: Math.round((item.x * 1920) / programWidth),
            positionY: Math.round((item.y * 1920) / programHeight),
            width: Math.round((item.width * 1920) / programWidth),
            height: Math.round((item.height * 1920) / programHeight),
          },
          fontSize: this.calculateFontSize(item.fontSize),
          FontColor: {
            RGB: oUtils.transformRgb(item.fontColor, 16),
          },
        };
        if (ModuleInfo.moduleType === "text") {
          ModuleInfo.text = item.content;
        }
        return {
          ModuleInfo,
        };
      });
    } else if (windowMode === "clock") {
      oWindowInfo.ClockParam = {
        backPicId: window.backgroundPic,
      };
      let aHeadStr = ["ClockIcon", "YmdParam", "HmsParam", "WeekParam"];
      window.subWindows.forEach((subWindow, i) => {
        let height = Math.round((subWindow.height * 1920) / programHeight);
        let width = Math.round((subWindow.width * 1920) / programWidth);
        let positionX = Math.round((subWindow.x * 1920) / programWidth);
        let positionY = Math.round((subWindow.y * 1920) / programHeight);
        if (bResolutionCoordinate) {
          height = Math.round(subWindow.height);
          width = Math.round(subWindow.width);
          positionX = Math.round(subWindow.x);
          positionY = Math.round(subWindow.y);
        }
        oWindowInfo.ClockParam[aHeadStr[i]] = {
          enabled: subWindow.enable,
          Position: {
            positionX,
            positionY,
            height,
            width,
          },
        };
        let oClockSubParam = oWindowInfo.ClockParam[aHeadStr[i]];
        if (i === 0) {
          oClockSubParam.type = subWindow.clockType; //时钟样式
        } else {
          oClockSubParam.fontSize = this.calculateFontSize(subWindow.fontSize);
          oClockSubParam.FontColor = {
            RGB: oUtils.transformRgb(subWindow.fontColor, 16),
          };
        }
      });
    } else if (windowMode === "weather") {
      oWindowInfo.WeatherParam = {
        backPicId: window.backgroundPic,
      };
      // openweather 处理
      if (window.weatherShowType) {
        (!window.subWindows.find((item) => item.type === "city")?.cityId ||
          window.subWindows.find((item) => item.type === "city")?.cityId ===
          -1) &&
          (szErrorTip = "weatherWndNoCity"); //必须选择天气窗口
        Object.assign(oWindowInfo.WeatherParam, {
          weatherShowType: window.weatherShowType,
          WeatherDetail: {
            backPicId: window.backgroundPic,
            // backTransparent: Math.ceil(
            //   ((100 - window.backTransparent) / 100) * 255
            // ),
            backTransparent: Math.ceil(window.backTransparent * 255), // 背景透明度
            BackColor: {
              RGB: oUtils.transformRgb(window.backgroundColor, 16),
            },
            tempUnit: window.timeUnit,
            dateShowType: window.dateShowType,
            countryId: window.subWindows.find((item) => item.type === "city")
              ?.areaId,
            cityId: window.subWindows.find((item) => item.type === "city")
              ?.cityId,
            cityName: window.subWindows.find((item) => item.type === "city")
              ?.cityName,
            cityIdPath: window.subWindows.find((item) => item.type === "city")
              ?.cityIdPath,
            updateInterval: window.updateInterval,
            weatherDateList: [],
          },
        });
        const dateMap = new Map();
        window.subWindows.forEach((item) => {
          if (!dateMap.has(item.moduleType)) {
            dateMap.set(item.moduleType, []);
          }
          let positionX = (item.x * 1920) / programWidth;
          let positionY = (item.y * 1920) / programHeight;
          let height = (item.height * 1920) / programHeight;
          let width = (item.width * 1920) / programWidth;
          if (bResolutionCoordinate) {
            height = Math.round(item.height);
            width = Math.round(item.width);
            positionX = Math.round(item.x);
            positionY = Math.round(item.y);
          }
          dateMap.get(item.moduleType).push({
            paramType: item.type,
            Position: {
              positionX,
              positionY,
              height,
              width,
            },
            fontSize: this.calculateFontSize(item.fontSize),
            FontColor: {
              RGB: oUtils.transformRgb(item.fontColor, 16),
            },
          });
        });

        oWindowInfo.WeatherParam.WeatherDetail.weatherDateList = Array.from(
          dateMap
        ).map((item) => {
          return {
            weatherparamList: item[1],
          };
        });
      } else {
        let aHeadStr = [
          "City",
          "UpdateTime",
          "WeatherIcon",
          "Date",
          "Temperature",
          "WeatherContent",
          "Wind",
          "AirQuality",
          "Humidity",
        ];
        window.subWindows.forEach((subWindow, i) => {
          oWindowInfo.WeatherParam[aHeadStr[i]] = {
            enabled: subWindow.enable,
            Position: {
              positionX: Math.round((subWindow.x * 1920) / programWidth),
              positionY: Math.round((subWindow.y * 1920) / programHeight),
              height: Math.round((subWindow.height * 1920) / programHeight),
              width: Math.round((subWindow.width * 1920) / programWidth),
            },
          };
          let oWeatherSubParam = oWindowInfo.WeatherParam[aHeadStr[i]];
          if (i === 0) {
            (!subWindow.cityId || subWindow.cityId === -1) &&
              (szErrorTip = "weatherWndNoCity"); //必须选择天气窗口
            oWeatherSubParam.cityId = subWindow.cityId;
            oWeatherSubParam.cityName = subWindow.cityName;
            oWeatherSubParam.cityIdPath = subWindow.cityIdPath;
          } else if (i === 1) {
            oWeatherSubParam.updateInterval = subWindow.interval;
          }
          if (i !== 2) {
            oWeatherSubParam.fontSize = this.calculateFontSize(
              subWindow.fontSize
            );
            oWeatherSubParam.FontColor = {
              RGB: oUtils.transformRgb(subWindow.fontColor, 16),
            };
          }
        });
      }
    } else if (windowMode === "call") {
      oWindowInfo.DataSource = {
        materialNo: window.materialList[0]
          ? window.materialList[0].materialId
          : "",
      };
      oWindowInfo.Call = {
        tableRow: window.tableRow,
        tableColumn: window.tableColumn,
        tableDirection: window.tableDirection,
        tableType: window.tableType,
        backPicId: window.backgroundPic,
        alignType: window.alignType,
        refreshDirection: window.refreshDirection,
        HeadDataList: [], //标题data
        ItemStyleList: [], //每列样式
      };
      window.tableHeaders.forEach((item) => {
        oWindowInfo.Call.HeadDataList.push({
          HeadData: {
            id: item.id,
            data: item.data,
          },
        });
        oWindowInfo.Call.ItemStyleList.push({
          ItemStyle: {
            id: item.id,
            width: item.width,
            fontSize: item.fontSize,
            FontColor: {
              RGB: oUtils.transformRgb(item.fontColor, 16),
            },
            BackColor: {
              RGB: oUtils.transformRgb(item.backgroundColor, 16),
            },
          },
        });
      });
    } else if (windowMode === "event") {
      oWindowInfo.EventParam = {
        backPicId: window.insideInfo.backgroundPic,
      };
      // const aHeadStr = ["Title", "PeopleCounting", "PeopleIcon", "InsidePeopleTitle", "InsidePeopleNumber", "AvailablePeopleTitle", "AvailablePeopleNumber",
      //   "Mask", "MaskIcon", "Temperature", "TemperatureIcon"];
      let aSubWindowInfo = {};
      window.subWindows.forEach((subWindow) => {
        let oEventSubParam = {
          enabled: subWindow.enable,
          Position: {
            positionX: Math.round((subWindow.x * 1920) / programWidth),
            positionY: Math.round((subWindow.y * 1920) / programHeight),
            height: Math.round((subWindow.height * 1920) / programHeight),
            width: Math.round((subWindow.width * 1920) / programWidth),
          },
        };
        if (
          [
            "Title",
            "PeopleCounting Prompt",
            "InsidePeopleTitle",
            "InsidePeopleNumber",
            "AvailablePeopleTitle",
            "AvailablePeopleNumber",
            "Mask",
            "Temperature Prompt",
            "WearMask",
            "NormalTemperature Prompt",
          ].includes(subWindow.key)
        ) {
          oEventSubParam.fontSize = subWindow.fontSize;
          //提示语区分告警和正常所以在下面单独拼接
          if (subWindow.key === "AvailablePeopleNumber") {
            oEventSubParam.FontColor = {
              RGB: oUtils.transformRgb(window.insideInfo.numberColor, 16),
            };
          } else if (subWindow.key !== "PeopleCounting Prompt") {
            oEventSubParam.FontColor = {
              RGB: oUtils.transformRgb(subWindow.fontColor, 16),
            };
          }
        }
        if (
          [
            "Title",
            "InsidePeopleTitle",
            "AvailablePeopleTitle",
            "Mask",
            "Temperature Prompt",
            "WearMask",
            "NormalTemperature Prompt",
          ].includes(subWindow.key)
        ) {
          oEventSubParam.text = subWindow.content;
        }
        if (
          [
            "Mask MaskIcon",
            "Temperature TemperatureIcon",
            "WearMask MaskIcon",
            "NormalTemperature TemperatureIcon",
          ].includes(subWindow.key)
        ) {
          oEventSubParam.materialNo = subWindow.icon;
        }
        if (
          [
            "Mask",
            "Temperature Prompt",
            "WearMask",
            "NormalTemperature Prompt",
          ].includes(subWindow.key)
        ) {
          oEventSubParam.BackColor = {
            RGB: oUtils.transformRgb(subWindow.backgroundColor, 16),
          };
        }
        let key = subWindow.key;
        if (key === "PeopleCounting Prompt") {
          key = "peopleConting";
        } else if (key === "Temperature Prompt") {
          key = "Temperature";
        } else if (key === "Mask MaskIcon") {
          key = "MaskIcon";
        } else if (key === "Temperature TemperatureIcon") {
          key = "TemperatureIcon";
        } else if (key === "WearMask MaskIcon") {
          key = "WearMaskIcon";
        } else if (key === "NormalTemperature Prompt") {
          key = "NormalTemperaturePrompt";
        } else if (key === "NormalTemperature TemperatureIcon") {
          key = "NormalTemperatureIcon";
        }
        aSubWindowInfo[key] = oEventSubParam;
      });
      Object.assign(
        oWindowInfo.EventParam,
        this.creatEventParam(window, aSubWindowInfo)
      );
    } else if (windowMode === "signIn") {
      oWindowInfo.SignIn = {
        backPicId: window.backgroundPic,
      };
      //const aHeadStr = ["MainTitle", "SubTitle", "ShowInfo", "NormalTemperatureText", "NormalTemperatureIcon", "AbnormalTemperatureText", "AbnormalTemperatureIcon"];
      let aSubWindowInfo = {};

      window.subWindows.forEach((subWindow) => {
        let oSignInSubParam = {
          Position: {
            positionX: Math.round((subWindow.x * 1920) / programWidth),
            positionY: Math.round((subWindow.y * 1920) / programHeight),
            height: Math.round((subWindow.height * 1920) / programHeight),
            width: Math.round((subWindow.width * 1920) / programWidth),
          },
        };
        if (
          [
            "MainTitle",
            "NormalTemperature PeopleNumber",
            "NormalTemperature Icon",
            "AbnormalTemperature PeopleNumber",
            "AbnormalTemperature Icon",
            "signIn_time",
          ].includes(subWindow.key)
        ) {
          oSignInSubParam.enabled = true;
        }
        if (
          ["SubTitle", "signIn_logo", "signIn_zimu"].includes(subWindow.key)
        ) {
          oSignInSubParam.enabled = !!subWindow.enabled;
        }
        if ("ShowInfo" === subWindow.key) {
          oSignInSubParam.row = subWindow.row;
          oSignInSubParam.column = subWindow.column;
          oSignInSubParam.inLib = {};
          //const signinLibsList = ['nameEnabled', 'genderEnabled', 'signInTimeEnabled', 'temperatureEnabled', 'selfDefine1Enabled', 'selfDefine2Enabled'];
          window.signinLibs.forEach((item) => {
            oSignInSubParam.inLib[item.key] = item.enabled;
          });
          //TODO:下个版本放开，默认性别传false
          // oSignInSubParam.inLib.genderEnabled = false;
          oSignInSubParam.outLib = {};
          //const signoutLibsList = ['nameEnabled', 'genderEnabled', 'signInTimeEnabled', 'temperatureEnabled'];
          window.signoutLibs.forEach((item) => {
            oSignInSubParam.outLib[item.key] = item.enabled;
          });
          //TODO:下个版本放开，默认性别传false
          // oSignInSubParam.outLib.genderEnabled = false;
          oSignInSubParam.outLib.name = window.outLibName;
          window.showDuration &&
            (oSignInSubParam.showDuration = window.showDuration);
        }
        if (
          [
            "MainTitle",
            "SubTitle",
            "NormalTemperature PeopleNumber",
            "AbnormalTemperature PeopleNumber",
            "signIn_time",
            "signIn_zimu",
          ].includes(subWindow.key)
        ) {
          oSignInSubParam.fontSize = subWindow.fontSize;
          oSignInSubParam.FontColor = {
            RGB: oUtils.transformRgb(subWindow.fontColor, 16),
          };
          oSignInSubParam.text = subWindow.content;
        }
        if (
          [
            "NormalTemperature Icon",
            "AbnormalTemperature Icon",
            "signIn_logo",
          ].includes(subWindow.key)
        ) {
          oSignInSubParam.materialNo = subWindow.icon;
        }
        if (["signIn_zimu"].includes(subWindow.key)) {
          oSignInSubParam.rolling_direction = subWindow.rolling_direction;
        }
        aSubWindowInfo[subWindow.key] = oSignInSubParam;
      });
      Object.assign(oWindowInfo.SignIn, this.creatSigninParam(aSubWindowInfo));
    } else if (windowMode === "conference") {
      // 会议签到数据组装
      let oCfg = window.cfg;
      oWindowInfo.ConferenceParam = {
        backPicId: window.backgroundPic,
        VoiceBroadcast: {
          enabled: oCfg.voiceBroadcastEnable,
          broadcastSpeed: oCfg.broadcastSpeed,
          inLibVoice: oCfg.inLibVoice,
          outLibVoice: oCfg.outLibVoice,
        },
        WelcomeWord: {
          enabled: oCfg.welcomeWordEnable,
          inLibWord: oCfg.inLibWord,
          outLibWord: oCfg.outLibWord,
        },
      };
      let aSubWindowInfo = {};
      let moduleInfoList = [];
      window.subWindows.forEach((subWindow) => {
        let oSignInSubParam = {};
        let positionObj = {};
        if (
          [
            "Title",
            "ShowInfo",
            "conferenceTime",
            "conferenceSite",
            "conferenceStatus",
            "signInPersonNum",
            "totalPersonNum",
            "unSignInPersonNum",
            "signInAndTotalPersonNum",
          ].includes(subWindow.key)
        ) {
          if (oProgramInfo.cannotTransform) {
            positionObj = {
              positionX: subWindow.x,
              positionY: subWindow.y,
              height: subWindow.height,
              width: Math.round((subWindow.width * 1920) / programWidth),
            };
          } else {
            positionObj = {
              positionX: Math.round((subWindow.x * 1920) / programWidth),
              positionY: Math.round((subWindow.y * 1920) / programHeight),
              height: Math.round((subWindow.height * 1920) / programHeight),
              width: Math.round((subWindow.width * 1920) / programWidth),
            };
          }
        }
        if (["Title"].includes(subWindow.key)) {
          oSignInSubParam.enabled = true;
          oSignInSubParam.fontSize = subWindow.fontSize;
          oSignInSubParam.FontColor = {
            RGB: oUtils.transformRgb(subWindow.fontColor, 16),
          };
          oSignInSubParam.text = subWindow.content
            ? subWindow.content.trim()
            : "";
          oSignInSubParam.Position = positionObj;
        }

        if ("ShowInfo" === subWindow.key) {
          oSignInSubParam.row = subWindow.row;
          oSignInSubParam.column = subWindow.column;
          oSignInSubParam.Position = positionObj;
          oSignInSubParam.inLib = {
            nameEnabled: subWindow.nameEnabled,
          };
        }

        if (
          [
            "conferenceTime",
            "conferenceSite",
            "conferenceStatus",
            "signInPersonNum",
            "totalPersonNum",
            "unSignInPersonNum",
            "signInAndTotalPersonNum",
          ].includes(subWindow.key)
        ) {
          let moduleInfo = {};
          moduleInfo.enabled = true;
          moduleInfo.fontSize = subWindow.fontSize;
          moduleInfo.FontColor = {
            RGB: oUtils.transformRgb(subWindow.fontColor, 16),
          };
          moduleInfo.moduleType = subWindow.key;
          moduleInfo.text = subWindow.content || "";
          moduleInfo.Position = positionObj;
          if (subWindow.backPicId) {
            moduleInfo.backPicId = subWindow.backPicId;
          }
          moduleInfoList.push({ ModuleInfo: moduleInfo });
        } else {
          aSubWindowInfo[subWindow.key] = oSignInSubParam;
        }
      });
      aSubWindowInfo.ModuleInfoList = moduleInfoList;
      Object.assign(oWindowInfo.ConferenceParam, aSubWindowInfo);
    } else if (windowMode === "dataSource") {
      const flag = window.sourceId && window.sourceId !== -1;
      if (!flag) {
        szErrorTip = i18n.t("program_source_id_tip");
      } else {
        oWindowInfo.DataSource = {
          dataSourceUUID: window.sourceId?.split("_")[0],
          sourceType: window.tripartiteType,
          materialNo: Number(window.sourceId?.split("_")[1]),
        };
        if (dataType === "table") {
          iPageWndDurationTotal += 10;
          let emptyFlag = false;
          oWindowInfo.Call = {
            tableRow: window.sourceRow,
            tableColumn: window.sourceColumn,
            tableDirection: window.sourceTableDirection,
            tableType: `template${window.sourceTemplate}`,
            backPicId: window.backgroundPic,
            alignType: window.sourceTables[0].alignType,
            verticaAlignType: window.sourceTables[0].verticaAlignType,
            playType: window.sourcePlayMode,
            HeadDataList: [], //标题data
            ItemStyleList: [], //每列样式
            refreshDirection: "downToup", //表格刷新方向
          };
          window.sourceTables.forEach((item) => {
            oWindowInfo.Call.HeadDataList.push({
              HeadData: {
                id: item.lineIndex,
                data: item.name,
              },
            });
            oWindowInfo.Call.ItemStyleList.push({
              ItemStyle: {
                id: item.lineIndex,
                width: item.emptyRate,
                fontSize: item.fontSize,
                FontColor: {
                  RGB: oUtils.transformRgb(item.fontColor, 16),
                },
                BackColor: {
                  RGB: oUtils.transformRgb(item.background, 16),
                },
              },
            });
            if (!item.name) {
              emptyFlag = true;
            }
          });
          if (emptyFlag) {
            szErrorTip = i18n.t("program_source_name_tip");
          }
        } else if (dataType === "character") {
          // 圆角 、 旋转度
          oWindowInfo.rotateDegree = window.rotate || 0;
          oWindowInfo.filletedCornerDegree = window.borderRadius || 0;

          oWindowInfo.CharactersAttribute = {
            characterContent: window.characterContent
              ? window.characterContent
              : i18n.t("program_type_character"), // 文字内容
            fontSize: window.fontSize, // 字体大小
            FontColor: {
              RGB: oUtils.transformRgb(window.fontColor, 16), //字体颜色
            },
            BackColor: {
              RGB: oUtils.transformRgb(window.backgroundColor, 16), // 背景颜色
            },
            fontType: window.characterStyle, // 字体类型
            strikethroughEnabled: window.strikethroughEnabled, // 文字删除线
            backTransparent: Math.ceil(window.backTransparent * 255), // 背景透明度
            alignType: window.alignType, // 水平对齐方式
            verticaAlignType: window.verticaAlignType, // 垂直对齐方式
            AnimationEffectList: window.AnimationEffectList,
            fontShadow: window.fontShadow,
          };
          parseInt(window.fontFamily, 10) !== -1 &&
            Object.assign(oWindowInfo.CharactersAttribute, {
              materialID: parseInt(window.fontFamily, 10),
            });

          const fbParams = {
            characterBorderList: [],
          };
          // 文字窗口边框
          if (
            window.fontBorderStyle &&
            JSON.stringify(window.fontBorderStyle) !== "{}"
          ) {
            const { size, style, color } = window.fontBorderStyle;
            const styleMap = {
              solid: 1,
              dashed: 2,
              pointsDotted: 3,
            };
            const TypeList = ["left", "right", "top", "bottom"];
            TypeList.forEach((type) => {
              fbParams.characterBorderList.push({
                characterBorder: {
                  borderType: type,
                  borderDegree: size,
                  borderColor: {
                    RGB: oUtils.transformRgb(color, 16),
                  },
                  borderStyle: styleMap[style],
                },
              });
            });
          }
          // 是否启用文字删除线 -- 只做透传
          if (window.strikethroughEnabled !== undefined) {
            fbParams.strikethroughEnabled = window.strikethroughEnabled;
          }
          // 文本阴影
          const shadowParams = {
            fontShadow: {},
          };
          if (window.fontShadow && JSON.stringify(window.fontShadow) !== "{}") {
            const {
              enabled,
              shadowRadiusX,
              shadowRadiusY,
              shadowTransparent,
              shadowColor,
            } = window.fontShadow;
            shadowParams.fontShadow = {
              enabled,
              shadowRadiusX: shadowRadiusX * 2,
              shadowRadiusY: shadowRadiusY * 2,
              shadowTransparent: Math.ceil(shadowTransparent * 255),
              shadowColor: oUtils.transformRgb(shadowColor, 16),
            };
          }
          // 文本渐变
          const fontGradientParams = {
            fontGradient: {},
          };
          if (
            window.fontGradient &&
            JSON.stringify(window.fontGradient) !== "{}"
          ) {
            const {
              enabled,
              startTransparent,
              startColor,
              endTransparent,
              endColor,
              gradientDirection,
            } = window.fontGradient;
            fontGradientParams.fontGradient = {
              enabled,
              gradientDirection,
              startTransparent: Math.ceil(startTransparent * 255),
              startColor: oUtils.transformRgb(startColor, 16),
              endTransparent: Math.ceil(endTransparent * 255),
              endColor: oUtils.transformRgb(endColor, 16),
            };
          }
          // 文本描边
          const borderParams = {
            fontBorder: {},
          };
          if (window.fontBorder && JSON.stringify(window.fontBorder) !== "{}") {
            const { enabled, borderDegree, borderColor, borderTransparent } =
              window.fontBorder;
            borderParams.fontBorder = {
              enabled,
              borderDegree,
              borderTransparent: Math.ceil(borderTransparent * 255),
              borderColor: oUtils.transformRgb(borderColor, 16),
            };
          }

          // 滚动设置
          const rdParams =
            window.rollingDirection && !window.AnimationEffectList?.length
              ? {
                scrollDirection: window.rollingDirection,
                scrollSpeed: window.scrollSpeed,
                characterLineType:
                  window.rollingDirection === "up"
                    ? "multiLines"
                    : "singleLine",
                characterSingleLineAnimation: "marquee",
              }
              : {
                characterLineType: "multiLines",
              };

          Object.assign(
            oWindowInfo.CharactersAttribute,
            rdParams,
            fbParams,
            shadowParams,
            borderParams,
            fontGradientParams
          );
          // 限制文字窗口长度
          // TODO 看看是怎么个规则
          // const characterMaxLen = 512;
          // if (oUtils.lengthw(window.characterContent) > characterMaxLen) {
          //   szErrorTip = i18n
          //     .t("program_var_charater_length_tips")
          //     .replace("%s", characterMaxLen);
          // }
        } else if (dataType === "chart") {
          iPageWndDurationTotal += 10;
          let emptyFlag = false;
          oWindowInfo.ChartData = {
            chartType: window.sourceTemplate === "1" ? "histogram" : "pieChart",
            backPicId: window.backgroundPic,
            HeadDataList: [],
          };
          window.sourceTables.forEach((item, index) => {
            emptyFlag = emptyFlag || !item.name;
            oWindowInfo.ChartData.HeadDataList.push({
              HeadData: {
                id: item.lineIndex,
                data: item.name,
                headType: index % 2 === 0 ? "axis" : "value",
              },
            });
          });
          if (emptyFlag) {
            szErrorTip = i18n.t("program_source_name_tip");
          }
        } else if (dataType === "pic") {
          oWindowInfo.rotateDegree = window.rotate || 0;
          oWindowInfo.filletedCornerDegree = window.borderRadius || 0;
          // 三方的动态图片 微动效 没有playItem 只能再定一个字段
          oWindowInfo.DataSource.AnimationEffectList =
            window.AnimationEffectList;
        }
      }
    } else if (windowMode === "RSS") {
      if (!window.rssUrl) {
        szErrorTip = i18n.t("program_rss_none_tip");
      }
      iPageWndDurationTotal += 10;
      oWindowInfo.RSS = {
        RSSURL: window.rssUrl,
        backColor: oUtils.transformRgb(window.backgroundColor, 16),
        backTransparent: Math.ceil(
          ((100 - window.backTransparent) / 100) * 255
        ),
        pageIntervalTime: window.rssPageTime,
      };
      if (window.rollingDirection) {
        oWindowInfo.RSS.playMode = "scroll";
        oWindowInfo.RSS.scrollDirection = window.rollingDirection;
        oWindowInfo.RSS.scrollSpeed = window.scrollSpeed;
      } else {
        oWindowInfo.RSS.playMode = "turnPage";
      }

      if (window.subWindows?.length) {
        oWindowInfo.RSS.RSSElementList = [];
        oWindowInfo.RSS.elementRectList = [];
        let aHeadStr = ["icon", "title", "date", "content"];
        // 配置参数
        [window.subWindows[0], ...window.subWindows[1].subWindows].forEach(
          (subWindow, i) => {
            const params = {
              RSSElementType: aHeadStr[i],
              elementHideEnabled: !subWindow.enable,
            };
            if (i === 3) {
              oWindowInfo.RSS.updateInterval = subWindow.interval; // 刷新间隔
            }
            // 除图标的配置
            if (i !== 0) {
              params.fontSize = this.calculateFontSize(subWindow.fontSize);
              params.fontColor = oUtils.transformRgb(subWindow.fontColor, 16);
              params.alignType = subWindow.alignType;
            }

            oWindowInfo.RSS.RSSElementList.push(params);
          }
        );
      }
      // 位置信息
      const rectArr = ["icon", "content"];
      window.subWindows.forEach((subWindow, i) => {
        let height = Math.round((subWindow.height * 1920) / programHeight);
        let width = Math.round((subWindow.width * 1920) / programWidth);
        let positionX = Math.round((subWindow.x * 1920) / programWidth);
        let positionY = Math.round((subWindow.y * 1920) / programHeight);
        if (bResolutionCoordinate) {
          height = Math.round(subWindow.height);
          width = Math.round(subWindow.width);
          positionX = Math.round(subWindow.x);
          positionY = Math.round(subWindow.y);
        }

        oWindowInfo.RSS.elementRectList.push({
          elementRectType: rectArr[i],
          rect: {
            x: positionX,
            y: positionY,
            height,
            width,
          },
        });
      });
    } else if (windowMode === "signalSource") {
      oWindowInfo.PlayItemList = [
        {
          PlayItem: {
            id: 1,
            SignalSource: {
              signalSourceType: window.signalSourceType,
              signalSourceSubTypeId: window.signalSourceSubTypeId,
              name: window.signalSourceName,
            },
          },
        },
      ];
    }
    // 背景图也加入到列表中
    window.backgroundPic && materialList.push(window.backgroundPic);
    //组装窗口跳转信息
    let aTouchTypes = [
      "character",
      "picture",
      // "document",
      // "pdf",
      ...constant.DOCUMENT_TYPES,
      "web",
      "video",
      "hyperlinkBtn",
      "dataSource",
    ];
    if (aTouchTypes.includes(windowMode)) {
      oWindowInfo.TouchProperty = {
        windType: window.windowType,
      };
      if (
        window.hyperlinkType !== "no" &&
        !window.AnimationEffectList?.length
      ) {
        oWindowInfo.TouchProperty.hyperlinkType = window.hyperlinkType;
        "window" === window.hyperlinkType &&
          (oWindowInfo.TouchProperty.windowId = window.hyperlinkWndId);
        "page" === window.hyperlinkType &&
          (oWindowInfo.TouchProperty.pageId = window.hyperlinkPageId);
      }
    }
    // 特殊标记 用于考勤
    if (window.windowApplication) {
      oWindowInfo.windowApplication = window.windowApplication;
    }
    return {
      oWindowInfo,
      szErrorTip,
      iPageWndDurationTotal,
      iVoiceOpenNum,
    };
  }

  //计算字体的最大、最小值
  calculateFontSize (fontSize) {
    fontSize = Math.round(fontSize);
    if (fontSize > 400) {
      fontSize = 400;
    } else if (fontSize < 30) {
      fontSize = 30;
    }
    return fontSize;
  }

  //根据节目id获取节目信息
  async getProgramById (programId, vm, programData = null) {
    // let oWait = oResponse.getWaitInstance(i18n.t("loading"));
    let loadingInstance = Loading.service({
      background: "rgba(255, 255, 255, 0.5)",
    });
    // let resJson = await oWebSdk.WSDK_GetDeviceConfig(
    //   "operateSingleShow",
    //   {
    //     id: programId,
    //   },
    //   {
    //     showLoading: true,
    //     errorResponse: () => {
    //       // 异常错误提示
    //       if (showErrorTips) {
    //         return false;
    //       }
    //     },
    //   }
    // );
    let resJson = {}
    if (programData) {
      let data = JSON.parse(JSON.stringify(programData))
      const { materialInfoList } = data
      const { pictureList, videoList, documentList, audioList } = materialInfoList
      data.materialInfoList = [...pictureList, ...videoList, ...documentList, ...audioList].filter(item => item.deleteStatus !== 1)
      resJson = {
        code: "200",
        data: data,
        message: "Success",
        success: true
      };
    } else {
      resJson = await programApi.getProgram({
        programId,
      });
    }
    console.log("resJson", resJson);

    loadingInstance.close();
    if (!resJson || !resJson?.data) {
      // oWait && oWait.close();
      // return false;
      return resJson
    }
    let materialInfoList = resJson?.data?.materialInfoList || [];
    let materialList = materialInfoList.map(item => item.materialId)
    // let materialList = (resJson?.data.materialList) ? (resJson?.data.materialList.split(",")) : [];
    let oProgramInfo = JSON.parse(resJson?.data.programContext);
    // 第一次新建的节目中没有programId
    oProgramInfo.id = programId;
    this.programContextInit = JSON.stringify(oProgramInfo);
    // let oProgramInfo = resJson?.Data.Program;
    let pageList = [];
    let pageItems = oProgramInfo.PageList;
    let programType = oProgramInfo.programType;
    let applicationType = oProgramInfo.applicationType;
    for (let page of pageItems) {
      let PageBasicInfo = page.Page.PageBasicInfo;
      let backgroundPic = PageBasicInfo.backgroundPic;
      let backgroundPicType = PageBasicInfo.backgroundPicType;
      // TODO 背景图名称
      // let backgroundPicName = await this.getBackgroundName(backgroundPic);
      let backgroundPicDeleteFlag = !!backgroundPic && !materialList.includes(backgroundPic)

      let playDurationMode = PageBasicInfo.playDurationMode;
      // // 考勤参数默认值
      // let signInCfg = {
      //   voiceBroadcastEnable: false, //语音播报
      //   broadcastSpeed: "", //播报语速
      //   inLibVoice: "", //在库人员语音播报内容
      //   outLibVoice: "", //未知人员语音播报内容
      //   welcomeWordEnable: false, //是否启用欢迎词
      //   inLibWord: "", //在库人员欢迎词内容
      //   outLibWord: "", //未知人员欢迎词内容
      //   bSupportTemplateThreshold: false, //是否支持温度
      //   templateThreshold: "", //正常温度值
      // };
      // if (PageBasicInfo.SignInCfg) {
      //   signInCfg = {
      //     voiceBroadcastEnable: PageBasicInfo.SignInCfg.VoiceBroadcast.enabled,
      //     broadcastSpeed: PageBasicInfo.SignInCfg.VoiceBroadcast.broadcastSpeed,
      //     inLibVoice: PageBasicInfo.SignInCfg.VoiceBroadcast.inLibVoice,
      //     outLibVoice: PageBasicInfo.SignInCfg.VoiceBroadcast.outLibVoice,
      //     welcomeWordEnable: PageBasicInfo.SignInCfg.WelcomeWord.enabled,
      //     inLibWord: PageBasicInfo.SignInCfg.WelcomeWord.inLibWord,
      //     outLibWord: PageBasicInfo.SignInCfg.WelcomeWord.outLibWord,
      //     // templateThreshold: PageBasicInfo.SignInCfg.TemperatureDetection.threshold,
      //     inLibAbnormalTemperatureVoice:
      //       PageBasicInfo.SignInCfg.VoiceBroadcast
      //         .inLibAbnormalTemperatureVoice,
      //     outLibAbnormalTemperatureVoice:
      //       PageBasicInfo.SignInCfg.VoiceBroadcast
      //         .outLibAbnormalTemperatureVoice,
      //     bSupportTemplateThreshold:
      //       !!PageBasicInfo.SignInCfg.TemperatureDetection,
      //   };
      //   signInCfg.templateThreshold = signInCfg.bSupportTemplateThreshold
      //     ? PageBasicInfo.SignInCfg.TemperatureDetection.threshold
      //     : "";
      // }
      // 设置为是编辑
      oProgramInfo.isEdit = true;
      pageList.push({
        pageId: page.Page.id,
        templateId: PageBasicInfo.templateId,
        pageName: PageBasicInfo.pageName,
        backgroundColor: oUtils.transformRgb(PageBasicInfo.BackgroundColor.RGB),
        playDurationMode:
          playDurationMode === "loop" ? "programLoop" : playDurationMode, //播放时间类型
        playDuration:
          PageBasicInfo.playDuration ||
          (this.oPageCap?.oPageDefParam?.iDefPagePlayDuration ?? 10),
        // (this.oPageCap?.oPageDefParam?.iDefPagePlayDuration ?? 60),
        playCount: PageBasicInfo.playCount || 1, //播放次数
        switchEffect: PageBasicInfo.switchEffect || "none", // 切换效果
        animationBlockType: PageBasicInfo.animationBlockType || "null", // 特效
        backgroundPic: backgroundPic, //背景图片id
        backgroundType: backgroundPicType,
        // TODO
        // backgroundPicName: backgroundPicName, //背景图片名称
        backgroundPicDeleteFlag: backgroundPicDeleteFlag, //背景图片是否删除
        windowList: await this.getWindows(
          page.Page.WindowsList,
          "",
          oProgramInfo,
          vm,
          0,
          materialInfoList
        ), //窗口列表
        // signInCfg: signInCfg, // 考勤配置
        ModuleInfoList: PageBasicInfo.CascadeInfo
          ? PageBasicInfo.CascadeInfo.ModuleInfoList
          : [],
        layoutWindowList: this.getLayoutWindow(
          page.Page?.TemplateLayoutWindowList || [],
          oProgramInfo
        ), //布局模板列表
        layoutActiveId: -1,
        backStack: [],
        forwardStack: [],
        layoutAndWindow: {},
      });
      const { windowList, layoutAndWindow } = pageList[pageList.length - 1];
      const layoutWindowList = this.getLayoutWindow(
        page.Page?.TemplateLayoutWindowList || [],
        oProgramInfo,
        true
      );
      const notIncludesWindows = constant.LAYOUT_FREE_WINDOWS;
      if (layoutWindowList.length) {
        windowList.forEach((window) => {
          layoutWindowList.some((layout) => {
            //坐标来回转换有误差，在误差范围内说明在布局模板中
            if (
              window.dataType !== "character" &&
              !notIncludesWindows.includes(window.windowMode) &&
              Math.abs(window.x - layout.x) < 5 &&
              Math.abs(window.y - layout.y) < 5
            ) {
              layoutAndWindow[window.windowId] = layout.id - 1;
              return true;
            }
            return false;
          });
        });
        // console.error(layoutAndWindow);
      }
    }
    // oWait && oWait.close(); //可能会有问题，如果获取节目失败，暂不考虑

    // // 获取当前节目的所有素材的有效期时间
    // try {
    //   const res = await Promise.all(Object.values(this.materialValidyMap));
    //   Object.keys(this.materialValidyMap).forEach((key, index) => {
    //     this.materialValidyMap[key] = res[index];
    //   });

    //   for (let page of pageList ?? []) {
    //     for (let window of page?.windowList ?? []) {
    //       for (let material of window?.materialList ?? []) {
    //         material.validityTime =
    //           this.materialValidyMap[material.materialId] || "";
    //       }
    //     }
    //   }

    //   this.materialValidyMap = {};
    //   this.materialNameMap = {};
    // } catch (error) {
    //   console.log(error);
    // }

    return {
      programId: programId,
      programName: oProgramInfo.programName, //节目名称
      resolutionName: oProgramInfo.Resolution.resolutionName,
      resolution: oProgramInfo.Resolution.resolutionName,
      programWidth: oProgramInfo.Resolution.imageWidth,
      programHeight: oProgramInfo.Resolution.imageHeight,
      groupId: oProgramInfo.groupId, //组织编号
      groupIdPath: oProgramInfo.groupIdPath, //组织编号
      // orgId: oProgramInfo.orgNo, //组织编号
      shareProperty: oProgramInfo.shareProperty, //共享属性
      programRemarks: oProgramInfo.programRemarks, //节目描述
      approveState: oProgramInfo.approveState, //是否自动审核 approved\notApprove
      coordinateType: oProgramInfo.coordinateType, //是否归一化坐标
      programType: programType,
      applicationType: applicationType,
      pageList: pageList,
      CascadeSize: oProgramInfo.CascadeSize,
      programDeviceType: constant.DEVICE_TYPE_MAP[oProgramInfo.mode],
      AddAttribute: oProgramInfo.AddAttribute,
    };
  }

  //修改窗口和获取模板窗口时,获取窗口 aWindowListData-窗口的json screenType-屏幕类型（模板才有） template-为了app获取节目宽、高(协议的坑)
  // TemplateId 模板获取时的id
  async getWindows (aWindowListData, screenType, template, vm, TemplateId = 0, materialInfoList = []) {
    const materialList = materialInfoList.map(item => item.materialId)
    let windowList = [];
    let aSupportLink = [
      "character",
      "picture",
      // "document",
      // "pdf",
      ...constant.DOCUMENT_TYPES,
      "web",
      "video",
      "hyperlinkBtn",
      "call",
      "chart",
    ]; //是否支持链接跳转
    let aSupportMaterial = [
      "picture",
      // "document",
      // "pdf",
      ...constant.DOCUMENT_TYPES,
      "video",
      "audio",
      "web",
      "realStream",
    ]; //是否支持素材

    // 处理下考勤logo默认值的情况
    const logoIndex = aWindowListData.findIndex(
      (item) => item?.TemplateWindows?.windowApplication === "attendanceLogo"
    ); // 模板中获取
    const logoIndex1 = aWindowListData.findIndex((item) =>
      item?.Windows?.windowApplication?.includes("logoid")
    ); //  编辑时节目中获取
    let signInLogo_def = 0;
    if (TemplateId && logoIndex + 1) {
      const pList = aWindowListData[logoIndex]?.TemplateWindows?.PlayItemList;
      signInLogo_def = pList && (pList[0]?.PlayItem?.materialNo ?? 0);
      if (signInLogo_def) {
        aWindowListData.splice(logoIndex, 1);
      }
    } else if (!TemplateId && logoIndex1 + 1) {
      const arr =
        aWindowListData[logoIndex1].Windows?.windowApplication?.split("&");
      if (arr?.length > 1 && arr[1].includes("logoid")) {
        signInLogo_def = parseInt(arr[1], 10);
      }
    }

    for (let templateWindow of aWindowListData) {
      let oWindowInfo =
        templateWindow.TemplateWindows || templateWindow.Windows;
      let window = {};
      window.uuid = uuidv4();
      window.windowId = oWindowInfo.id;
      if ("static" === oWindowInfo.WinMaterialInfo.materialType) {
        window.windowMode = oWindowInfo.WinMaterialInfo.staticMaterialType;
      } else if ("dynamic" === oWindowInfo.WinMaterialInfo.materialType) {
        window.windowMode = oWindowInfo.WinMaterialInfo.dynamicType; // xml时用了.trim()去首尾空格，json暂时未发现有空格现象，先不加
      } else if ("multiType" === oWindowInfo.WinMaterialInfo.materialType) {
        window.windowMode =
          oWindowInfo.WinMaterialInfo.staticMaterialType ||
          oWindowInfo.WinMaterialInfo.dynamicType ||
          oWindowInfo.WinMaterialInfo.otherType;
      } else {
        const bigger = ["rss"];
        window.windowMode = bigger.includes(
          oWindowInfo.WinMaterialInfo.otherType
        )
          ? oWindowInfo.WinMaterialInfo.otherType.toUpperCase()
          : oWindowInfo.WinMaterialInfo.otherType;
      }
      let windowMode = window.windowMode; //窗口模式
      window.windowName = window.windowId + "-" + i18n.t(windowMode);
      window.className = windowMode + "-window" + window.windowId;
      if (windowMode === "app" || windowMode === "zip") {
        //app类型宽度、高度等于分辨率本身
        window.width = window.defWidth = template.Resolution
          ? template.Resolution.imageWidth
          : 0;
        window.height = window.defHeight = template.Resolution
          ? template.Resolution.imageHeight
          : 0;
        /* TODO xml写法先保留，无app 窗口模板，先按照节目json格式实现 */
        // window.width = window.defWidth =   oUtils.nodeValue(xmlDoc, "imageWidth", "i");
        // window.height = window.defHeight = oUtils.nodeValue(xmlDoc, "imageHeight", "i");
      } else if (windowMode === "event" || windowMode === "conference") {
        window.width = window.defWidth = 1920;
        window.height = window.defHeight = 1920;
      } else {
        window.width = window.defWidth = oWindowInfo.Position.width;
        window.height = window.defHeight = oWindowInfo.Position.height;
      }
      window.x = oWindowInfo.Position.positionX;
      window.y = oWindowInfo.Position.positionY;
      window.z = oWindowInfo.layerNo;
      //如果是模板，优先显示素材选择
      if (screenType && aSupportMaterial.includes(windowMode)) {
        // window.showState = 3;
        window.showState = 2; //现在素材和模板显示一致了，所以不存在3了
      } else {
        window.showState = 2;
      }
      //展示触摸屏下的超链接信息
      if (aSupportLink.includes(windowMode)) {
        let oTouchProperty = oWindowInfo.TouchProperty || {};
        window.windowType = oTouchProperty.windType || "page";
        window.hyperlinkType = oTouchProperty.hyperlinkType || "no";
        window.hyperlinkPageId = oTouchProperty.pageId || -1;
        window.hyperlinkWndId = oTouchProperty.windowId || -1;
      }
      if (windowMode === "dynamicPic") {
        //++后面优化下
        let material = {};
        material.materialId = oWindowInfo.DataSource.materialNo;
        let materialInfo = await this.getMaterialById(material.materialId);
        material.materialName = materialInfo.name;
        material.index = 1;
        material.src = oMaterialService.getMaterialThumbnail(
          material.materialId,
          windowMode
        );
        window.materialList = [material];
        window.backgroundPic = oWindowInfo.DynamicPic.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.style = {
          background: "url(" + material.src + ") no-repeat",
          "background-size": "100% 100%",
        };
      } else if (windowMode === "capturePic") {
        let material = {};
        material.materialId = oWindowInfo.CapturePic.ipcMaterialNo;
        let materialInfo = await this.getMaterialById(material.materialId);
        material.materialName = materialInfo.name;
        material.index = 1;
        material.src = oMaterialService.getMaterialThumbnail(
          material.materialId,
          windowMode
        );
        window.materialList = [material];
        window.backgroundPic = oWindowInfo.CapturePic.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.cancelType = oWindowInfo.CapturePic.cancelType;
        window.duration = oWindowInfo.CapturePic.duration;
        window.style = {
          background: "url(" + material.src + ") no-repeat",
          "background-size": "100% 100%",
        };
      } else if (windowMode === "app" || windowMode === "zip") {
        let material = {};
        material.materialId =
          oWindowInfo.AppWindow.WindowInfoList[0].WindowInfo.materialNo;
        let materialInfo = await this.getMaterialById(material.materialId);
        material.materialName = materialInfo.name;
        material.index = 1;
        material.src = oMaterialService.getMaterialThumbnail(
          material.materialId,
          windowMode
        );
        window.materialList = [material];
        window.style = {
          background: "url(" + material.src + ") no-repeat",
          "background-size": "100% 100%",
        };
      } else if (windowMode === "hyperlinkBtn") {
        window.backgroundPic = oWindowInfo.HyperlinkBtn.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
      } else if (
        windowMode === "character" &&
        oWindowInfo.DataSource?.dataSourceUUID
      ) {
        //三方数据动态文字
        window.windowName =
          window.windowId + "-" + i18n.t("program_type_character");
        window.windowMode = "dataSource";
        window.dataType = "character";
        window.tripartiteType = oWindowInfo.DataSource.sourceType;
        window.sourceId = `${oWindowInfo.DataSource.dataSourceUUID}_${oWindowInfo.DataSource.materialNo}`;

        // 如果模板中有配置使用多语言则需要转化多语言
        window.characterContent = oWindowInfo.CharactersAttribute.useLanguage
          ? i18n.t(
            "program_" + oWindowInfo.CharactersAttribute.characterContent
          )
          : oWindowInfo.CharactersAttribute.characterContent; // 文字消息内容
        // window.characterContent = oWindowInfo.CharactersAttribute.characterContent; // 文字消息内容
        // "动态文本"不显示
        // window.characterContent === i18n.t('program_type_character') && (window.characterContent = "");
        window.fontSize = oWindowInfo.CharactersAttribute.fontSize; // 文字字体大小
        window.fontColor = oUtils.transformRgb(
          oWindowInfo.CharactersAttribute.FontColor.RGB
        );
        window.showTextColor = window.fontColor;

        window.backgroundColor = oUtils.transformRgb(
          oWindowInfo.CharactersAttribute.BackColor.RGB
        );
        window.backTransparent =
          Math.ceil(
            100 -
            ((255 - oWindowInfo.CharactersAttribute.backTransparent) / 255) *
            100
          ) / 100; // 背景透明度
        window.showBackgroundColor =
          window.backTransparent === 1
            ? window.backgroundColor
            : oUtils.getColor(window.backgroundColor, window.backTransparent);

        window.characterStyle = oWindowInfo.CharactersAttribute.fontType; // 文字字体类型
        window.strikethroughEnabled =
          oWindowInfo.CharactersAttribute.strikethroughEnabled; // 文字删除线
        window.alignType = oWindowInfo.CharactersAttribute.alignType; // 文字对齐方式
        window.verticaAlignType =
          oWindowInfo.CharactersAttribute.verticaAlignType; // 文字对齐方式
        // 字体阴影
        if (oWindowInfo.CharactersAttribute?.fontShadow) {
          const {
            enabled = false,
            shadowTransparent = 255,
            shadowColor = 16777215,
            shadowRadiusX = 4,
            shadowRadiusY = 1,
          } = oWindowInfo.CharactersAttribute.fontShadow;
          window.fontShadow = {
            enabled,
            shadowRadiusX: shadowRadiusX / 2 || 1,
            shadowRadiusY: shadowRadiusY / 2 || 1,
            shadowTransparent:
              Math.ceil(100 - ((255 - shadowTransparent) / 255) * 100) / 100,
            shadowColor: oUtils.transformRgb(shadowColor),
            showShadowColor: "",
          };
          window.fontShadow.showShadowColor =
            window.fontShadow.shadowTransparent === 1
              ? window.fontShadow.shadowColor
              : oUtils.getColor(
                window.fontShadow.shadowColor,
                window.fontShadow.shadowTransparent
              );
        } else {
          window.fontShadow = {
            enabled: false,
            shadowRadiusX: 2,
            shadowRadiusY: 2,
            shadowTransparent: 1,
            shadowColor: "#000000",
            showShadowColor: "#000000",
          };
        }
        // 文字渐变
        if (oWindowInfo.CharactersAttribute?.fontGradient) {
          const {
            enabled = false,
            gradientDirection = "horizontal",
            startTransparent = 255,
            startColor = 16777215,
            endTransparent = 255,
            endColor = 16777215,
          } = oWindowInfo.CharactersAttribute.fontGradient;
          window.fontGradient = {
            enabled,
            startTransparent:
              Math.ceil(100 - ((255 - startTransparent) / 255) * 100) / 100,
            startColor: oUtils.transformRgb(startColor),
            endTransparent:
              Math.ceil(100 - ((255 - endTransparent) / 255) * 100) / 100,
            endColor: oUtils.transformRgb(endColor),
            gradientDirection,
          };
          window.showTextColor = !window.fontGradient.enabled
            ? window.fontColor
            : `linear-gradient(${gradientDirection === "vertical" ? "180deg" : "90deg"
            },  ${oUtils.getColor(
              window.fontGradient.startColor,
              window.fontGradient.startTransparent
            )}, ${oUtils.getColor(
              window.fontGradient.endColor,
              window.fontGradient.endTransparent
            )})`;
        } else {
          window.fontGradient = {
            enabled: false,
            gradientDirection: "horizontal",
            startTransparent: 1,
            startColor: "#FFFFFF",
            endTransparent: 1,
            endColor: "#FFFFFF",
          };
        }
        // 文字描边
        if (oWindowInfo.CharactersAttribute?.fontBorder) {
          const {
            enabled = false,
            borderDegree = 0,
            borderTransparent = 255,
            borderColor = 16777215,
          } = oWindowInfo.CharactersAttribute.fontBorder;
          window.fontBorder = {
            enabled,
            borderTransparent:
              Math.ceil(100 - ((255 - borderTransparent) / 255) * 100) / 100,
            borderColor: oUtils.transformRgb(borderColor),
            borderDegree,
            showBorderColor: "",
          };
          window.fontBorder.showBorderColor =
            window.fontBorder.borderTransparent === 1
              ? window.fontBorder.borderColor
              : oUtils.getColor(
                window.fontBorder.borderColor,
                window.fontBorder.borderTransparent
              );
        } else {
          window.fontBorder = {
            enabled: false,
            borderDegree: 0,
            borderTransparent: 1,
            borderColor: "#000000",
            showBorderColor: "#000000",
          };
        }
        // 文字边框
        if (oWindowInfo.CharactersAttribute?.characterBorderList?.length) {
          const {
            borderDegree = 1,
            borderColor: { RGB = "ffffff" },
            borderStyle = 1,
          } = oWindowInfo.CharactersAttribute.characterBorderList[0]
            ?.characterBorder ?? {};
          const styleMap = ["", "solid", "dashed", "pointsDotted"];
          window.fontBorderStyle = {
            size: borderDegree,
            oldSize: borderDegree,
            style: styleMap[borderStyle],
            color: oUtils.transformRgb(RGB),
          };
        } else {
          window.fontBorderStyle = {
            size: 1,
            oldSize: 1,
            style: "solid",
            color: "#000000",
          };
        }
        window.rollingDirection =
          oWindowInfo.CharactersAttribute.scrollDirection;
        window.rollingDirection === "up" && (window.scrollLine = 3); // 默认显示前三行
        const standSpeed = [1, 5, 9]; // 对应慢中快
        window.scrollSpeed = standSpeed.includes(
          oWindowInfo.CharactersAttribute.scrollSpeed
        )
          ? oWindowInfo.CharactersAttribute.scrollSpeed
          : 5;

        window.AnimationEffectList =
          oWindowInfo.CharactersAttribute.AnimationEffectList || []; // 微动效
        window.borderRadius = oWindowInfo.filletedCornerDegree || 0; // 圆角
        window.rotate = oWindowInfo.rotateDegree || 0; // 旋转

        window.fontFamily = oWindowInfo.CharactersAttribute.materialID || -1; // 字体
      } else if (windowMode === "character") {
        // 如果模板中有配置使用多语言则需要转化多语言
        window.characterContent = oWindowInfo.CharactersAttribute.useLanguage
          ? i18n.t(
            "program_" + oWindowInfo.CharactersAttribute.characterContent
          )
          : oWindowInfo.CharactersAttribute.characterContent; // 文字消息内容
        // window.characterContent = oWindowInfo.CharactersAttribute.characterContent; // 文字消息内容
        window.fontSize =
          oWindowInfo.CharactersAttribute.fontSize &&
            oWindowInfo.CharactersAttribute.fontSize >= 20
            ? oWindowInfo.CharactersAttribute.fontSize
            : 20; // 文字字体大小
        window.fontColor = oUtils.transformRgb(
          oWindowInfo.CharactersAttribute.FontColor.RGB
        );
        window.showTextColor = window.fontColor;

        window.backgroundColor = oUtils.transformRgb(
          oWindowInfo.CharactersAttribute.BackColor.RGB
        );
        window.backTransparent =
          Math.ceil(
            100 -
            ((255 - oWindowInfo.CharactersAttribute.backTransparent) / 255) *
            100
          ) / 100; // 背景透明度
        window.showBackgroundColor =
          window.backTransparent === 1
            ? window.backgroundColor
            : oUtils.getColor(window.backgroundColor, window.backTransparent);

        window.characterStyle = oWindowInfo.CharactersAttribute.fontType; // 文字字体类型
        window.alignType = oWindowInfo.CharactersAttribute.alignType; // 文字对齐方式
        window.verticaAlignType =
          oWindowInfo.CharactersAttribute.verticaAlignType; // 文字对齐方式

        // 字体阴影
        if (oWindowInfo.CharactersAttribute?.fontShadow) {
          const {
            enabled = false,
            shadowTransparent = 255,
            shadowColor = 16777215,
            shadowRadiusX = 4,
            shadowRadiusY = 1,
          } = oWindowInfo.CharactersAttribute.fontShadow;
          window.fontShadow = {
            enabled,
            shadowRadiusX: shadowRadiusX / 2 || 1,
            shadowRadiusY: shadowRadiusY / 2 || 1,
            shadowTransparent:
              Math.ceil(100 - ((255 - shadowTransparent) / 255) * 100) / 100,
            shadowColor: oUtils.transformRgb(shadowColor),
            showShadowColor: "",
          };
          window.fontShadow.showShadowColor =
            window.fontShadow.shadowTransparent === 1
              ? window.fontShadow.shadowColor
              : oUtils.getColor(
                window.fontShadow.shadowColor,
                window.fontShadow.shadowTransparent
              );
        } else {
          window.fontShadow = {
            enabled: false,
            shadowRadiusX: 2,
            shadowRadiusY: 2,
            shadowTransparent: 1,
            shadowColor: "#000000",
            showShadowColor: "#000000",
          };
        }
        // 文字渐变
        if (oWindowInfo.CharactersAttribute?.fontGradient) {
          const {
            enabled = false,
            gradientDirection = "horizontal",
            startTransparent = 255,
            startColor = 16777215,
            endTransparent = 255,
            endColor = 16777215,
          } = oWindowInfo.CharactersAttribute.fontGradient;
          window.fontGradient = {
            enabled,
            startTransparent:
              Math.ceil(100 - ((255 - startTransparent) / 255) * 100) / 100,
            startColor: oUtils.transformRgb(startColor),
            endTransparent:
              Math.ceil(100 - ((255 - endTransparent) / 255) * 100) / 100,
            endColor: oUtils.transformRgb(endColor),
            gradientDirection,
          };
          window.showTextColor = !window.fontGradient.enabled
            ? window.fontColor
            : `linear-gradient(${gradientDirection === "vertical" ? "180deg" : "90deg"
            },  ${oUtils.getColor(
              window.fontGradient.startColor,
              window.fontGradient.startTransparent
            )}, ${oUtils.getColor(
              window.fontGradient.endColor,
              window.fontGradient.endTransparent
            )})`;
        } else {
          window.fontGradient = {
            enabled: false,
            gradientDirection: "horizontal",
            startTransparent: 1,
            startColor: "#FFFFFF",
            endTransparent: 1,
            endColor: "#FFFFFF",
          };
        }
        // 文字描边
        if (oWindowInfo.CharactersAttribute?.fontBorder) {
          const {
            enabled = false,
            borderDegree = 0,
            borderTransparent = 255,
            borderColor = 16777215,
          } = oWindowInfo.CharactersAttribute.fontBorder;
          window.fontBorder = {
            enabled,
            borderTransparent:
              Math.ceil(100 - ((255 - borderTransparent) / 255) * 100) / 100,
            borderColor: oUtils.transformRgb(borderColor),
            borderDegree,
            showBorderColor: "",
          };
          window.fontBorder.showBorderColor =
            window.fontBorder.borderTransparent === 1
              ? window.fontBorder.borderColor
              : oUtils.getColor(
                window.fontBorder.borderColor,
                window.fontBorder.borderTransparent
              );
        } else {
          window.fontBorder = {
            enabled: false,
            borderDegree: 0,
            borderTransparent: 1,
            borderColor: "#000000",
            showBorderColor: "#000000",
          };
        }
        // 文字边框
        if (oWindowInfo.CharactersAttribute?.characterBorderList?.length) {
          const {
            borderDegree = 1,
            borderColor: { RGB = "ffffff" },
            borderStyle = 1,
          } = oWindowInfo.CharactersAttribute.characterBorderList[0]
            ?.characterBorder ?? {};
          const styleMap = ["", "solid", "dashed", "pointsDotted"];
          window.fontBorderStyle = {
            size: borderDegree,
            oldSize: borderDegree,
            style: styleMap[borderStyle],
            color: oUtils.transformRgb(RGB),
          };
        } else {
          window.fontBorderStyle = {
            size: 1,
            oldSize: 1,
            style: "solid",
            color: "#000000",
          };
        }

        window.rollingDirection =
          oWindowInfo.CharactersAttribute.scrollDirection || "";
        window.rollingDirection === "up" && (window.scrollLine = 3); // 默认显示前三行
        const standSpeed = [1, 5, 9]; // 对应慢中快
        window.scrollSpeed = standSpeed.includes(
          oWindowInfo.CharactersAttribute.scrollSpeed
        )
          ? oWindowInfo.CharactersAttribute.scrollSpeed
          : 5;
        window.AnimationEffectList =
          oWindowInfo.CharactersAttribute.AnimationEffectList || []; // 微动效
        window.borderRadius = oWindowInfo.filletedCornerDegree || 0; // 圆角
        window.rotate = oWindowInfo.rotateDegree || 0; // 旋转

        window.fontFamily = oWindowInfo.CharactersAttribute.materialID || -1; // 字体

        window.strikethroughEnabled =
          oWindowInfo.CharactersAttribute.strikethroughEnabled || false; // 文字删除线
      } else if (
        windowMode === "call" &&
        oWindowInfo.DataSource?.dataSourceUUID
      ) {
        window.windowName =
          window.windowId + "-" + i18n.t("program_type_table");
        window.windowMode = "dataSource";
        window.dataType = "table";
        window.sourceId = `${oWindowInfo.DataSource.dataSourceUUID}_${oWindowInfo.DataSource.materialNo}`;
        window.tripartiteType = oWindowInfo.DataSource.sourceType;
        window.sourceEditIndex = -1;
        //三方数据走叫号逻辑，区别是是否有uuid
        window.backgroundPic = oWindowInfo.Call.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.sourceTemplate = oWindowInfo.Call.tableType.replace(
          "template",
          ""
        ); //表格样式
        window.sourceRow = oWindowInfo.Call.tableRow; //表格行数
        window.sourceColumn = oWindowInfo.Call.tableColumn; //表格列数
        window.sourceTableDirection = oWindowInfo.Call.tableDirection; //表格方向 横、竖
        window.sourcePlayMode = oWindowInfo.Call.playType;
        window.sourceTables = [];

        oWindowInfo.Call.HeadDataList.forEach((item, index) => {
          let HeadData = item.HeadData;
          let ItemStyle = oWindowInfo.Call.ItemStyleList[index].ItemStyle;

          window.sourceTables.push({
            index,
            lineIndex: HeadData?.id,
            name: HeadData?.data,
            emptyRate: ItemStyle?.width,
            fontSize: ItemStyle?.fontSize,
            fontColor: oUtils.transformRgb(ItemStyle?.FontColor?.RGB),
            background: oUtils.transformRgb(ItemStyle?.BackColor?.RGB),
            alignType: oWindowInfo.Call.alignType,
            verticaAlignType: oWindowInfo.Call.verticaAlignType,
          });
        });
      } else if (windowMode === "call") {
        let material = {};
        material.materialId = oWindowInfo.DataSource.materialNo;
        if (material.materialId !== -1) {
          //叫号窗口素材id为-1相当于没有素材，特殊置空处理
          let materialInfo = await this.getMaterialById(material.materialId);
          material.materialName = materialInfo.name;
          material.index = 1;
          material.src = oMaterialService.getMaterialThumbnail(
            material.materialId,
            windowMode
          );
          window.materialList = [material];
          window.style = {
            background: "url(" + material.src + ") no-repeat",
            "background-size": "100% 100%",
          };
        } else {
          window.materialList = [];
        }
        window.backgroundPic = oWindowInfo.Call.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.tableType = oWindowInfo.Call.tableType; //表格样式
        window.tableRow = oWindowInfo.Call.tableRow; //表格行数
        window.tableColumn = oWindowInfo.Call.tableColumn; //表格列数
        window.tableDirection = oWindowInfo.Call.tableDirection; //表格方向 横、竖
        window.alignType = oWindowInfo.Call.alignType; //表格对齐
        window.refreshDirection = oWindowInfo.Call.refreshDirection; //表格刷新方向
        window.tableHeaders = [];
        let id = 1; //（协议垃圾）
        oWindowInfo.Call.HeadDataList.forEach((item) => {
          let HeadData = item.HeadData;
          id = HeadData.id;
          window.tableHeaders[id - 1] = {
            id: id,
            data: HeadData?.data,
          };
        });
        oWindowInfo.Call.ItemStyleList.forEach((item) => {
          let ItemStyle = item.ItemStyle;
          id = ItemStyle.id;
          let tableHeader = window.tableHeaders[id - 1];
          tableHeader.width = ItemStyle.width;
          tableHeader.fontSize = ItemStyle.fontSize;
          tableHeader.fontColor = oUtils.transformRgb(ItemStyle.FontColor.RGB);
          tableHeader.backgroundColor = oUtils.transformRgb(
            ItemStyle.BackColor.RGB
          );
        });
      } else if (windowMode === "countdown") {
        window.endTime = new Date(
          oUtils.transformUTCDate(oWindowInfo.Countdown.endTime, "format")
        );
        // 解决倒计时编辑的时候时间不对的问题 同步windowprop changeEndTime的代码
        const aSupportHMSTemplate = ["template2", "template3", "template4"];
        if (!aSupportHMSTemplate.includes(oWindowInfo.Countdown.template)) {
          window.endTime.setHours(23);
          window.endTime.setMinutes(59);
          window.endTime.setSeconds(59);
        }
        window.timeUnit = oWindowInfo.Countdown.timeUnit;
        window.timeUnitEnabled = oWindowInfo.Countdown.timeUnitEnabled;
        window.maxTimeUnit = oWindowInfo.Countdown.maxTimeUnit;
        window.template = oWindowInfo.Countdown.template;
        window.backgroundPic = oWindowInfo.Countdown.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.subWindows = [];
        window.subWindows.key = window.windowId;
        if (
          oWindowInfo.Countdown.ModuleInfoList &&
          oWindowInfo.Countdown.ModuleInfoList.length
        ) {
          oWindowInfo.Countdown.ModuleInfoList = this.countDownSort(
            oWindowInfo.Countdown.ModuleInfoList,
            window.template
          );
          oWindowInfo.Countdown.ModuleInfoList.forEach((item, i) => {
            let ModuleInfo = item.ModuleInfo;
            let subWindow = {
              start: i,
              x: ModuleInfo.Position.positionX,
              y: ModuleInfo.Position.positionY,
              height: ModuleInfo.Position.height,
              width: ModuleInfo.Position.width,
              moduleType: ModuleInfo.moduleType,
              enable: ModuleInfo.enabled,
              content: ModuleInfo.moduleType === "text" ? ModuleInfo.text : "0",
            };
            subWindow.defX = subWindow.x;
            subWindow.defY = subWindow.y;
            subWindow.defWidth = subWindow.width;
            subWindow.defHeight = subWindow.height;
            subWindow.defFont = subWindow.fontSize = ModuleInfo.fontSize;
            subWindow.fontColor = ModuleInfo.FontColor
              ? oUtils.transformRgb(ModuleInfo.FontColor.RGB)
              : "";
            window.subWindows.push(subWindow);
          });

          oUtils.setCountDown(
            window.subWindows,
            window.endTime,
            window.maxTimeUnit
          );
          window.subwindowGroups = oSubGroupMap[window.template];
        }
      } else if (windowMode === "clock") {
        let arrayClockType = ["ClockIcon", "YmdParam", "HmsParam", "WeekParam"];
        let clockNames = this.getSubWindowName("clock");
        window.backgroundPic = oWindowInfo.ClockParam.backPicId;
        // TODO 暂时不需要展示名称
        // window.backgroundPicName = await this.getBackgroundName(
        //   window.backgroundPic
        // );
        window.backgroundPicDeleteFlag = !!window.backgroundPic && !materialList.includes(window.backgroundPic)
        window.subWindows = [];
        window.subWindows.key = window.windowId;
        for (let k = 0; k < 4; k++) {
          let subWindow = {
            enable: oWindowInfo.ClockParam[arrayClockType[k]].enabled,
            x: oWindowInfo.ClockParam[arrayClockType[k]].Position.positionX,
            y: oWindowInfo.ClockParam[arrayClockType[k]].Position.positionY,
            width: oWindowInfo.ClockParam[arrayClockType[k]].Position.width,
            height: oWindowInfo.ClockParam[arrayClockType[k]].Position.height,
            content: clockNames[k].content,
            name: clockNames[k].name,
          };
          subWindow.defX = subWindow.x;
          subWindow.defY = subWindow.y;
          subWindow.defWidth = subWindow.width;
          subWindow.defHeight = subWindow.height;
          if (k === 0) {
            subWindow.clockType =
              oWindowInfo.ClockParam[arrayClockType[k]].type;
          } else {
            subWindow.defFont = subWindow.fontSize =
              oWindowInfo.ClockParam[arrayClockType[k]].fontSize;
            subWindow.fontColor = oUtils.transformRgb(
              oWindowInfo.ClockParam[arrayClockType[k]].FontColor.RGB
            );
          }
          window.subWindows.push(subWindow);
        }
      } else if (windowMode === "weather") {
        let arrayWeatherType = [
          "City",
          "UpdateTime",
          "WeatherIcon",
          "Date",
          "Temperature",
          "WeatherContent",
          "Wind",
          "AirQuality",
          "Humidity",
        ];
        let weatherNames = this.getSubWindowName("weather");
        window.backgroundPic =
          oWindowInfo.WeatherParam.backPicId ||
          oWindowInfo.WeatherParam?.WeatherDetail?.backPicID ||
          "";
        // TODO 暂时不需要展示名称
        // window.backgroundPicName = await this.getBackgroundName(
        //   window.backgroundPic
        // );
        window.backgroundPicDeleteFlag = !!window.backgroundPic && !materialList.includes(window.backgroundPic)
        window.subWindows = [];
        window.subWindows.key = window.windowId;
        if (oWindowInfo.WeatherParam.weatherShowType) {
          window.weatherShowType = oWindowInfo.WeatherParam.weatherShowType;

          window.lockAspectRatio = true;
          window.aspectFactor =
            window.weatherShowType === "fiveDays" ? 1312 / 230 : 640 / 360; // weather要keep宽高比

          window.backgroundColor = oUtils.transformRgb(
            oWindowInfo.WeatherParam.WeatherDetail.BackColor.RGB
          );
          // window.backTransparent = Math.ceil(
          //   100 -
          //   (oWindowInfo.WeatherParam.WeatherDetail.backTransparent / 255) *
          //   100
          // );
          window.backTransparent =
            Math.ceil(
              100 -
              ((255 - oWindowInfo.WeatherParam.WeatherDetail.backTransparent) / 255) *
              100
            ) / 100; // 背景透明度
          window.showBackgroundColor =
            window.backTransparent === 1
              ? window.backgroundColor
              : oUtils.getColor(window.backgroundColor, window.backTransparent);
          window.timeUnit = oWindowInfo.WeatherParam.WeatherDetail.tempUnit;
          window.dateShowType =
            oWindowInfo.WeatherParam.WeatherDetail.dateShowType;
          window.updateInterval =
            oWindowInfo.WeatherParam.WeatherDetail.updateInterval;

          if (
            oWindowInfo.WeatherParam?.WeatherDetail?.weatherDateList?.[0]
              ?.weatherparamList?.length
          ) {
            for (
              let i = 0;
              i < oWindowInfo.WeatherParam.WeatherDetail.weatherDateList.length;
              i++
            ) {
              const date =
                oWindowInfo.WeatherParam.WeatherDetail.weatherDateList[i];
              for (let j = 0; j < date.weatherparamList.length; j++) {
                const oWeatherSubParam = date.weatherparamList[j];
                const language =
                  Storage.get(Storage.NAME.LANGUAGE) === "zh" ? "zh-cn" : "en";
                const contentMap = {
                  datetoday0: moment(new Date()).format(
                    constant.DATA_FORMATE[window.dateShowType] || "YYYY-MM-DD"
                  ),
                  currentTemperature: `xx${window.timeUnit === "fahrenheit" ? "°F" : "℃"
                    }`,
                  lowestTemperature: `xx${window.timeUnit === "fahrenheit" ? "°F" : "℃"
                    }`,
                  highestTemperature: `xx${window.timeUnit === "fahrenheit" ? "°F" : "℃"
                    }`,
                  wind: i18n.t("program_wind").replace("%s", "xx"),
                  humidity: i18n.t("program_humidity").replace("%s", "xx"),
                  datefiveDays0: moment(new Date()).format(
                    constant.DATA_FORMATE[window.dateShowType] || "YYYY-MM-DD"
                  ),
                  datefiveDays1: moment(new Date())
                    .add(1, "day")
                    .locale(language)
                    .format("dddd"),
                  datefiveDays2: moment(new Date())
                    .add(2, "day")
                    .locale(language)
                    .format("dddd"),
                  datefiveDays3: moment(new Date())
                    .add(3, "day")
                    .locale(language)
                    .format("dddd"),
                  datefiveDays4: moment(new Date())
                    .add(4, "day")
                    .locale(language)
                    .format("dddd"),
                  source: "x".repeat(25),
                };
                const subWin = {
                  enable: true,
                  moduleType: i,
                  x: oWeatherSubParam.Position.positionX,
                  y: oWeatherSubParam.Position.positionY,
                  width: oWeatherSubParam.Position.width,
                  height: oWeatherSubParam.Position.height,
                  defX: oWeatherSubParam.Position.positionX,
                  defY: oWeatherSubParam.Position.positionY,
                  defWidth: oWeatherSubParam.Position.width,
                  defHeight: oWeatherSubParam.Position.height,
                  content:
                    contentMap[
                    oWeatherSubParam.paramType +
                    (oWeatherSubParam.paramType === "date"
                      ? window.weatherShowType + i
                      : "")
                    ] || "xxxxxx",
                  type: oWeatherSubParam.paramType,
                  fontSize: oWeatherSubParam.fontSize,
                  defFont: oWeatherSubParam.fontSize,
                  fontColor: oUtils.transformRgb(
                    oWeatherSubParam.FontColor.RGB || 0
                  ),
                  weatherIcon: oWeatherSubParam.paramType === "weatherIcon",
                };
                if (oWeatherSubParam.paramType === "city") {
                  subWin.areaId =
                    oWindowInfo.WeatherParam.WeatherDetail.countryId;
                  subWin.cityId = oWindowInfo.WeatherParam.WeatherDetail.cityId;
                  subWin.cityIdPath = oWindowInfo.WeatherParam.WeatherDetail.cityIdPath;
                  subWin.content = subWin.cityName =
                    oWindowInfo.WeatherParam.WeatherDetail.cityName;
                }
                window.subWindows.push(subWin);
              }
            }
            if (vm?.needWaiting) {
              await this.repaceWeatherDataInWindow(
                oWindowInfo.WeatherParam.WeatherDetail.cityId,
                window,
                true
              );
            } else {
              this.repaceWeatherDataInWindow(
                oWindowInfo.WeatherParam.WeatherDetail.cityId,
                window,
                true
              );
            }
          }
        } else {
          for (let k = 0; k < 9; k++) {
            let subWindow = {
              enable: oWindowInfo.WeatherParam[arrayWeatherType[k]].enabled,
              x: oWindowInfo.WeatherParam[arrayWeatherType[k]].Position
                .positionX,
              y: oWindowInfo.WeatherParam[arrayWeatherType[k]].Position
                .positionY,
              width:
                oWindowInfo.WeatherParam[arrayWeatherType[k]].Position.width,
              height:
                oWindowInfo.WeatherParam[arrayWeatherType[k]].Position.height,
              content: weatherNames[k].content,
              name: weatherNames[k].name,
            };
            subWindow.defX = subWindow.x;
            subWindow.defY = subWindow.y;
            subWindow.defWidth = subWindow.width;
            subWindow.defHeight = subWindow.height;
            if (k === 0) {
              subWindow.cityId =
                oWindowInfo.WeatherParam[arrayWeatherType[k]].cityId || -1;
              subWindow.cityIdPath =
                oWindowInfo.WeatherParam[arrayWeatherType[k]].cityIdPath || -1;
              subWindow.cityName =
                oWindowInfo.WeatherParam[arrayWeatherType[k]].cityName || -1;
              subWindow.content = subWindow.cityName || i18n.t("city"); //显示城市名称
            } else if (k === 1) {
              subWindow.interval =
                oWindowInfo.WeatherParam[arrayWeatherType[k]].updateInterval;
              subWindow.content = i18n
                .t("update_interval")
                .replace("%s", subWindow.interval);
            } else if (k === 2) {
              subWindow.weatherIcon = true; //是否显示天气图标
            }
            if (k !== 2) {
              subWindow.defFont = subWindow.fontSize =
                oWindowInfo.WeatherParam[arrayWeatherType[k]].fontSize;
              subWindow.fontColor = oUtils.transformRgb(
                oWindowInfo.WeatherParam[arrayWeatherType[k]].FontColor.RGB
              );
            }
            window.subWindows.push(subWindow);
          }
        }
      } else if (windowMode === "event") {
        let oEventParam = oWindowInfo.EventParam;
        // const arrayEventType = ["Title", "PeopleCounting Prompt", "PeopleIcon", "InsidePeopleTitle", "InsidePeopleNumber", "AvailablePeopleTitle", "AvailablePeopleNumber", "Mask", "MaskIcon", "Temperature Prompt", "TemperatureIcon"];
        const arrayEventType = [
          "Title",
          "PeopleCounting Prompt",
          "PeopleIcon",
          "InsidePeopleTitle",
          "InsidePeopleNumber",
          "AvailablePeopleTitle",
          "AvailablePeopleNumber",
          "Mask",
          "Mask MaskIcon",
          "Temperature Prompt",
          "Temperature TemperatureIcon",
          "WearMask",
          "WearMask MaskIcon",
          "NormalTemperature Prompt",
          "NormalTemperature TemperatureIcon",
        ];
        /* json 查找属性时调用的方法必须一层一层查找，所以这里做个映射 */
        const attrMap = {
          PeopleIcon: "PeopleCounting PeopleIcon",
          InsidePeopleTitle: "PeopleCounting InsidePeopleTitle",
          InsidePeopleNumber: "PeopleCounting InsidePeopleNumber",
          AvailablePeopleTitle: "PeopleCounting AvailablePeopleTitle",
          AvailablePeopleNumber: "PeopleCounting AvailablePeopleNumber",
          MaskIcon: "Mask MaskIcon",
          TemperatureIcon: "Temperature TemperatureIcon",
          WearMaskIcon: "WearMask MaskIcon",
          NormalTemperatureIcon: "NormalTemperature TemperatureIcon",
        };
        let eventNames = this.getSubWindowName("event");
        window.backgroundPic = oEventParam.backPicId;
        window.backgroundPicName = screenType
          ? "mask_bg"
          : await this.getBackgroundName(window.backgroundPic);
        window.maxPeopleNumber = oEventParam.PeopleCounting.maxPeopleNumber; //最大可进入人数
        window.showMaxPeopleNumber =
          oEventParam.PeopleCounting.maxPeopleNumber !== undefined; //最大可进入人数
        window.abnormalHighTemperature =
          oEventParam.Temperature.abnormalHighTemperature || 37.5; //高温值
        if (oEventParam.NormalStatusAudioAlarm) {
          // 温度正常提示音
          window.normalTemperatureAlarm = {
            enabled: oEventParam.NormalStatusAudioAlarm.enabled,
            materialNo: oEventParam.NormalStatusAudioAlarm.materialNo,
            materialName: screenType
              ? "normalTemperature.wav"
              : await this.getBackgroundName(
                oEventParam.NormalStatusAudioAlarm.materialNo
              ),
          };
        }
        if (oEventParam.Mask.AudioAlarm) {
          window.maskAlarm = {
            //未佩戴口罩提示音
            enabled: oEventParam.Mask.AudioAlarm.enabled,
            materialNo: oEventParam.Mask.AudioAlarm.materialNo,
            materialName: screenType
              ? "mask.wav"
              : await this.getBackgroundName(
                oEventParam.Mask.AudioAlarm.materialNo
              ),
          };
          window.temperatureAlarm = {
            //温度异常提示音
            enabled: oEventParam.Temperature.AudioAlarm.enabled,
            materialNo: oEventParam.Temperature.AudioAlarm.materialNo,
            materialName: screenType
              ? "temperature.wav"
              : await this.getBackgroundName(
                oEventParam.Temperature.AudioAlarm.materialNo
              ),
          };
        }
        // 针对测温做兼容，不显示客流已满语音报警
        let oAudioAlarm = oEventParam.PeopleCounting.AudioAlarm;
        if (oAudioAlarm) {
          window.showUnavailableAlarm = oAudioAlarm.enabled !== undefined;
          window.unavailableAlarm = {
            //客流已满提示音
            enabled: oAudioAlarm.enabled,
            materialNo: oAudioAlarm.materialNo,
            materialName: screenType
              ? "peopleCounting.wav"
              : await this.getBackgroundName(oAudioAlarm.materialNo),
          };
        } else {
          window.showUnavailableAlarm = false;
        }
        //报警时的信息，暂时这么写，后面改进lsj (后面增加实际显示数据【背景、报警】，仅用于页面显示，不用于实际保存使用)
        let unavailableBackgroundPic =
          oEventParam.PeopleCounting.unavailableBackPicId; //报警
        let unavailableBackgroundName = screenType
          ? "mask_bg"
          : await this.getBackgroundName(unavailableBackgroundPic);
        let oEventPCPrompt = oEventParam.PeopleCounting.Prompt;
        let oEventPCAvailNum = oEventParam.PeopleCounting.AvailablePeopleNumber;
        let insideInfoText = "";
        let unavaibleInfoText = "";
        // 编辑取协议返回的值
        if (template && template.isEdit) {
          insideInfoText = oEventPCPrompt ? oEventPCPrompt.text : "";
          unavaibleInfoText = oEventPCPrompt
            ? oEventPCPrompt.unavailableText
            : "";
        } else {
          // 新增模板的值做多语言映射
          insideInfoText = oEventPCPrompt
            ? oEventPCPrompt.text === "Come in."
              ? i18n.t("program_please_come_in")
              : oEventPCPrompt.text
            : "";
          unavaibleInfoText = oEventPCPrompt
            ? oEventPCPrompt.unavailableText === "Please wait."
              ? i18n.t("program_please_wait")
              : oEventPCPrompt.unavailableText
            : "";
        }
        window.insideInfo = {
          text: insideInfoText,
          fontColor: oEventPCPrompt
            ? oUtils.transformRgb(oEventPCPrompt.FontColor.RGB)
            : 0,
          icon: oEventParam.PeopleCounting.PeopleIcon
            ? oEventParam.PeopleCounting.PeopleIcon.materialNo
            : "",
          numberColor: oUtils.transformRgb(
            oEventPCAvailNum ? oEventPCAvailNum.FontColor.RGB : 0
          ),
          backgroundPic: window.backgroundPic,
          backgroundPicName: window.backgroundPicName,
        };
        window.unavailableInfo = {
          text: unavaibleInfoText,
          fontColor: oUtils.transformRgb(
            oEventPCPrompt ? oEventPCPrompt.UnavailableFontColor.RGB : 0
          ), //提示语颜色
          numberColor: oUtils.transformRgb(
            oEventPCAvailNum ? oEventPCAvailNum.UnavailableFontColor.RGB : 0
          ), //人员不能进入字体颜色
          icon: oEventParam.PeopleCounting.UnavailablePeopleIcon
            ? oEventParam.PeopleCounting.UnavailablePeopleIcon.materialNo
            : "",
          backgroundPic: unavailableBackgroundPic,
          backgroundPicName: unavailableBackgroundName,
        };
        window.subWindows = [];
        window.subWindows.key = window.windowId;
        // 模板数据支持多语言
        const oMatchTempText = {
          Title: {
            ATTENTION: i18n.t("title"),
            "": i18n.t("title"),
          },
          "PeopleCounting Prompt": {
            "Come in.": i18n.t("program_please_come_in"),
          },
          InsidePeopleTitle: {
            "People Entered": i18n.t("program_inside_people"),
          },
          AvailablePeopleTitle: {
            "Remained Entries": i18n.t("program_available_people"),
          },
          Mask: {
            "No Mask": i18n.t("program_no_wear_mask"),
          },
          WearMask: {
            Mask: i18n.t("program_wear_mask"),
          },
          "Temperature Prompt": {
            "High Temperature": i18n.t("program_high_temperature_format"),
          },
          "NormalTemperature Prompt": {
            "Normal Temperature": i18n.t("normal_temperature_format"),
          },
        };
        for (let k = 0; k < arrayEventType.length; k++) {
          let realKey = attrMap[arrayEventType[k]] || arrayEventType[k];
          if (oUtils.getJsonAttr(oEventParam, realKey)) {
            let oEventSubInfo = oUtils.getJsonAttr(oEventParam, realKey);
            let subWindow = {
              enable: oEventSubInfo.enabled,
              x: oEventSubInfo.Position.positionX,
              y: oEventSubInfo.Position.positionY,
              width: oEventSubInfo.Position.width,
              height: oEventSubInfo.Position.height,
              content: eventNames[k].content,
              name: eventNames[k].name,
            };
            //区分正常状态、告警状态窗口
            if (
              [
                "Mask MaskIcon",
                "Temperature TemperatureIcon",
                "Mask",
                "Temperature Prompt",
              ].includes(arrayEventType[k])
            ) {
              subWindow.alarmShow = false; //正常状态不显示
            } else {
              subWindow.alarmShow = true;
            }
            // 设置正常状态口罩和温度
            if (
              [
                "WearMask MaskIcon",
                "NormalTemperature TemperatureIcon",
                "WearMask",
                "NormalTemperature Prompt",
              ].includes(arrayEventType[k])
            ) {
              subWindow.alarmShow = true; //正常状态显示
            }
            subWindow.key = arrayEventType[k]; //关键字段，用于处理保存逻辑判断
            subWindow.defX = subWindow.x;
            subWindow.defY = subWindow.y;
            subWindow.defWidth = subWindow.width;
            subWindow.defHeight = subWindow.height;
            //显示文本内容
            if (
              [
                "Title",
                "PeopleCounting Prompt",
                "InsidePeopleTitle",
                "AvailablePeopleTitle",
                "Mask",
                "Temperature Prompt",
                "WearMask",
                "NormalTemperature Prompt",
              ].includes(arrayEventType[k])
            ) {
              // 是编辑状态则取返回的值
              if (template && template.isEdit) {
                subWindow.content = oEventSubInfo.text || "";
              } else {
                // 反之模板的值做多语言映射
                let oMatchText = oMatchTempText[arrayEventType[k]] || {};
                subWindow.content = oMatchText[oEventSubInfo.text]
                  ? oMatchText[oEventSubInfo.text]
                  : oEventSubInfo.text || "";
              }
              subWindow.bCharacterWindow = true;
            }
            if (
              ["InsidePeopleNumber", "AvailablePeopleNumber"].includes(
                arrayEventType[k]
              )
            ) {
              subWindow.bCharacterWindow = true;
            }
            //字体颜色、字体大小
            if (
              [
                "Title",
                "PeopleCounting Prompt",
                "InsidePeopleTitle",
                "InsidePeopleNumber",
                "AvailablePeopleTitle",
                "AvailablePeopleNumber",
                "Mask",
                "Temperature Prompt",
                "WearMask",
                "NormalTemperature Prompt",
              ].includes(arrayEventType[k])
            ) {
              subWindow.defFont = subWindow.fontSize = oEventSubInfo.fontSize;
              // console.log('arrayEventType[k]) = >', arrayEventType[k], oEventSubInfo);
              subWindow.fontColor = oUtils.transformRgb(
                oEventSubInfo.FontColor.RGB
              );
            }
            //图标
            if (
              [
                "PeopleIcon",
                "Mask MaskIcon",
                "Temperature TemperatureIcon",
                "WearMask MaskIcon",
                "NormalTemperature TemperatureIcon",
              ].includes(arrayEventType[k])
            ) {
              let icon = oEventSubInfo.materialNo;
              subWindow.icon = icon;
              subWindow.showIcon = !!(icon !== undefined);
              subWindow.iconName = screenType
                ? arrayEventType[k]
                : await this.getBackgroundName(subWindow.icon);
            }
            //背景图片
            if (
              [
                "Mask",
                "Temperature Prompt",
                "WearMask",
                "NormalTemperature Prompt",
              ].includes(arrayEventType[k])
            ) {
              subWindow.backgroundColor = oUtils.transformRgb(
                oEventSubInfo.BackColor.RGB
              );
            }
            window.subWindows.push(subWindow);
          }
        }
      } else if (windowMode === "signIn") {
        let oSignInInfo = oWindowInfo.SignIn;
        let notSupportTemperature = !oUtils.getJsonDeepAttr(
          template,
          "TemperatureDetection"
        ); //是否支持测温

        window.backgroundPic = oSignInInfo.backPicId;
        window.backgroundPicName = screenType
          ? "mask_bg"
          : await this.getBackgroundName(window.backgroundPic);
        //子窗口信息
        window.subWindows = [];
        window.subWindows.key = window.windowId;

        const added1_5 = ["signIn_logo", "signIn_time", "signIn_zimu"]; //信发1.5新增 logo, 当前时间, 滚动字幕
        // 模板获取时 从本地获取 考勤logo、时间、字幕的配置
        // 模板id ===> 对应配置
        let templateMap = [
          [[135, 137, 210], signIn_temperature_h],
          [[139, 141, 211], signIn_h],
          [[134], signIn_temperature_v1],
          [[138, 212], signIn_temperature_v],
          [[140, 142, 213], signIn_v],
        ];
        if (TemplateId) {
          window.windowApplication = `${TemplateId}_templateid&${signInLogo_def}_logoid`;

          try {
            const t = templateMap.filter(([templateArr]) =>
              templateArr.includes(TemplateId)
            );
            t[0][1]["signIn_logo"].materialNo = signInLogo_def;
            Object.assign(oSignInInfo, { ...t[0][1] });
          } catch (error) {
            console.log(error);
          }
        } else {
          // 考勤编辑的时候 从本地获取 考勤logo、时间、字幕的配置
          // 考勤背景图片id ===> 对应配置
          // 默认根据新增时保存的模板id去取对应的模板，是在不行根据背景图片匹配
          if (!parseInt(oWindowInfo.windowApplication, 10)) {
            templateMap = [
              [[170, 166, 180], { ...signIn_temperature_h }],
              [[176, 136, 181], { ...signIn_h }],
              [[169], { ...signIn_temperature_v1 }],
              [[174, 183], { ...signIn_temperature_v }],
              [[134, 138, 177], { ...signIn_v }],
            ];
          } else {
            window.windowApplication = oWindowInfo.windowApplication;
          }

          try {
            const t = templateMap.filter(([templateArr]) =>
              templateArr.includes(
                parseInt(oWindowInfo.windowApplication, 10) ||
                oSignInInfo.backPicId - 1
              )
            );
            const obj = JSON.parse(JSON.stringify({ ...t[0][1] }));
            Object.values(obj).forEach((values) => {
              values.enabled = false;
              if (typeof values.materialNo !== "undefined") {
                values.materialNo = signInLogo_def;
              }
            });
            Object.assign(oSignInInfo, obj);
          } catch (error) {
            console.log(error);
          }
        }

        const arraySinginType = [
          "MainTitle",
          "SubTitle",
          "ShowInfo",
          "NormalTemperature PeopleNumber",
          "NormalTemperature Icon",
          "AbnormalTemperature PeopleNumber",
          "AbnormalTemperature Icon",
          ...added1_5,
        ];
        // 模板数据支持多语言
        const oMatchTempText = {
          MainTitle: {
            ATTENDANCE: i18n.t("program_uppercase_attentance"),
          },
          SubTitle: {
            "Subtitle Infomation": i18n.t("program_subtitle_info"),
          },
          "NormalTemperature PeopleNumber": {
            "Normal Temperature": i18n.t("normal_temperature_format"),
          },
          "AbnormalTemperature PeopleNumber": {
            "High Temperature": i18n.t("program_high_temperature_format"),
          },
        };
        //let eventNames = this.getSubWindowName("event");
        for (let k = 0; k < arraySinginType.length; k++) {
          if (oUtils.getJsonAttr(oSignInInfo, arraySinginType[k])) {
            let oSignInSubInfo = oUtils.getJsonAttr(
              oSignInInfo,
              arraySinginType[k]
            );
            let subWindow = {
              x: oSignInSubInfo.Position.positionX,
              y: oSignInSubInfo.Position.positionY,
              width: oSignInSubInfo.Position.width,
              height: oSignInSubInfo.Position.height,
              content: oSignInSubInfo.text || "",
            };
            subWindow.key = arraySinginType[k]; //关键字段，用于处理保存逻辑判断
            subWindow.defX = subWindow.x;
            subWindow.defY = subWindow.y;
            subWindow.defWidth = subWindow.width;
            subWindow.defHeight = subWindow.height;
            if (
              [
                "MainTitle",
                "SubTitle",
                "NormalTemperature PeopleNumber",
                "AbnormalTemperature PeopleNumber",
                "signIn_zimu",
              ].includes(arraySinginType[k])
            ) {
              // 是编辑状态则取返回的值
              if (template && template.isEdit) {
                subWindow.content = oSignInSubInfo.text || "";
              } else {
                // 反之模板的值做多语言映射
                let oMatchText = oMatchTempText[arraySinginType[k]] || {};
                subWindow.content = oMatchText[oSignInSubInfo.text]
                  ? oMatchText[oSignInSubInfo.text]
                  : oSignInSubInfo.text || "";
              }
              subWindow.bCharacterWindow = true;
            }
            // 使能
            if (
              ["SubTitle", "signIn_logo", "signIn_zimu"].includes(
                arraySinginType[k]
              )
            ) {
              subWindow.enabled = !!oSignInSubInfo.enabled;
            }
            //字体大小
            if (
              [
                "MainTitle",
                "SubTitle",
                "NormalTemperature PeopleNumber",
                "AbnormalTemperature PeopleNumber",
                "signIn_time",
                "signIn_zimu",
              ].includes(arraySinginType[k])
            ) {
              subWindow.defFont = subWindow.fontSize = oSignInSubInfo.fontSize;
              subWindow.fontColor = oUtils.transformRgb(
                oSignInSubInfo.FontColor.RGB
              );
            }
            //图标
            if (
              [
                "NormalTemperature Icon",
                "AbnormalTemperature Icon",
                "signIn_logo",
              ].includes(arraySinginType[k])
            ) {
              subWindow.icon = oSignInSubInfo.materialNo;
              subWindow.iconName = screenType
                ? "mask_icon"
                : await this.getBackgroundName(subWindow.icon);
            }
            //滚动方向
            if (["signIn_zimu"].includes(arraySinginType[k])) {
              subWindow.rolling_direction = oSignInSubInfo.rolling_direction;
            }
            // 显示当前时间
            if (arraySinginType[k] === "signIn_time") {
              subWindow.isShowTime = true;
              subWindow.text = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
            }
            if (arraySinginType[k] === "ShowInfo") {
              subWindow.row = oSignInSubInfo.row;
              subWindow.column = oSignInSubInfo.column;
              subWindow.background =
                subWindow.row +
                (notSupportTemperature ? "_" : "-") +
                subWindow.column; //背景图片名称
            }
            // subwindow有最大最小值
            if (["signIn_logo"].includes(arraySinginType[k])) {
              subWindow.minWidth = oSignInSubInfo.minWidth;
              subWindow.maxWidth = oSignInSubInfo.maxWidth;
              subWindow.minHeight = oSignInSubInfo.minHeight;
              subWindow.maxHeight = oSignInSubInfo.maxHeight;
            }
            window.subWindows.push(subWindow);
          }
        }
        //在库人员信息
        let signinLibsList = [
          "nameEnabled",
          "genderEnabled",
          "signInTimeEnabled",
          "temperatureEnabled",
        ];
        // const signinLibsList = ['nameEnabled', 'signInTimeEnabled', 'temperatureEnabled', 'selfDefine1Enabled', 'selfDefine2Enabled'];
        let signinLibNames = this.getSubWindowName("signin");
        // 如果存在自定义属性并且数量小于等于2（只支持下发两个，存在多个显示会有问题），则用获取的，反之用默认的
        if (this.aCustomField?.length && this.aCustomField.length <= 2) {
          this.aCustomField.forEach((item, index) => {
            signinLibNames.push({
              name: item.CustomFieldName,
            });
            signinLibsList.push("selfDefine" + (index + 1) + "Enabled");
          });
        } else {
          signinLibNames = signinLibNames.concat([
            {
              name: i18n.t("selfDefine1Enabled"),
            },
            {
              name: i18n.t("selfDefine2Enabled"),
            },
          ]);
          signinLibsList = signinLibsList.concat([
            "selfDefine1Enabled",
            "selfDefine2Enabled",
          ]);
        }
        window.signinLibs = [];
        for (let k = 0; k < signinLibsList.length; k++) {
          let signinLib = {
            key: signinLibsList[k],
            flag: "inLib",
            enabled: oSignInInfo.ShowInfo.inLib[signinLibsList[k]],
            name: signinLibNames[k].name,
          };
          if (
            notSupportTemperature &&
            signinLibsList[k] === "temperatureEnabled"
          ) {
            //如果默认不启用体温，就不显示
          } else {
            window.signinLibs.push(signinLib);
          }
        }
        //未知人员信息
        const signoutLibsList = [
          "nameEnabled",
          "genderEnabled",
          "signInTimeEnabled",
          "temperatureEnabled",
        ];
        // const signoutLibsList = ['nameEnabled', 'signInTimeEnabled', 'temperatureEnabled'];
        let signoutLibName = this.getSubWindowName("signout");
        window.signoutLibs = [];
        for (let k = 0; k < signoutLibsList.length; k++) {
          let signoutLib = {
            key: signoutLibsList[k],
            flag: "outLib",
            enabled: oSignInInfo.ShowInfo.outLib[signoutLibsList[k]],
            name: signoutLibName[k].name,
          };
          if (
            notSupportTemperature &&
            signoutLibsList[k] === "temperatureEnabled"
          ) {
            //如果默认不启用体温，就不显示
          } else {
            window.signoutLibs.push(signoutLib);
          }
        }
        window.outLibName = oSignInInfo.ShowInfo.outLib.name; //未知人员姓名
        window.showDuration = oSignInInfo.ShowInfo.showDuration; //签到记录显示
        window.realShowDuration = oSignInInfo.ShowInfo.showDuration; //签到记录显示
        window.realApplicationType = notSupportTemperature
          ? "signIn"
          : "signInTemperature";
      } else if (windowMode === "conference") {
        // 会议签到
        let oSignInInfo = oWindowInfo.ConferenceParam || {};
        window.backgroundPic = oSignInInfo.backPicId;
        window.backgroundPicName = screenType
          ? "mask_bg"
          : await this.getBackgroundName(window.backgroundPic);
        //子窗口信息
        window.subWindows = [];
        window.subWindows.key = window.windowId;
        const arraySinginType = [
          "conferenceTime",
          "conferenceSite",
          "conferenceStatus",
          "signInAndTotalPersonNum",
          "Title",
          "ShowInfo",
        ];
        for (let k = 0; k < arraySinginType.length; k++) {
          let oSignInSubInfo = oSignInInfo[arraySinginType[k]] || {};
          if (
            [
              "conferenceTime",
              "conferenceSite",
              "conferenceStatus",
              "signInPersonNum",
              "totalPersonNum",
              "unSignInPersonNum",
              "signInAndTotalPersonNum",
            ].includes(arraySinginType[k])
          ) {
            oSignInSubInfo =
              (oSignInInfo.ModuleInfoList[k] &&
                oSignInInfo.ModuleInfoList[k].ModuleInfo) ||
              {};
          }
          let subWindow = {};
          if (oSignInSubInfo.Position) {
            subWindow = {
              x: oSignInSubInfo.Position.positionX,
              y: oSignInSubInfo.Position.positionY,
              width: oSignInSubInfo.Position.width,
              height: oSignInSubInfo.Position.height,
              content: oSignInSubInfo.text || "",
            };
          }
          subWindow.key = arraySinginType[k]; //关键字段，用于处理保存逻辑判断
          subWindow.defX = subWindow.x;
          subWindow.defY = subWindow.y;
          subWindow.defWidth = subWindow.width;
          subWindow.defHeight = subWindow.height;

          if (
            [
              "conferenceTime",
              "conferenceSite",
              "conferenceStatus",
              "signInPersonNum",
              "totalPersonNum",
              "unSignInPersonNum",
              "signInAndTotalPersonNum",
              "Title",
            ].includes(arraySinginType[k])
          ) {
            subWindow.content = oSignInSubInfo.text || "";
            subWindow.bCharacterWindow = true;
            subWindow.backPicId = oSignInSubInfo.backPicId;
            if (oSignInSubInfo.backPicId && oSignInSubInfo.backPicId !== -1) {
              subWindow.icon = oSignInSubInfo.backPicId;
            }
            subWindow.defFont = subWindow.fontSize = oSignInSubInfo.fontSize;
            subWindow.fontColor = oSignInSubInfo.FontColor
              ? oUtils.transformRgb(oSignInSubInfo.FontColor.RGB)
              : 0;
          }
          if (["conferenceTime"].includes(arraySinginType[k])) {
            subWindow.label = `${i18n.t("conference_time")}：`;
          }
          if (["conferenceSite"].includes(arraySinginType[k])) {
            subWindow.label = `${i18n.t("conference_address")}：`;
          }
          let arrayModuleType = ["conferenceStatus", "signInAndTotalPersonNum"];
          let arrayModuleTypeObj = {
            // 'signInPersonNum': {
            //   value: '签到人数',
            //   num: '36'
            // },
            // 'totalPersonNum': {
            //   value: '应到人数',
            //   num: '40'
            // },
            // 'unSignInPersonNum': {
            //   value: '缺勤人数',
            //   num: '4'
            // },
            conferenceStatus: {
              value: i18n.t("meet_not_started"),
              num: "",
            },
            signInAndTotalPersonNum: {
              value: i18n.t("sign_in_and_total_person_num") + "：16/40",
              num: "",
            },
          };
          if (arrayModuleType.includes(arraySinginType[k])) {
            //             subWindow.content = (`${arrayModuleTypeObj[arraySinginType[k]].value}
            // ${arrayModuleTypeObj[arraySinginType[k]].num}`) || '';
            subWindow.content = arrayModuleTypeObj[arraySinginType[k]].value;
          } else {
            subWindow.content = oSignInSubInfo.text || "";
          }
          // 会议时间，会议地点赋值
          if (
            vm &&
            vm.conferenceSignIn &&
            vm.conferenceSignIn.showTime &&
            vm.conferenceSignIn.theme
          ) {
            let conferenceObj = {
              conferenceTime: "showTime",
              Title: "theme",
              conferenceSite: "conferencePlace",
            };
            Object.keys(conferenceObj).forEach((key) => {
              if (key === arraySinginType[k]) {
                subWindow.content = vm.conferenceSignIn[conferenceObj[key]];
              }
            });
          }
          if (arraySinginType[k] === "ShowInfo") {
            let bNameEnabled = oSignInSubInfo.inLib.nameEnabled;
            let sClassName = bNameEnabled ? "hasName" : "noName";
            subWindow.row = oSignInSubInfo.row;
            subWindow.column = oSignInSubInfo.column;
            subWindow.windowMode = "conference"; // 窗口模式，标识符，区分图片
            subWindow.background =
              subWindow.row + "-" + subWindow.column + "-" + sClassName; //背景图片名称
            subWindow.backgroundNoName =
              subWindow.row + "-" + subWindow.column + "-noName";
            subWindow.backgroundHasName =
              subWindow.row + "-" + subWindow.column + "-hasName";
            subWindow.nameEnabled = bNameEnabled;
          }
          window.subWindows.push(subWindow);
        }
        // 语言播报内容
        window.cfg = {
          voiceBroadcastEnable: oSignInInfo.VoiceBroadcast.enabled, //语音播报
          broadcastSpeed: oSignInInfo.VoiceBroadcast.broadcastSpeed, //播报语速
          inLibVoice: oSignInInfo.VoiceBroadcast.inLibVoice
            ? oSignInInfo.VoiceBroadcast.inLibVoice
            : `*${i18n.t("welcome_people")}`, //在库人员语音播报内容
          outLibVoice: oSignInInfo.VoiceBroadcast.outLibVoice
            ? oSignInInfo.VoiceBroadcast.outLibVoice
            : i18n.t("sign_in_fail"), //未知人员语音播报内容
          nameEnabled: oSignInInfo.ShowInfo.inLib.nameEnabled, // 是否显示人员姓名
          welcomeWordEnable: oSignInInfo.WelcomeWord.enabled, //是否启用欢迎词
          inLibWord: oSignInInfo.WelcomeWord.inLibWord
            ? oSignInInfo.WelcomeWord.inLibWord
            : i18n.t("welcome_people"), // 签到成功内容
          outLibWord: oSignInInfo.WelcomeWord.outLibWord
            ? oSignInInfo.WelcomeWord.outLibWord
            : i18n.t("sign_in_fail"), // 签到失败内容
        };
      } else if (
        windowMode === "picture" &&
        oWindowInfo.DataSource?.dataSourceUUID
      ) {
        //三方数据动态图片
        window.windowName = window.windowId + "-" + i18n.t("program_type_pic");
        window.windowMode = "dataSource";
        window.dataType = "pic";
        window.tripartiteType = oWindowInfo.DataSource.sourceType;
        window.sourceId = `${oWindowInfo.DataSource.dataSourceUUID}_${oWindowInfo.DataSource.materialNo}`;
        window.defaultStyle = {
          background:
            "url(" +
            require("@/assets/image/program/dataSource_pic.svg") +
            ") no-repeat center center",
        };
        // 增加material图片
        let material = {};
        material.index = 1;
        material.src = require("@/assets/image/program/dataSource_pic.svg");
        window.materialList = [material];

        window.AnimationEffectList =
          oWindowInfo.DataSource.AnimationEffectList || []; // 微动效
        window.borderRadius = oWindowInfo.filletedCornerDegree || 0; // 圆角
        window.rotate = oWindowInfo.rotateDegree || 0; // 旋转
      } else if (
        windowMode === "chart" &&
        oWindowInfo.DataSource?.dataSourceUUID
      ) {
        window.windowName =
          window.windowId + "-" + i18n.t("program_type_chart");
        window.windowMode = "dataSource";
        window.dataType = "chart";
        window.tripartiteType = oWindowInfo.DataSource.sourceType;
        window.sourceId = `${oWindowInfo.DataSource.dataSourceUUID}_${oWindowInfo.DataSource.materialNo}`;
        window.sourceTemplate =
          oWindowInfo.ChartData.chartType === "histogram" ? "1" : "2";
        window.backgroundPic = oWindowInfo.ChartData.backPicId;
        window.backgroundPicName = await this.getBackgroundName(
          window.backgroundPic
        );
        window.sourceTables = [];

        oWindowInfo.ChartData.HeadDataList.forEach((item, index) => {
          window.sourceTables.push({
            index,
            lineIndex: item.HeadData.id,
            name: item.HeadData.data,
          });
        });
      } else if (windowMode === "RSS") {
        // 窗口属性
        window.rssUrl = oWindowInfo.RSS.RSSURL;
        window.backgroundColor = oUtils.transformRgb(oWindowInfo.RSS.backColor);
        window.backTransparent = Math.ceil(
          100 - (oWindowInfo.RSS.backTransparent / 255) * 100
        );
        window.rollingDirection =
          oWindowInfo.RSS.playMode === "turnPage"
            ? ""
            : oWindowInfo.RSS.scrollDirection;
        window.scrollSpeed = oWindowInfo.RSS.scrollSpeed || 5;
        window.rssPageTime = oWindowInfo.RSS.pageIntervalTime;

        window.subWindows = [];
        window.subWindows.key = window.windowId;

        // 子窗口位置
        const rectArr = ["icon", "content"];
        rectArr.forEach((key, i) => {
          const subWin = oWindowInfo.RSS.elementRectList?.find(
            (item) => item.elementRectType === key
          );
          if (subWin) {
            let subWindow = {
              enable:
                key === "icon"
                  ? !(
                    oWindowInfo.RSS.RSSElementList?.find(
                      (item) => item.RSSElementType === key
                    )?.elementHideEnabled ?? false
                  )
                  : true,
              x: subWin.rect.x,
              y: subWin.rect.y,
              width: subWin.rect.width,
              height: subWin.rect.height,
              start: i,
              type: key,
              name: key === "icon" ? i18n.t("program_icon") : "rssContent",
            };
            subWindow.defX = subWindow.x;
            subWindow.defY = subWindow.y;
            subWindow.defWidth = subWindow.width;
            subWindow.defHeight = subWindow.height;
            window.subWindows.push(subWindow);
            window.fontSize = (subWindow.height / 160) * 15;
          }
        });

        // 内容窗口的子窗口
        const contentIndex = window.subWindows.findIndex(
          (item) => item.type === "content"
        );
        if (contentIndex !== -1) {
          window.subWindows[contentIndex].subWindows = [];
          let aHeadStr = ["title", "date", "content"];
          const enableCount =
            4 -
            oWindowInfo.RSS.RSSElementList?.filter(
              (item) =>
                aHeadStr.includes(item.RSSElementType) &&
                !item.elementHideEnabled
            )?.length;
          let RssNames = this.getSubWindowName(
            "RSS",
            window.rollingDirection ? enableCount / 3 : 1
          );
          aHeadStr.forEach((key, k) => {
            const subs = oWindowInfo.RSS.RSSElementList?.find(
              (item) => item.RSSElementType === key
            );
            if (subs) {
              const subWindows = {
                enable: !subs.elementHideEnabled,
                type: key,
                alignType: subs.alignType,
                fontSize: subs.fontSize,
                fontColor: oUtils.transformRgb(subs.fontColor || 0),
                name: RssNames[k + 1].name,
                content: RssNames[k + 1].content,
                defFont: subs.fontSize,
              };
              key === "content" &&
                (subWindows.interval = oWindowInfo.RSS.updateInterval);
              window.subWindows[contentIndex].subWindows.push(subWindows);
            }
          });
        }
      } else if (windowMode === "signalSource") {
        window.windowName =
          window.windowId + "-" + i18n.t("program_signal_source");
        window.signalSourceType =
          oWindowInfo.PlayItemList[0].PlayItem.SignalSource.signalSourceType;
        window.signalSourceSubTypeId =
          oWindowInfo.PlayItemList[0].PlayItem.SignalSource.signalSourceSubTypeId;
        window.signalSourceName =
          oWindowInfo.PlayItemList[0].PlayItem.SignalSource.name;
      } else if (aSupportMaterial.includes(windowMode)) {
        //区分视频直播窗口时，考勤窗口、客流窗口、普通节目窗口
        let playType =
          oWindowInfo.PlayItemList && oWindowInfo.PlayItemList.length
            ? oWindowInfo.PlayItemList[0].PlayItem.playType
            : "";
        // 针对会议签到，特殊处理
        window.playType = playType;
        if (
          playType === "normal" &&
          vm &&
          vm.applicationType === "conference"
        ) {
          playType = "conference";
        }
        let imageWidth = template.Resolution
          ? template.Resolution.imageWidth
          : 0;
        let imageHeight = template.Resolution
          ? template.Resolution.imageHeight
          : 0;
        //这里面计算比例，看加载哪个背景图；因为横竖屏失真等问题，比较复杂
        if (playType === "faceAttendance") {
          let notSupportTemperature = !oUtils.getJsonDeepAttr(
            template,
            "TemperatureDetection"
          ); //是否支持测温
          let applicationType = notSupportTemperature
            ? "signIn"
            : "signInTemperature";
          if (
            screenType === "horizontal" ||
            (imageWidth && imageWidth >= imageHeight)
          ) {
            window.backgroundIPC =
              applicationType + "H" + Math.round(window.height / window.width);
          } else if (
            screenType === "vertical" ||
            (imageWidth && imageWidth < imageHeight)
          ) {
            window.backgroundIPC =
              applicationType + "V" + Math.round(window.width / window.height);
          }
        } else if (playType === "temperature") {
          if (
            screenType === "horizontal" ||
            (imageWidth && imageWidth >= imageHeight)
          ) {
            window.backgroundIPC =
              "temperatureH" + Math.round(window.height / window.width, 10);
          } else if (
            screenType === "vertical" ||
            (imageWidth && imageWidth < imageHeight)
          ) {
            window.backgroundIPC =
              "temperatureV" + Math.round(window.width / window.height, 10);
          }
        } else if (playType === "conference") {
          if (
            screenType === "horizontal" ||
            (imageWidth && imageWidth >= imageHeight)
          ) {
            window.backgroundIPC =
              "conferenceSignInH" +
              Math.round(window.height / window.width, 10);
          } else if (
            screenType === "vertical" ||
            (imageWidth && imageWidth < imageHeight)
          ) {
            window.backgroundIPC =
              "conferenceSignInV" +
              Math.round(window.width / window.height, 10);
          }
        } else {
          window.materialList = [];
          let playItems = oWindowInfo.PlayItemList || [];
          let types = [];

          // 微动效
          if (windowMode === "picture") {
            // 设备支持按素材配置 但是平台只能按窗口统一配
            if (
              playItems?.find(
                (item) => item?.PlayItem?.AnimationEffectList?.length
              )
            ) {
              window.AnimationEffectList = playItems.find(
                (item) => item?.PlayItem?.AnimationEffectList?.length
              ).PlayItem.AnimationEffectList;
            }
            window.borderRadius = oWindowInfo.filletedCornerDegree || 0; // 圆角
            window.rotate = oWindowInfo.rotateDegree || 0; // 旋转
          }

          for (let k = 0; k < playItems.length; k++) {
            // 打个标记，素材信息获取和初始化
            let materialItem = playItems[k].PlayItem;
            let material = {};
            let materialInfo = {};
            material.index = k + 1;
            material.windowId = window.windowId;
            material.materialId = materialItem.materialNo;

            windowMode = materialItem.itemMaterialType || windowMode; // 设置每种素材的类型，重新设置windowmode为了下面的判断

            material.materialType = windowMode;
            !types.includes(i18n.t(windowMode)) &&
              types.push(i18n.t(windowMode));
            if (screenType) {
              material.materialName = "mask";
              material.src = await oMaterialService.getMaterialThumbnail(
                material.materialId,
                windowMode
              );
            } else {
              material.materialDeleteFlag = !materialList.includes(material.materialId)
              materialInfo = await this.getMaterialById(material.materialId, material.materialDeleteFlag, materialInfoList);
              windowMode !== "realStream" &&
                (material.materialName = materialInfo.name);
              let materialType = windowMode;
              //特殊处理(urlPic)，素材显示url; liveVideo显示成IPC; 流媒体显示
              // if (materialInfo.dynamicMaterialType === "picUrl") {
              //   materialType = "picUrl";
              // } else if (materialInfo.dataType === "liveVideo") {
              //   materialType = "liveVideo";
              // } else if (materialInfo.destionType === "streamMedia") {
              //   materialType = "streamMedia";
              // }
              // material.src = material.materialDeleteFlag ? '' : oMaterialService.getMaterialThumbnail(
              material.src = oMaterialService.getMaterialThumbnail(
                // materialInfo.thumbnail,
                material.materialId,
                materialType,
                false
              );
              material.materialThumbnailUrl =
                oMaterialService.getMaterialThumbnail(
                  // materialInfo.thumbnail,
                  material.materialId,
                  materialType
                );
            }
            material.playTimeType = materialItem.PlayDuration
              ? materialItem.PlayDuration.durationType
              : ""; //播放时间类型
            material.materialTime = 0; //避免在编辑时，因为没定义该变量导致问题

            // 如果是网页无限时长，默认自定义素材时间
            if (materialItem?.PlayDuration?.durationType === "unlimited") {
              material.materialTime = 120;
            }

            "selfDefine" === material.playTimeType &&
              (material.materialTime = materialItem.PlayDuration.duration);

            // console.log("material", material);
            // console.log("materialItem", materialItem);
            // console.log("materialInfo", materialInfo);

            "materialTime" === material.playTimeType &&
              (material.materialTime =
                materialItem.PlayDuration.duration ||
                Number(materialInfo.duration || 0));

            if (["picture", "video"].includes(windowMode)) {
              material.scaleType = materialItem.scaleType === "fitCenter"; //是否等比例缩放
            }
            // 显示样式
            if (windowMode === "web") {
              material.webType = materialItem.WebProperty?.webType;
            }

            // 设置素材有效期 这里保存一个获取有效期时间的promise
            // if (["picture", "video", "pdf", "document"].includes(windowMode)) {
            //   if (!(material.materialId in this.materialValidyMap)) {
            //     this.materialValidyMap[material.materialId] =
            //       (materialInfo?.validityTime !== undefined &&
            //         Promise.resolve(materialInfo.validityTime)) ||
            //       this.getSingleMaterialvalidityTime(material.materialId);
            //   }
            // }
            switch (windowMode) {
              case "picture":
                material.switchEffect = materialItem.switchEffect; //图片类型：切换效果
                break;
              // case "document":
              //   material.fontSize = materialItem.CharactersEffect.fontSize; //字体大
              //   material.fontColor = oUtils.transformRgb(
              //     materialItem.CharactersEffect.FontColor.RGB
              //   );
              //   material.backgroundColor = oUtils.transformRgb(
              //     materialItem.CharactersEffect.BackColor.RGB
              //   ); //背景颜色
              //   material.backTransparent = Math.ceil(
              //     100 -
              //       (materialItem.CharactersEffect.backTransparent / 255) * 100
              //   ); // 背景透明度
              //   material.scrollDirection =
              //     materialItem.CharactersEffect.scrollDirection; //文字滚动方向
              //   material.scrollSpeed =
              //     materialItem.CharactersEffect.scrollSpeed; //滚动速度
              //   break;
              case "web":
                material.scrollSpeed = materialItem.scrollSpeed; //滚动速度
                break;
              case "pdf":
              case "ppt":
              case "doc":
              case "excel":
              case "document":
                material.pageTime = materialItem.pageTime; //页面时间
                break;
              case "realStream":
                material.inputChannel = materialItem.inputChannel; //通道id
                //判断是ipc还是媒体流
                if (material.inputChannel && material.inputChannel !== 0) {
                  material.materialName =
                    i18n.t("device_channel") + " " + material.inputChannel;
                  material.src = oMaterialService.getMaterialThumbnail(
                    material.materialId,
                    "IPC"
                  );
                } else {
                  material.materialName = materialInfo.name;
                }
                break;
              default:
                break;
            }
            // console.log("material", material);
            window.materialList.push(material);
          }

          if (window.materialList?.length) {
            // 设置默认展示的图片，默认第一张，混合窗口，默认第一个与windowmode相同的窗口
            const index = window.materialList.findIndex((material) => {
              return material.materialType === window.windowMode;
            });
            const material = window.materialList[index === -1 ? 0 : index];
            window.style = {
              background: "url(" + material.src + ") no-repeat",
              // "background-size": "100% 100%"
            };
            window.backgroundPicDeleteFlag = material.materialDeleteFlag
            if (material.materialDeleteFlag) {
              // 不设置none不会清除之前的背景
              window.style["background-image"] = "none";
            }
            if (!material.scaleType) {
              window.style["background-size"] = "100% 100%";
            } else {
              window.style["background-size"] = `contain`;
              window.style["background-position"] = "center";
            }
          }

          window.enabledAudio = oUtils.judgeExistTypes(window, [
            "video",
            "realStream",
          ])
            ? !oWindowInfo.enabledAudio
            : true; //关闭音频（web窗口enabledAudio意思为去音频，所以加!）
          types.length > 1 &&
            (window.windowName = window.windowId + "-" + types.join("/"));
        }
      }

      // 编辑时 考勤 logo、zimu、时间 window => 转换为 subwindow
      if (
        templateWindow.Windows?.windowApplication &&
        !templateWindow.Windows?.windowApplication?.includes("_templateid")
      ) {
        try {
          const signSubWindows = windowList[0].subWindows;
          const handleLogo = async () => {
            const subwindow = signSubWindows.filter(
              (item) => item.key === "signIn_logo"
            )[0];
            const icon = window.materialList[0].materialId;
            const iconName = await this.getBackgroundName(icon);
            const p = {
              enabled: true,
              x: window.x,
              y: window.y,
              height: window.height,
              width: window.width,
              icon,
              iconName,
            };

            Object.assign(subwindow, p);
          };

          const handleTime = () => {
            const subwindow = signSubWindows.filter(
              (item) => item.key === "signIn_time"
            )[0];
            const p = {
              enabled: true,
              x: window.x,
              y: window.y,
              height: window.height,
              width: window.width,
              text: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
            };

            Object.assign(subwindow, p);
          };

          const handleSubtitles = () => {
            const subwindow = signSubWindows.filter(
              (item) => item.key === "signIn_zimu"
            )[0];
            const p = {
              enabled: true,
              x: window.x,
              y: window.y,
              height: window.height,
              width: window.width,
              content: window.characterContent,
              rolling_direction: window.rollingDirection,
            };

            Object.assign(subwindow, p);
          };
          const attendanceMap = new Map([
            ["attendanceLogo", handleLogo],
            ["attendanceClock", handleTime],
            ["attendanceSubtitles", handleSubtitles],
          ]);
          await attendanceMap.get(templateWindow.Windows.windowApplication)();
        } catch (error) {
          console.log(error);
        }
        continue;
      }

      windowList.push(window);
    }
    return windowList;
  }

  //获取背景图片名称
  async getBackgroundName (backgroundPic) {
    let backgroundPicName = i18n.t("none");
    if (backgroundPic > 0) {
      let materialInfo = await this.getMaterialById(backgroundPic);
      backgroundPicName = materialInfo.name;
    }
    return backgroundPicName;
  }

  //根据素材id获取素材
  async getMaterialById (materialId, deleteFlag = false, materialInfoList = []) {
    return new Promise((resolve) => {
      if (!materialId) {
        /* materialId不存在不发起请求，但是不阻碍流程  */
        resolve({
          name: "",
          dynamicMaterialType: "",
          dataType: "",
          destionType: "",
        });
        return;
      }
      // 已删除的直接返回
      if (deleteFlag) {
        resolve({
          name: "",
          dynamicMaterialType: "",
          dataType: "",
          destionType: "",
          deleteFlag: true,
        })
        return
      }
      // 节目详情接口返回materialInfoList，可以直接从中获取素材详情
      if (materialInfoList.length) {
        // 如果存在materialInfoList，则直接从materialInfoList中获取
        const materialInfo = materialInfoList.find(
          (item) => item.materialId === materialId
        );
        if (materialInfo) {
          let materialName = materialInfo.fileName;
          let materialType = materialInfo.materialType;
          let materialFormat = materialInfo.materialFormat;
          let thumbnail = materialInfo.thumbnail;
          let duration = Number(materialInfo.duration || 0);
          let name = materialFormat
            ? materialName + materialFormat
            : materialName;
          resolve({
            name,
            thumbnail,
            duration,
            dynamicMaterialType: "",
            dataType: "",
            destionType: "",
            // validityTime,
            deleteFlag: false,
          });
          return;
        }
      }
      if (this.materialNameMap[materialId]) {
        resolve({
          ...this.materialNameMap[materialId],
        });
        return;
      }

      programApi
        .getMaterialDetail({ materialId })
        .then((resJson) => {
          // console.log("getMaterialDetail", resJson);
          if (resJson.code == 200) {
            let MaterialInfo = resJson.data;
            let materialName = MaterialInfo.fileName;
            let materialType = MaterialInfo.materialType;
            let materialFormat = MaterialInfo.materialFormat;
            let thumbnail = MaterialInfo.thumbnail;
            let duration = Number(MaterialInfo.duration || 0);
            let name = materialFormat
              ? materialName + materialFormat
              : materialName;
            this.materialNameMap[materialId] = {
              name,
              thumbnail,
              duration,
              dynamicMaterialType: "",
              dataType: "",
              destionType: "",
              // validityTime: "",
              deleteFlag: false,
            };

            resolve({
              name,
              thumbnail,
              duration,
              dynamicMaterialType: "",
              dataType: "",
              destionType: "",
              // validityTime,
              deleteFlag: false,
            });
          } else if (resJson.code == "C001") {
            // 素材不存在
            resolve({
              name: "",
              dynamicMaterialType: "",
              dataType: "",
              destionType: "",
              deleteFlag: true,
            });
          } else {
            resolve({
              name: "",
              dynamicMaterialType: "",
              dataType: "",
              destionType: "",
            });
          }
        })
        .catch((e) => {
          console.log("getMaterialById", e);
          resolve({
            name: "",
            dynamicMaterialType: "",
            dataType: "",
            destionType: "",
          });
        });
      // oWebSdk.WSDK_GetDeviceConfig(
      //   "operateSingleMaterial",
      //   {
      //     id: materialId,
      //   },
      //   {
      //     showLoading: true,
      //     success: (resJson) => {
      //       let MaterialInfo = resJson.Material;
      //       let materialName = MaterialInfo.materialName;
      //       let materialType = MaterialInfo.materialType;
      //       let dynamicMaterialType = MaterialInfo.DynamicMaterial
      //         ? MaterialInfo.DynamicMaterial.dynamicMaterialType
      //         : "";
      //       let dataType = "";
      //       let destionType = "";
      //       if (MaterialInfo.DynamicMaterial) {
      //         dataType = MaterialInfo.DynamicMaterial.RealStream
      //           ? MaterialInfo.DynamicMaterial.RealStream.dataType
      //           : "";
      //         destionType = MaterialInfo.DynamicMaterial.RealStream
      //           ? MaterialInfo.DynamicMaterial.RealStream.destionType
      //           : "";
      //       }
      //       let materialFormat = "";
      //       /* TODO materialType
      //     materialType === "static" && (materialFormat = $(xmlDoc).find("staticMaterialType").next().text()); */
      //       //materialType === "static" && (materialFormat = MaterialInfo.StaticMaterial.staticMaterialType || MaterialInfo.StaticMaterial.staticMaterialType);
      //       //获取静态素材的格式
      //       if (materialType === "static") {
      //         let StaticMaterial = MaterialInfo.StaticMaterial;
      //         //Format
      //         for (let i in StaticMaterial) {
      //           if (i.indexOf("Format") > 0) {
      //             materialFormat = StaticMaterial[i];
      //           }
      //         }
      //       }
      //       let name = materialFormat
      //         ? materialName + "." + materialFormat
      //         : materialName;
      //       //素材有效期时间
      //       let { enable, beginTime, endTime } =
      //         resJson.Material?.Validity ?? {};
      //       beginTime =
      //         beginTime ||
      //         `${new Date().getFullYear()}/${
      //           new Date().getMonth() + 1
      //         }/${new Date().getDate()} 00:00:00`;
      //       endTime =
      //         endTime ||
      //         `${new Date().getFullYear()}/${
      //           new Date().getMonth() + 1
      //         }/${new Date().getDate()} 23:59:59`;
      //       let validityTime = "";
      //       if (isSupportValidityBeginTimeCap) {
      //         validityTime = enable
      //           ? `${moment(beginTime).format("YYYY/MM/DD HH:mm:ss")}-${moment(
      //               endTime
      //             ).format("YYYY/MM/DD HH:mm:ss")}`
      //           : "";
      //       } else {
      //         validityTime = enable
      //           ? `${moment(endTime).format("YYYY/MM/DD HH:mm:ss")}`
      //           : "";
      //       }

      //       this.materialNameMap[materialId] = {
      //         name,
      //         dynamicMaterialType,
      //         dataType,
      //         destionType,
      //         validityTime,
      //       };

      //       resolve({
      //         name,
      //         dynamicMaterialType,
      //         dataType,
      //         destionType,
      //         validityTime,
      //       });
      //     },
      //     errorResponse: () => {
      //       resolve({
      //         name: "",
      //         dynamicMaterialType: "",
      //         dataType: "",
      //         destionType: "",
      //       });
      //       return false;
      //     },
      //     error: () => {
      //       resolve({
      //         name: "",
      //         dynamicMaterialType: "",
      //         dataType: "",
      //         destionType: "",
      //       });
      //     },
      //   }
      // );
    });
  }

  //编辑处理布局模板
  //flag为true直接返回区域信息
  getLayoutWindow (list, program, flag) {
    list = list.map((item) => {
      return {
        id: item.TemplateLayoutWindow.id,
        x: item.TemplateLayoutWindow.Position.positionX,
        y: item.TemplateLayoutWindow.Position.positionY,
        height: item.TemplateLayoutWindow.Position.height,
        width: item.TemplateLayoutWindow.Position.width,
      };
    });
    if (flag) {
      return list;
    }
    return this.transformLayoutWindow(
      list,
      program.Resolution.imageWidth,
      program.Resolution.imageHeight
    );
  }

  //照搬getter中对每个页面的处理
  getAreaInfo (program, list) {
    //获取相关横线、竖线
    const { programHeight, programWidth } = program;
    let rowLine = [{ x: 0, y: 0, w: programWidth }];
    let colLine = [{ x: 0, y: 0, h: programHeight }];
    let layout = list || [];
    layout.forEach((item) => {
      if (item.width === 1) {
        colLine.push({ x: item.x, y: item.y, h: item.height });
      }
      if (item.height === 1) {
        rowLine.push({ x: item.x, y: item.y, w: item.width });
      }
    });
    rowLine.push({ x: 0, y: programHeight, w: programWidth });
    colLine.push({ x: programWidth, y: 0, h: programHeight });
    //从小到大排序
    rowLine.sort((a, b) => {
      return a.y - b.y;
    });
    colLine.sort((a, b) => {
      return a.x - b.x;
    });
    let res = [];
    //从上到下,左到右生成区域信息
    for (let i = 0; i < colLine.length - 1; i++) {
      let smallRow = ""; //记录当前最小行，和下一个大行形成一块区域
      for (let j = 0; j < rowLine.length; j++) {
        const lineItem = colLine[i];
        const rowItem = rowLine[j];
        // const bigRowItem = rowLine[j + 1];
        // 寻找穿过竖线的横线来拼成一个区域
        //第一次符合条件是上面那条
        //第二次符合条件 就可以组成一个区域
        const xFlag =
          lineItem.x === rowItem.x ||
          (lineItem.x > rowItem.x && rowItem.x + rowItem.w > lineItem.x); // 保证横线穿过竖线
        const yFlag =
          rowItem.y === lineItem.y ||
          (rowItem.y > lineItem.y && rowItem.y <= lineItem.y + lineItem.h); //保证横线在竖线范围内
        if (xFlag && yFlag) {
          if (!smallRow) {
            smallRow = rowItem;
          } else {
            let bigLineItem = "";
            //找到竖线右边第一个符合条件的竖线
            // eslint-disable-next-line no-loop-func
            colLine.some((col, index) => {
              if (
                index > i &&
                smallRow.y >= col.y &&
                smallRow.y <= col.y + col.h &&
                rowItem.y >= col.y &&
                rowItem.y <= col.y + col.h
              ) {
                bigLineItem = col;
                return true;
              }
              return false;
            });
            //到这步应该是出错了，这里做个兼容
            if (!bigLineItem) {
              console.error("错误啦");
              bigLineItem = colLine[i + 1];
            }
            res.push({
              x: lineItem.x,
              y: smallRow.y,
              height: rowItem.y - smallRow.y,
              width: bigLineItem.x - lineItem.x,
              id: res.length,
            });
            smallRow = rowItem;
          }
        }
      }
    }
    //上传时转换为1920*1920
    const coordinateValue = 1920; //基准坐标 保存时要在转换为 1920 * 1920
    res.forEach((w) => {
      w.x = Math.round(
        Number.parseFloat((w.x * coordinateValue) / programWidth, 2)
      );
      w.y = Math.round(
        Number.parseFloat((w.y * coordinateValue) / programHeight, 2)
      );
      w.height = Math.round(
        Number.parseFloat((w.height * coordinateValue) / programHeight, 2)
      );
      w.width = Math.round(
        Number.parseFloat((w.width * coordinateValue) / programWidth, 2)
      );
    });
    //精度调整，保证区域重叠
    let ynum = 0;
    let xnum = 0;
    res.forEach((w, i) => {
      //相同列且不是最后一个
      if (i < res.length - 1 && w.x === res[i + 1].x) {
        res[i + 1].y = w.y + w.height;
        ynum += w.height;
      } else if (i < res.length - 1 && w.x !== res[i + 1].x) {
        //相同列，最后一个
        res[i].height = coordinateValue - ynum;
        // ynum = 0;
        //x轴数据处理
        xnum =
          w.x + w.width === coordinateValue
            ? res[i - 1].x + res[i - 1].width
            : w.x + w.width; //@123
        const bigX = res[i + 1].x;
        res.forEach((w1, i1) => {
          if (w1.x === bigX) {
            ynum = Math.min(w1.y, ynum);
            // w1.x = xnum;
            res[i1].x = xnum; //保证数组真正被修改
          }
        });
      } else if (i === res.length - 1) {
        //  |
        // -- 这种模板保存时特殊处理一下 @123
        if (ynum === 0 && res[i - 1].width === coordinateValue) {
          ynum = res[i - 1].height;
        }
        res[i].height = coordinateValue - ynum;
        res.forEach((w1, i1) => {
          if (w1.x === xnum) {
            res[i1].width = coordinateValue - xnum;
          }
        });
      }
    });
    console.error(res);
    return res;
  }

  // 国家天气码
  async getWeatherAreaIdList (isPro) {
    // let resJson = await oWebSdk.WSDK_GetDeviceConfig(
    //   "getWeatherAreaIdList",
    //   null,
    //   {
    //     errorResponse: () => {
    //       return false;
    //     }
    //   }
    // );
    // TODO 暂时使用静态数据, 后期需要从后端获取
    let resJson = { "CountryList": [{ "countryId": "45", "countryLanguageKey": "China", "countryAbbreviation": "CN" }] }
    return Promise.resolve(resJson?.CountryList?.map(item => {
      return {
        label: i18n.t(item.countryLanguageKey),
        value: item.countryId,
        Abbreviation: item.countryAbbreviation
      };
    })?.sort(function (s1, s2) {
      if (isPro) {
        return s1.label.localeCompare(s2.label, 'ch');
      }
      let a1 = s1.label.toUpperCase();
      let a2 = s2.label.toUpperCase();
      if (a1 < a2) {
        return -1;
      }
      if (a1 > a2) {
        return 1;
      }
      return 0;
    }) ?? []);
  }

  // 根据国家获取天气城市码
  async getWeatherCityIdList (params, isPro) {
    let resJson = await programApi.listCityInfo(params);
    return Promise.resolve(resJson?.data?.map(item => {
      return {
        label: item.cityName,
        // label: i18n.t(item.cityLanguageKey),
        value: item.cityId
      };
    })?.sort(function (s1, s2) {
      if (isPro) {
        return s1.label.localeCompare(s2.label, 'ch');
      }
      let a1 = s1.label.toUpperCase();
      let a2 = s2.label.toUpperCase();
      if (a1 < a2) {
        return -1;
      }
      if (a1 > a2) {
        return 1;
      }
      return 0;
    }) ?? []);
  }

  // 根据国家获取天气城市码
  async getCityInfo (params, isPro) {
    let resJson = await programApi.getCityInfo(params);
    return Promise.resolve(resJson?.data?.map(item => {
      return {
        label: item.name,
        // label: i18n.t(item.cityLanguageKey),
        value: item.id,
        leaf: !!item.cityId,
        cityId: item.cityId
      };
    })?.sort(function (s1, s2) {
      if (params.languageCode == 'CN') {
        // return s1.label.localeCompare(s2.label, 'ch');
        return 1
      }
      let a1 = s1.label.toUpperCase();
      let a2 = s2.label.toUpperCase();
      if (a1 < a2) {
        return -1;
      }
      if (a1 > a2) {
        return 1;
      }
      return 0;
    }) ?? []);
  }

  // 根据城市码获取天气数据
  async getWeatherData (data, showLoading) {
    // let resJson = await oWebSdk.WSDK_GetDeviceConfig(
    //   "getWeatherData",
    //   null,
    //   {
    //     data,
    //     showLoading,
    //     errorResponse: data => {
    //       if ([111958].includes(data.ErrorCode)) {
    //         this?.m?.close?.();
    //         this.m = oResponse.showTips(i18n.t("hcp_focsign_weather_data_fail").replace("%s", i18n.t(`error_${data.ErrorModule}_${data.ErrorCode}`)));
    //         return false;
    //       }
    //     }
    //   }
    // );
    let resJson = await programApi.getWeatherInfo(data)
    return Promise.resolve(resJson?.data ?? {});
  }

  // 替换天气窗口的相关数据
  repaceWeatherDataInWindow (id, window, showLoading = false) {
    eventBus.$emit('focSign_weather_data_refresh', {
      enable: true,
      windowId: window.windowId
    });
    return new Promise((resolve) => {
      this.getWeatherData({
        type: window.weatherShowType,
        cityId: id
        // cityCode: id
      }, showLoading).then((res) => {
        eventBus.$emit('focSign_weather_data_refresh', {
          enable: false,
          windowId: window.id
        });
        const list = res ?? [];

        for (let i = 0; i < list.length; i++) {
          const subWindows = window.subWindows.filter(item => item.moduleType === i);
          const data = list[i];
          for (let j = 0; j < subWindows.length; j++) {
            const subWindow = subWindows[j];
            switch (subWindow.type) {
              case "currentTemperature":
              case "highestTemperature":
              case "lowestTemperature":
                // eslint-disable-next-line no-case-declarations
                const value = window.timeUnit === "fahrenheit" ? Math.floor(data[subWindow.type] * 1.8 + 32) : data[subWindow.type];
                subWindow.content = value + (window.timeUnit === "fahrenheit" ? "°F" : "℃");
                subWindow.originValue = data[subWindow.type];
                break;
              case "humidity":
                subWindow.content = i18n.t("program_humidity").replace("%s", data[subWindow.type]);
                break;
              case "weatherContent":
                subWindow.content = i18n.t("program_weatherCondition_" + data["weatherCondition"]);
                break;
              case "wind":
                subWindow.content = i18n.t("program_wind").replace("%s", (+data["windSpeed"]).toFixed(1));
                break;
              case "updateTime":
                subWindow.content = window.updateInterval >= 60 ? (i18n.t(`program_hours`).replace('%d', Math.round(window.updateInterval / 60))) : (i18n.t(`program_minutes`).replace('%d', window.updateInterval));
                break;
              case "city":
                subWindow.enable = true;
                subWindow.content = subWindow.cityName;
                break;
              case "cityIcon":
                subWindow.enable = true;
                break;
              case "date":
                if (i === 0) {
                  const language = Storage.get(Storage.NAME.LANGUAGE) === "zh" ? "zh-cn" : "en";
                  // moment.defineLocale('zh-cn', {
                  //   meridiem: function (hour, minute) {
                  //     var hm = hour * 100 + minute;
                  //     if (hm <= 1200) {
                  //       return i18n.t('program_am');
                  //     }
                  //     return i18n.t('program_pm');
                  //   }
                  // });
                  subWindow.content = moment(data[subWindow.type] ? data[subWindow.type] : new Date()).add(data[subWindow.type] ? 0 : i, "day").locale(language).format(
                    constant.DATA_FORMATE[window.dateShowType]
                  );
                } else {
                  const language = Storage.get(Storage.NAME.LANGUAGE) === "zh" ? "zh-cn" : "en";
                  subWindow.content = moment(data[subWindow.type] ? data[subWindow.type] : new Date()).add(data[subWindow.type] ? 0 : i, "day").locale(language).format(
                    "dddd"
                  );
                }

                subWindow.originValue = moment(data[subWindow.type] ? data[subWindow.type] : new Date());
                break;
              case "source":
                subWindow.content = res.weatherSource || "xxxxx";
                break;
              case "weatherIcon":
                subWindow.content = data["weatherCondition"] + "";
                break;
              default:
                break;
            }
          }
        }
        resolve();
      });
    });
  }
}

let programService = new ProgramService();
export default programService;
